/* eslint-disable max-lines */
export const ReadingTypes = ["fvc", "fev1", "fev1FvcRatio"] as const;
export type ReadingType = (typeof ReadingTypes)[number];

export const Ethnicities = ["Caucasian", "African American", "South East Asian",  "North East Asian",  "Other"] as const;
export type Ethnicity = (typeof Ethnicities)[number];

export const Genders = ["Male", "Female"] as const;
export type Gender = (typeof Genders)[number];

export const ReasonsForAttending = ["Baseline screen", "Routine surveillance", "Repeat test for previous anomaly"] as const;
export type ReasonForAttending = (typeof ReasonsForAttending)[number];

type LookupTableGenderEthnicityEntry = Record<ReadingType, LookupTableAgeEntry[]> & {
    ethnicity: Ethnicity;
    gender: Gender;
}

type LookupTableAgeEntry = {
    age: number;
    values: LookupTableHeightEntry[];
}

type LookupTableHeightEntry = {
    height: number;
    value: number;
}

export const spirometryLookupTable: LookupTableGenderEthnicityEntry[] = [
    {
        ethnicity: "Caucasian",
        gender: "Male",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.56
                    },
                    {
                        height: 130,
                        value: 1.82
                    },
                    {
                        height: 137,
                        value: 2.07
                    },
                    {
                        height: 145,
                        value: 2.37
                    },
                    {
                        height: 152,
                        value: 2.66
                    },
                    {
                        height: 160,
                        value: 3.01
                    },
                    {
                        height: 168,
                        value: 3.38
                    },
                    {
                        height: 175,
                        value: 3.73
                    },
                    {
                        height: 183,
                        value: 4.16
                    },
                    {
                        height: 191,
                        value: 4.61
                    },
                    {
                        height: 198,
                        value: 5.03
                    },
                    {
                        height: 206,
                        value: 5.53
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.69
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.23
                    },
                    {
                        height: 145,
                        value: 2.56
                    },
                    {
                        height: 152,
                        value: 2.87
                    },
                    {
                        height: 160,
                        value: 3.25
                    },
                    {
                        height: 168,
                        value: 3.65
                    },
                    {
                        height: 175,
                        value: 4.03
                    },
                    {
                        height: 183,
                        value: 4.49
                    },
                    {
                        height: 191,
                        value: 4.98
                    },
                    {
                        height: 198,
                        value: 5.43
                    },
                    {
                        height: 206,
                        value: 5.98
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.95
                    },
                    {
                        height: 130,
                        value: 2.28
                    },
                    {
                        height: 137,
                        value: 2.59
                    },
                    {
                        height: 145,
                        value: 2.96
                    },
                    {
                        height: 152,
                        value: 3.32
                    },
                    {
                        height: 160,
                        value: 3.76
                    },
                    {
                        height: 168,
                        value: 4.23
                    },
                    {
                        height: 175,
                        value: 4.67
                    },
                    {
                        height: 183,
                        value: 5.2
                    },
                    {
                        height: 191,
                        value: 5.76
                    },
                    {
                        height: 198,
                        value: 6.29
                    },
                    {
                        height: 206,
                        value: 6.92
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 2.21
                    },
                    {
                        height: 130,
                        value: 2.58
                    },
                    {
                        height: 137,
                        value: 2.92
                    },
                    {
                        height: 145,
                        value: 3.35
                    },
                    {
                        height: 152,
                        value: 3.76
                    },
                    {
                        height: 160,
                        value: 4.25
                    },
                    {
                        height: 168,
                        value: 4.78
                    },
                    {
                        height: 175,
                        value: 5.28
                    },
                    {
                        height: 183,
                        value: 5.88
                    },
                    {
                        height: 191,
                        value: 6.52
                    },
                    {
                        height: 198,
                        value: 7.11
                    },
                    {
                        height: 206,
                        value: 7.82
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 2.23
                    },
                    {
                        height: 130,
                        value: 2.6
                    },
                    {
                        height: 137,
                        value: 2.95
                    },
                    {
                        height: 145,
                        value: 3.38
                    },
                    {
                        height: 152,
                        value: 3.79
                    },
                    {
                        height: 160,
                        value: 4.29
                    },
                    {
                        height: 168,
                        value: 4.83
                    },
                    {
                        height: 175,
                        value: 5.33
                    },
                    {
                        height: 183,
                        value: 5.93
                    },
                    {
                        height: 191,
                        value: 6.58
                    },
                    {
                        height: 198,
                        value: 7.18
                    },
                    {
                        height: 206,
                        value: 7.9
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 2.2
                    },
                    {
                        height: 130,
                        value: 2.56
                    },
                    {
                        height: 137,
                        value: 2.9
                    },
                    {
                        height: 145,
                        value: 3.33
                    },
                    {
                        height: 152,
                        value: 3.73
                    },
                    {
                        height: 160,
                        value: 4.22
                    },
                    {
                        height: 168,
                        value: 4.75
                    },
                    {
                        height: 175,
                        value: 5.24
                    },
                    {
                        height: 183,
                        value: 5.84
                    },
                    {
                        height: 191,
                        value: 6.48
                    },
                    {
                        height: 198,
                        value: 7.07
                    },
                    {
                        height: 206,
                        value: 7.77
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 2.16
                    },
                    {
                        height: 130,
                        value: 2.51
                    },
                    {
                        height: 137,
                        value: 2.85
                    },
                    {
                        height: 145,
                        value: 3.27
                    },
                    {
                        height: 152,
                        value: 3.67
                    },
                    {
                        height: 160,
                        value: 4.15
                    },
                    {
                        height: 168,
                        value: 4.67
                    },
                    {
                        height: 175,
                        value: 5.15
                    },
                    {
                        height: 183,
                        value: 5.74
                    },
                    {
                        height: 191,
                        value: 6.36
                    },
                    {
                        height: 198,
                        value: 6.94
                    },
                    {
                        height: 206,
                        value: 7.64
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 2.12
                    },
                    {
                        height: 130,
                        value: 2.47
                    },
                    {
                        height: 137,
                        value: 2.8
                    },
                    {
                        height: 145,
                        value: 3.21
                    },
                    {
                        height: 152,
                        value: 3.6
                    },
                    {
                        height: 160,
                        value: 4.07
                    },
                    {
                        height: 168,
                        value: 4.58
                    },
                    {
                        height: 175,
                        value: 5.05
                    },
                    {
                        height: 183,
                        value: 5.63
                    },
                    {
                        height: 191,
                        value: 6.24
                    },
                    {
                        height: 198,
                        value: 6.81
                    },
                    {
                        height: 206,
                        value: 7.49
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 2.07
                    },
                    {
                        height: 130,
                        value: 2.41
                    },
                    {
                        height: 137,
                        value: 2.73
                    },
                    {
                        height: 145,
                        value: 3.14
                    },
                    {
                        height: 152,
                        value: 3.51
                    },
                    {
                        height: 160,
                        value: 3.98
                    },
                    {
                        height: 168,
                        value: 4.47
                    },
                    {
                        height: 175,
                        value: 4.94
                    },
                    {
                        height: 183,
                        value: 5.5
                    },
                    {
                        height: 191,
                        value: 6.1
                    },
                    {
                        height: 198,
                        value: 6.65
                    },
                    {
                        height: 206,
                        value: 7.32
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 2.01
                    },
                    {
                        height: 130,
                        value: 2.34
                    },
                    {
                        height: 137,
                        value: 2.66
                    },
                    {
                        height: 145,
                        value: 3.05
                    },
                    {
                        height: 152,
                        value: 3.42
                    },
                    {
                        height: 160,
                        value: 3.87
                    },
                    {
                        height: 168,
                        value: 4.35
                    },
                    {
                        height: 175,
                        value: 4.8
                    },
                    {
                        height: 183,
                        value: 5.35
                    },
                    {
                        height: 191,
                        value: 5.93
                    },
                    {
                        height: 198,
                        value: 6.47
                    },
                    {
                        height: 206,
                        value: 7.12
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.94
                    },
                    {
                        height: 130,
                        value: 2.27
                    },
                    {
                        height: 137,
                        value: 2.57
                    },
                    {
                        height: 145,
                        value: 2.95
                    },
                    {
                        height: 152,
                        value: 3.31
                    },
                    {
                        height: 160,
                        value: 3.74
                    },
                    {
                        height: 168,
                        value: 4.21
                    },
                    {
                        height: 175,
                        value: 4.65
                    },
                    {
                        height: 183,
                        value: 5.17
                    },
                    {
                        height: 191,
                        value: 5.74
                    },
                    {
                        height: 198,
                        value: 6.26
                    },
                    {
                        height: 206,
                        value: 6.89
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.18
                    },
                    {
                        height: 137,
                        value: 2.47
                    },
                    {
                        height: 145,
                        value: 2.84
                    },
                    {
                        height: 152,
                        value: 3.18
                    },
                    {
                        height: 160,
                        value: 3.6
                    },
                    {
                        height: 168,
                        value: 4.05
                    },
                    {
                        height: 175,
                        value: 4.47
                    },
                    {
                        height: 183,
                        value: 4.98
                    },
                    {
                        height: 191,
                        value: 5.52
                    },
                    {
                        height: 198,
                        value: 6.02
                    },
                    {
                        height: 206,
                        value: 6.62
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.09
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.72
                    },
                    {
                        height: 152,
                        value: 3.04
                    },
                    {
                        height: 160,
                        value: 3.45
                    },
                    {
                        height: 168,
                        value: 3.88
                    },
                    {
                        height: 175,
                        value: 4.28
                    },
                    {
                        height: 183,
                        value: 4.77
                    },
                    {
                        height: 191,
                        value: 5.28
                    },
                    {
                        height: 198,
                        value: 5.76
                    },
                    {
                        height: 206,
                        value: 6.34
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.71
                    },
                    {
                        height: 130,
                        value: 2
                    },
                    {
                        height: 137,
                        value: 2.27
                    },
                    {
                        height: 145,
                        value: 2.6
                    },
                    {
                        height: 152,
                        value: 2.91
                    },
                    {
                        height: 160,
                        value: 3.3
                    },
                    {
                        height: 168,
                        value: 3.71
                    },
                    {
                        height: 175,
                        value: 4.09
                    },
                    {
                        height: 183,
                        value: 4.56
                    },
                    {
                        height: 191,
                        value: 5.05
                    },
                    {
                        height: 198,
                        value: 5.51
                    },
                    {
                        height: 206,
                        value: 6.06
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.64
                    },
                    {
                        height: 130,
                        value: 1.91
                    },
                    {
                        height: 137,
                        value: 2.17
                    },
                    {
                        height: 145,
                        value: 2.48
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.15
                    },
                    {
                        height: 168,
                        value: 3.54
                    },
                    {
                        height: 175,
                        value: 3.91
                    },
                    {
                        height: 183,
                        value: 4.36
                    },
                    {
                        height: 191,
                        value: 4.83
                    },
                    {
                        height: 198,
                        value: 5.27
                    },
                    {
                        height: 206,
                        value: 5.8
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.57
                    },
                    {
                        height: 130,
                        value: 1.83
                    },
                    {
                        height: 137,
                        value: 2.07
                    },
                    {
                        height: 145,
                        value: 2.38
                    },
                    {
                        height: 152,
                        value: 2.67
                    },
                    {
                        height: 160,
                        value: 3.02
                    },
                    {
                        height: 168,
                        value: 3.39
                    },
                    {
                        height: 175,
                        value: 3.75
                    },
                    {
                        height: 183,
                        value: 4.17
                    },
                    {
                        height: 191,
                        value: 4.63
                    },
                    {
                        height: 198,
                        value: 5.05
                    },
                    {
                        height: 206,
                        value: 5.55
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.75
                    },
                    {
                        height: 137,
                        value: 1.99
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.56
                    },
                    {
                        height: 160,
                        value: 2.89
                    },
                    {
                        height: 168,
                        value: 3.26
                    },
                    {
                        height: 175,
                        value: 3.59
                    },
                    {
                        height: 183,
                        value: 4
                    },
                    {
                        height: 191,
                        value: 4.44
                    },
                    {
                        height: 198,
                        value: 4.84
                    },
                    {
                        height: 206,
                        value: 5.33
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.69
                    },
                    {
                        height: 137,
                        value: 1.91
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.46
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.13
                    },
                    {
                        height: 175,
                        value: 3.46
                    },
                    {
                        height: 183,
                        value: 3.85
                    },
                    {
                        height: 191,
                        value: 4.27
                    },
                    {
                        height: 198,
                        value: 4.65
                    },
                    {
                        height: 206,
                        value: 5.12
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.37
                    },
                    {
                        height: 160,
                        value: 2.68
                    },
                    {
                        height: 168,
                        value: 3.02
                    },
                    {
                        height: 175,
                        value: 3.33
                    },
                    {
                        height: 183,
                        value: 3.71
                    },
                    {
                        height: 191,
                        value: 4.11
                    },
                    {
                        height: 198,
                        value: 4.49
                    },
                    {
                        height: 206,
                        value: 4.94
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.4
                    },
                    {
                        height: 130,
                        value: 1.61
                    },
                    {
                        height: 137,
                        value: 1.81
                    },
                    {
                        height: 145,
                        value: 2.06
                    },
                    {
                        height: 152,
                        value: 2.28
                    },
                    {
                        height: 160,
                        value: 2.56
                    },
                    {
                        height: 168,
                        value: 2.85
                    },
                    {
                        height: 175,
                        value: 3.12
                    },
                    {
                        height: 183,
                        value: 3.45
                    },
                    {
                        height: 191,
                        value: 3.79
                    },
                    {
                        height: 198,
                        value: 4.11
                    },
                    {
                        height: 206,
                        value: 4.49
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.49
                    },
                    {
                        height: 130,
                        value: 1.71
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.18
                    },
                    {
                        height: 152,
                        value: 2.43
                    },
                    {
                        height: 160,
                        value: 2.72
                    },
                    {
                        height: 168,
                        value: 3.03
                    },
                    {
                        height: 175,
                        value: 3.32
                    },
                    {
                        height: 183,
                        value: 3.66
                    },
                    {
                        height: 191,
                        value: 4.03
                    },
                    {
                        height: 198,
                        value: 4.36
                    },
                    {
                        height: 206,
                        value: 4.76
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.06
                    },
                    {
                        height: 137,
                        value: 2.32
                    },
                    {
                        height: 145,
                        value: 2.63
                    },
                    {
                        height: 152,
                        value: 2.92
                    },
                    {
                        height: 160,
                        value: 3.27
                    },
                    {
                        height: 168,
                        value: 3.65
                    },
                    {
                        height: 175,
                        value: 3.99
                    },
                    {
                        height: 183,
                        value: 4.41
                    },
                    {
                        height: 191,
                        value: 4.85
                    },
                    {
                        height: 198,
                        value: 5.25
                    },
                    {
                        height: 206,
                        value: 5.73
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 2.02
                    },
                    {
                        height: 130,
                        value: 2.32
                    },
                    {
                        height: 137,
                        value: 2.61
                    },
                    {
                        height: 145,
                        value: 2.96
                    },
                    {
                        height: 152,
                        value: 3.28
                    },
                    {
                        height: 160,
                        value: 3.68
                    },
                    {
                        height: 168,
                        value: 4.1
                    },
                    {
                        height: 175,
                        value: 4.49
                    },
                    {
                        height: 183,
                        value: 4.96
                    },
                    {
                        height: 191,
                        value: 5.45
                    },
                    {
                        height: 198,
                        value: 5.91
                    },
                    {
                        height: 206,
                        value: 6.45
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 2.01
                    },
                    {
                        height: 130,
                        value: 2.31
                    },
                    {
                        height: 137,
                        value: 2.59
                    },
                    {
                        height: 145,
                        value: 2.94
                    },
                    {
                        height: 152,
                        value: 3.27
                    },
                    {
                        height: 160,
                        value: 3.66
                    },
                    {
                        height: 168,
                        value: 4.08
                    },
                    {
                        height: 175,
                        value: 4.47
                    },
                    {
                        height: 183,
                        value: 4.93
                    },
                    {
                        height: 191,
                        value: 5.42
                    },
                    {
                        height: 198,
                        value: 5.87
                    },
                    {
                        height: 206,
                        value: 6.41
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.95
                    },
                    {
                        height: 130,
                        value: 2.24
                    },
                    {
                        height: 137,
                        value: 2.52
                    },
                    {
                        height: 145,
                        value: 2.85
                    },
                    {
                        height: 152,
                        value: 3.17
                    },
                    {
                        height: 160,
                        value: 3.55
                    },
                    {
                        height: 168,
                        value: 3.96
                    },
                    {
                        height: 175,
                        value: 4.33
                    },
                    {
                        height: 183,
                        value: 4.79
                    },
                    {
                        height: 191,
                        value: 5.26
                    },
                    {
                        height: 198,
                        value: 5.7
                    },
                    {
                        height: 206,
                        value: 6.22
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.89
                    },
                    {
                        height: 130,
                        value: 2.18
                    },
                    {
                        height: 137,
                        value: 2.45
                    },
                    {
                        height: 145,
                        value: 2.77
                    },
                    {
                        height: 152,
                        value: 3.08
                    },
                    {
                        height: 160,
                        value: 3.45
                    },
                    {
                        height: 168,
                        value: 3.85
                    },
                    {
                        height: 175,
                        value: 4.21
                    },
                    {
                        height: 183,
                        value: 4.65
                    },
                    {
                        height: 191,
                        value: 5.11
                    },
                    {
                        height: 198,
                        value: 5.54
                    },
                    {
                        height: 206,
                        value: 6.05
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.83
                    },
                    {
                        height: 130,
                        value: 2.11
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.69
                    },
                    {
                        height: 152,
                        value: 2.98
                    },
                    {
                        height: 160,
                        value: 3.34
                    },
                    {
                        height: 168,
                        value: 3.72
                    },
                    {
                        height: 175,
                        value: 4.08
                    },
                    {
                        height: 183,
                        value: 4.5
                    },
                    {
                        height: 191,
                        value: 4.95
                    },
                    {
                        height: 198,
                        value: 5.36
                    },
                    {
                        height: 206,
                        value: 5.86
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.77
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.29
                    },
                    {
                        height: 145,
                        value: 2.59
                    },
                    {
                        height: 152,
                        value: 2.88
                    },
                    {
                        height: 160,
                        value: 3.23
                    },
                    {
                        height: 168,
                        value: 3.6
                    },
                    {
                        height: 175,
                        value: 3.94
                    },
                    {
                        height: 183,
                        value: 4.35
                    },
                    {
                        height: 191,
                        value: 4.78
                    },
                    {
                        height: 198,
                        value: 5.18
                    },
                    {
                        height: 206,
                        value: 5.65
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.96
                    },
                    {
                        height: 137,
                        value: 2.2
                    },
                    {
                        height: 145,
                        value: 2.5
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.11
                    },
                    {
                        height: 168,
                        value: 3.47
                    },
                    {
                        height: 175,
                        value: 3.8
                    },
                    {
                        height: 183,
                        value: 4.19
                    },
                    {
                        height: 191,
                        value: 4.61
                    },
                    {
                        height: 198,
                        value: 4.99
                    },
                    {
                        height: 206,
                        value: 5.45
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.63
                    },
                    {
                        height: 130,
                        value: 1.88
                    },
                    {
                        height: 137,
                        value: 2.11
                    },
                    {
                        height: 145,
                        value: 2.4
                    },
                    {
                        height: 152,
                        value: 2.66
                    },
                    {
                        height: 160,
                        value: 2.98
                    },
                    {
                        height: 168,
                        value: 3.32
                    },
                    {
                        height: 175,
                        value: 3.64
                    },
                    {
                        height: 183,
                        value: 4.02
                    },
                    {
                        height: 191,
                        value: 4.42
                    },
                    {
                        height: 198,
                        value: 4.79
                    },
                    {
                        height: 206,
                        value: 5.23
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.56
                    },
                    {
                        height: 130,
                        value: 1.79
                    },
                    {
                        height: 137,
                        value: 2.01
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.53
                    },
                    {
                        height: 160,
                        value: 2.84
                    },
                    {
                        height: 168,
                        value: 3.16
                    },
                    {
                        height: 175,
                        value: 3.46
                    },
                    {
                        height: 183,
                        value: 3.83
                    },
                    {
                        height: 191,
                        value: 4.21
                    },
                    {
                        height: 198,
                        value: 4.56
                    },
                    {
                        height: 206,
                        value: 4.98
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.47
                    },
                    {
                        height: 130,
                        value: 1.7
                    },
                    {
                        height: 137,
                        value: 1.91
                    },
                    {
                        height: 145,
                        value: 2.16
                    },
                    {
                        height: 152,
                        value: 2.4
                    },
                    {
                        height: 160,
                        value: 2.69
                    },
                    {
                        height: 168,
                        value: 3
                    },
                    {
                        height: 175,
                        value: 3.28
                    },
                    {
                        height: 183,
                        value: 3.63
                    },
                    {
                        height: 191,
                        value: 3.99
                    },
                    {
                        height: 198,
                        value: 4.32
                    },
                    {
                        height: 206,
                        value: 4.71
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.8
                    },
                    {
                        height: 145,
                        value: 2.05
                    },
                    {
                        height: 152,
                        value: 2.27
                    },
                    {
                        height: 160,
                        value: 2.54
                    },
                    {
                        height: 168,
                        value: 2.84
                    },
                    {
                        height: 175,
                        value: 3.1
                    },
                    {
                        height: 183,
                        value: 3.43
                    },
                    {
                        height: 191,
                        value: 3.77
                    },
                    {
                        height: 198,
                        value: 4.08
                    },
                    {
                        height: 206,
                        value: 4.46
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.32
                    },
                    {
                        height: 130,
                        value: 1.52
                    },
                    {
                        height: 137,
                        value: 1.7
                    },
                    {
                        height: 145,
                        value: 1.93
                    },
                    {
                        height: 152,
                        value: 2.15
                    },
                    {
                        height: 160,
                        value: 2.41
                    },
                    {
                        height: 168,
                        value: 2.68
                    },
                    {
                        height: 175,
                        value: 2.93
                    },
                    {
                        height: 183,
                        value: 3.24
                    },
                    {
                        height: 191,
                        value: 3.56
                    },
                    {
                        height: 198,
                        value: 3.86
                    },
                    {
                        height: 206,
                        value: 4.22
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.25
                    },
                    {
                        height: 130,
                        value: 1.44
                    },
                    {
                        height: 137,
                        value: 1.61
                    },
                    {
                        height: 145,
                        value: 1.83
                    },
                    {
                        height: 152,
                        value: 2.03
                    },
                    {
                        height: 160,
                        value: 2.28
                    },
                    {
                        height: 168,
                        value: 2.54
                    },
                    {
                        height: 175,
                        value: 2.78
                    },
                    {
                        height: 183,
                        value: 3.07
                    },
                    {
                        height: 191,
                        value: 3.37
                    },
                    {
                        height: 198,
                        value: 3.66
                    },
                    {
                        height: 206,
                        value: 3.99
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.18
                    },
                    {
                        height: 130,
                        value: 1.36
                    },
                    {
                        height: 137,
                        value: 1.53
                    },
                    {
                        height: 145,
                        value: 1.74
                    },
                    {
                        height: 152,
                        value: 1.93
                    },
                    {
                        height: 160,
                        value: 2.16
                    },
                    {
                        height: 168,
                        value: 2.41
                    },
                    {
                        height: 175,
                        value: 2.64
                    },
                    {
                        height: 183,
                        value: 2.91
                    },
                    {
                        height: 191,
                        value: 3.2
                    },
                    {
                        height: 198,
                        value: 3.47
                    },
                    {
                        height: 206,
                        value: 3.79
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.13
                    },
                    {
                        height: 130,
                        value: 1.3
                    },
                    {
                        height: 137,
                        value: 1.46
                    },
                    {
                        height: 145,
                        value: 1.66
                    },
                    {
                        height: 152,
                        value: 1.84
                    },
                    {
                        height: 160,
                        value: 2.06
                    },
                    {
                        height: 168,
                        value: 2.3
                    },
                    {
                        height: 175,
                        value: 2.51
                    },
                    {
                        height: 183,
                        value: 2.77
                    },
                    {
                        height: 191,
                        value: 3.05
                    },
                    {
                        height: 198,
                        value: 3.31
                    },
                    {
                        height: 206,
                        value: 3.61
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.08
                    },
                    {
                        height: 130,
                        value: 1.24
                    },
                    {
                        height: 137,
                        value: 1.39
                    },
                    {
                        height: 145,
                        value: 1.58
                    },
                    {
                        height: 152,
                        value: 1.75
                    },
                    {
                        height: 160,
                        value: 1.97
                    },
                    {
                        height: 168,
                        value: 2.19
                    },
                    {
                        height: 175,
                        value: 2.4
                    },
                    {
                        height: 183,
                        value: 2.65
                    },
                    {
                        height: 191,
                        value: 2.91
                    },
                    {
                        height: 198,
                        value: 3.16
                    },
                    {
                        height: 206,
                        value: 3.45
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.77
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.76
                    },
                    {
                        height: 152,
                        value: 0.75
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.74
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.73
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.72
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.77
                    },
                    {
                        height: 137,
                        value: 0.76
                    },
                    {
                        height: 145,
                        value: 0.75
                    },
                    {
                        height: 152,
                        value: 0.75
                    },
                    {
                        height: 160,
                        value: 0.74
                    },
                    {
                        height: 168,
                        value: 0.74
                    },
                    {
                        height: 175,
                        value: 0.73
                    },
                    {
                        height: 183,
                        value: 0.73
                    },
                    {
                        height: 191,
                        value: 0.72
                    },
                    {
                        height: 198,
                        value: 0.72
                    },
                    {
                        height: 206,
                        value: 0.71
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "Caucasian",
        gender: "Female",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.25
                    },
                    {
                        height: 122,
                        value: 1.46
                    },
                    {
                        height: 130,
                        value: 1.69
                    },
                    {
                        height: 137,
                        value: 1.9
                    },
                    {
                        height: 145,
                        value: 2.16
                    },
                    {
                        height: 152,
                        value: 2.41
                    },
                    {
                        height: 160,
                        value: 2.7
                    },
                    {
                        height: 168,
                        value: 3.02
                    },
                    {
                        height: 175,
                        value: 3.31
                    },
                    {
                        height: 183,
                        value: 3.66
                    },
                    {
                        height: 191,
                        value: 4.03
                    },
                    {
                        height: 198,
                        value: 4.38
                    },
                    {
                        height: 206,
                        value: 4.79
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.38
                    },
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.1
                    },
                    {
                        height: 145,
                        value: 2.38
                    },
                    {
                        height: 152,
                        value: 2.65
                    },
                    {
                        height: 160,
                        value: 2.98
                    },
                    {
                        height: 168,
                        value: 3.33
                    },
                    {
                        height: 175,
                        value: 3.65
                    },
                    {
                        height: 183,
                        value: 4.04
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.82
                    },
                    {
                        height: 206,
                        value: 5.28
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.61
                    },
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.17
                    },
                    {
                        height: 137,
                        value: 2.44
                    },
                    {
                        height: 145,
                        value: 2.78
                    },
                    {
                        height: 152,
                        value: 3.09
                    },
                    {
                        height: 160,
                        value: 3.47
                    },
                    {
                        height: 168,
                        value: 3.88
                    },
                    {
                        height: 175,
                        value: 4.25
                    },
                    {
                        height: 183,
                        value: 4.71
                    },
                    {
                        height: 191,
                        value: 5.18
                    },
                    {
                        height: 198,
                        value: 5.62
                    },
                    {
                        height: 206,
                        value: 6.15
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.7
                    },
                    {
                        height: 122,
                        value: 1.98
                    },
                    {
                        height: 130,
                        value: 2.29
                    },
                    {
                        height: 137,
                        value: 2.58
                    },
                    {
                        height: 145,
                        value: 2.93
                    },
                    {
                        height: 152,
                        value: 3.26
                    },
                    {
                        height: 160,
                        value: 3.66
                    },
                    {
                        height: 168,
                        value: 4.09
                    },
                    {
                        height: 175,
                        value: 4.48
                    },
                    {
                        height: 183,
                        value: 4.96
                    },
                    {
                        height: 191,
                        value: 5.46
                    },
                    {
                        height: 198,
                        value: 5.93
                    },
                    {
                        height: 206,
                        value: 6.48
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.71
                    },
                    {
                        height: 122,
                        value: 1.99
                    },
                    {
                        height: 130,
                        value: 2.3
                    },
                    {
                        height: 137,
                        value: 2.59
                    },
                    {
                        height: 145,
                        value: 2.94
                    },
                    {
                        height: 152,
                        value: 3.28
                    },
                    {
                        height: 160,
                        value: 3.68
                    },
                    {
                        height: 168,
                        value: 4.11
                    },
                    {
                        height: 175,
                        value: 4.51
                    },
                    {
                        height: 183,
                        value: 4.99
                    },
                    {
                        height: 191,
                        value: 5.49
                    },
                    {
                        height: 198,
                        value: 5.96
                    },
                    {
                        height: 206,
                        value: 6.52
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.7
                    },
                    {
                        height: 122,
                        value: 1.98
                    },
                    {
                        height: 130,
                        value: 2.29
                    },
                    {
                        height: 137,
                        value: 2.58
                    },
                    {
                        height: 145,
                        value: 2.93
                    },
                    {
                        height: 152,
                        value: 3.26
                    },
                    {
                        height: 160,
                        value: 3.66
                    },
                    {
                        height: 168,
                        value: 4.09
                    },
                    {
                        height: 175,
                        value: 4.49
                    },
                    {
                        height: 183,
                        value: 4.97
                    },
                    {
                        height: 191,
                        value: 5.47
                    },
                    {
                        height: 198,
                        value: 5.94
                    },
                    {
                        height: 206,
                        value: 6.49
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.68
                    },
                    {
                        height: 122,
                        value: 1.96
                    },
                    {
                        height: 130,
                        value: 2.27
                    },
                    {
                        height: 137,
                        value: 2.55
                    },
                    {
                        height: 145,
                        value: 2.9
                    },
                    {
                        height: 152,
                        value: 3.23
                    },
                    {
                        height: 160,
                        value: 3.63
                    },
                    {
                        height: 168,
                        value: 4.05
                    },
                    {
                        height: 175,
                        value: 4.44
                    },
                    {
                        height: 183,
                        value: 4.91
                    },
                    {
                        height: 191,
                        value: 5.41
                    },
                    {
                        height: 198,
                        value: 5.87
                    },
                    {
                        height: 206,
                        value: 6.42
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.65
                    },
                    {
                        height: 122,
                        value: 1.92
                    },
                    {
                        height: 130,
                        value: 2.22
                    },
                    {
                        height: 137,
                        value: 2.5
                    },
                    {
                        height: 145,
                        value: 2.84
                    },
                    {
                        height: 152,
                        value: 3.16
                    },
                    {
                        height: 160,
                        value: 3.55
                    },
                    {
                        height: 168,
                        value: 3.97
                    },
                    {
                        height: 175,
                        value: 4.35
                    },
                    {
                        height: 183,
                        value: 4.81
                    },
                    {
                        height: 191,
                        value: 5.3
                    },
                    {
                        height: 198,
                        value: 5.75
                    },
                    {
                        height: 206,
                        value: 6.29
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.6
                    },
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.43
                    },
                    {
                        height: 145,
                        value: 2.76
                    },
                    {
                        height: 152,
                        value: 3.07
                    },
                    {
                        height: 160,
                        value: 3.45
                    },
                    {
                        height: 168,
                        value: 3.85
                    },
                    {
                        height: 175,
                        value: 4.23
                    },
                    {
                        height: 183,
                        value: 4.68
                    },
                    {
                        height: 191,
                        value: 5.15
                    },
                    {
                        height: 198,
                        value: 5.59
                    },
                    {
                        height: 206,
                        value: 6.11
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.55
                    },
                    {
                        height: 122,
                        value: 1.8
                    },
                    {
                        height: 130,
                        value: 2.08
                    },
                    {
                        height: 137,
                        value: 2.34
                    },
                    {
                        height: 145,
                        value: 2.67
                    },
                    {
                        height: 152,
                        value: 2.97
                    },
                    {
                        height: 160,
                        value: 3.33
                    },
                    {
                        height: 168,
                        value: 3.72
                    },
                    {
                        height: 175,
                        value: 4.08
                    },
                    {
                        height: 183,
                        value: 4.52
                    },
                    {
                        height: 191,
                        value: 4.97
                    },
                    {
                        height: 198,
                        value: 5.4
                    },
                    {
                        height: 206,
                        value: 5.9
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.49
                    },
                    {
                        height: 122,
                        value: 1.73
                    },
                    {
                        height: 130,
                        value: 2
                    },
                    {
                        height: 137,
                        value: 2.25
                    },
                    {
                        height: 145,
                        value: 2.56
                    },
                    {
                        height: 152,
                        value: 2.85
                    },
                    {
                        height: 160,
                        value: 3.2
                    },
                    {
                        height: 168,
                        value: 3.57
                    },
                    {
                        height: 175,
                        value: 3.92
                    },
                    {
                        height: 183,
                        value: 4.34
                    },
                    {
                        height: 191,
                        value: 4.78
                    },
                    {
                        height: 198,
                        value: 5.18
                    },
                    {
                        height: 206,
                        value: 5.67
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.42
                    },
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.91
                    },
                    {
                        height: 137,
                        value: 2.15
                    },
                    {
                        height: 145,
                        value: 2.45
                    },
                    {
                        height: 152,
                        value: 2.72
                    },
                    {
                        height: 160,
                        value: 3.06
                    },
                    {
                        height: 168,
                        value: 3.41
                    },
                    {
                        height: 175,
                        value: 3.74
                    },
                    {
                        height: 183,
                        value: 4.14
                    },
                    {
                        height: 191,
                        value: 4.56
                    },
                    {
                        height: 198,
                        value: 4.95
                    },
                    {
                        height: 206,
                        value: 5.41
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.35
                    },
                    {
                        height: 122,
                        value: 1.57
                    },
                    {
                        height: 130,
                        value: 1.82
                    },
                    {
                        height: 137,
                        value: 2.04
                    },
                    {
                        height: 145,
                        value: 2.32
                    },
                    {
                        height: 152,
                        value: 2.59
                    },
                    {
                        height: 160,
                        value: 2.9
                    },
                    {
                        height: 168,
                        value: 3.24
                    },
                    {
                        height: 175,
                        value: 3.56
                    },
                    {
                        height: 183,
                        value: 3.94
                    },
                    {
                        height: 191,
                        value: 4.34
                    },
                    {
                        height: 198,
                        value: 4.7
                    },
                    {
                        height: 206,
                        value: 5.15
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.28
                    },
                    {
                        height: 122,
                        value: 1.49
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.2
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.07
                    },
                    {
                        height: 175,
                        value: 3.37
                    },
                    {
                        height: 183,
                        value: 3.73
                    },
                    {
                        height: 191,
                        value: 4.1
                    },
                    {
                        height: 198,
                        value: 4.45
                    },
                    {
                        height: 206,
                        value: 4.87
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 1.21
                    },
                    {
                        height: 122,
                        value: 1.41
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.83
                    },
                    {
                        height: 145,
                        value: 2.08
                    },
                    {
                        height: 152,
                        value: 2.31
                    },
                    {
                        height: 160,
                        value: 2.6
                    },
                    {
                        height: 168,
                        value: 2.9
                    },
                    {
                        height: 175,
                        value: 3.18
                    },
                    {
                        height: 183,
                        value: 3.52
                    },
                    {
                        height: 191,
                        value: 3.88
                    },
                    {
                        height: 198,
                        value: 4.21
                    },
                    {
                        height: 206,
                        value: 4.6
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 1.14
                    },
                    {
                        height: 122,
                        value: 1.33
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.73
                    },
                    {
                        height: 145,
                        value: 1.96
                    },
                    {
                        height: 152,
                        value: 2.18
                    },
                    {
                        height: 160,
                        value: 2.45
                    },
                    {
                        height: 168,
                        value: 2.74
                    },
                    {
                        height: 175,
                        value: 3
                    },
                    {
                        height: 183,
                        value: 3.32
                    },
                    {
                        height: 191,
                        value: 3.66
                    },
                    {
                        height: 198,
                        value: 3.97
                    },
                    {
                        height: 206,
                        value: 4.35
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 1.08
                    },
                    {
                        height: 122,
                        value: 1.26
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.64
                    },
                    {
                        height: 145,
                        value: 1.86
                    },
                    {
                        height: 152,
                        value: 2.07
                    },
                    {
                        height: 160,
                        value: 2.32
                    },
                    {
                        height: 168,
                        value: 2.59
                    },
                    {
                        height: 175,
                        value: 2.85
                    },
                    {
                        height: 183,
                        value: 3.15
                    },
                    {
                        height: 191,
                        value: 3.47
                    },
                    {
                        height: 198,
                        value: 3.76
                    },
                    {
                        height: 206,
                        value: 4.12
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 1.02
                    },
                    {
                        height: 122,
                        value: 1.19
                    },
                    {
                        height: 130,
                        value: 1.38
                    },
                    {
                        height: 137,
                        value: 1.55
                    },
                    {
                        height: 145,
                        value: 1.77
                    },
                    {
                        height: 152,
                        value: 1.96
                    },
                    {
                        height: 160,
                        value: 2.21
                    },
                    {
                        height: 168,
                        value: 2.46
                    },
                    {
                        height: 175,
                        value: 2.7
                    },
                    {
                        height: 183,
                        value: 2.99
                    },
                    {
                        height: 191,
                        value: 3.29
                    },
                    {
                        height: 198,
                        value: 3.57
                    },
                    {
                        height: 206,
                        value: 3.91
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.98
                    },
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.31
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.68
                    },
                    {
                        height: 152,
                        value: 1.87
                    },
                    {
                        height: 160,
                        value: 2.1
                    },
                    {
                        height: 168,
                        value: 2.35
                    },
                    {
                        height: 175,
                        value: 2.57
                    },
                    {
                        height: 183,
                        value: 2.85
                    },
                    {
                        height: 191,
                        value: 3.14
                    },
                    {
                        height: 198,
                        value: 3.4
                    },
                    {
                        height: 206,
                        value: 3.72
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.16
                    },
                    {
                        height: 122,
                        value: 1.34
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.71
                    },
                    {
                        height: 145,
                        value: 1.96
                    },
                    {
                        height: 152,
                        value: 2.14
                    },
                    {
                        height: 160,
                        value: 2.38
                    },
                    {
                        height: 168,
                        value: 2.64
                    },
                    {
                        height: 175,
                        value: 2.88
                    },
                    {
                        height: 183,
                        value: 3.17
                    },
                    {
                        height: 191,
                        value: 3.47
                    },
                    {
                        height: 198,
                        value: 3.74
                    },
                    {
                        height: 206,
                        value: 4.07
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.26
                    },
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.66
                    },
                    {
                        height: 137,
                        value: 1.85
                    },
                    {
                        height: 145,
                        value: 2.12
                    },
                    {
                        height: 152,
                        value: 2.31
                    },
                    {
                        height: 160,
                        value: 2.58
                    },
                    {
                        height: 168,
                        value: 2.86
                    },
                    {
                        height: 175,
                        value: 3.12
                    },
                    {
                        height: 183,
                        value: 3.43
                    },
                    {
                        height: 191,
                        value: 3.75
                    },
                    {
                        height: 198,
                        value: 4.05
                    },
                    {
                        height: 206,
                        value: 4.41
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.51
                    },
                    {
                        height: 122,
                        value: 1.74
                    },
                    {
                        height: 130,
                        value: 1.99
                    },
                    {
                        height: 137,
                        value: 2.23
                    },
                    {
                        height: 145,
                        value: 2.55
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.1
                    },
                    {
                        height: 168,
                        value: 3.44
                    },
                    {
                        height: 175,
                        value: 3.75
                    },
                    {
                        height: 183,
                        value: 4.12
                    },
                    {
                        height: 191,
                        value: 4.51
                    },
                    {
                        height: 198,
                        value: 4.87
                    },
                    {
                        height: 206,
                        value: 5.3
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.57
                    },
                    {
                        height: 122,
                        value: 1.81
                    },
                    {
                        height: 130,
                        value: 2.07
                    },
                    {
                        height: 137,
                        value: 2.32
                    },
                    {
                        height: 145,
                        value: 2.65
                    },
                    {
                        height: 152,
                        value: 2.89
                    },
                    {
                        height: 160,
                        value: 3.22
                    },
                    {
                        height: 168,
                        value: 3.57
                    },
                    {
                        height: 175,
                        value: 3.89
                    },
                    {
                        height: 183,
                        value: 4.28
                    },
                    {
                        height: 191,
                        value: 4.69
                    },
                    {
                        height: 198,
                        value: 5.06
                    },
                    {
                        height: 206,
                        value: 5.5
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.55
                    },
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.61
                    },
                    {
                        height: 152,
                        value: 2.85
                    },
                    {
                        height: 160,
                        value: 3.17
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.84
                    },
                    {
                        height: 183,
                        value: 4.22
                    },
                    {
                        height: 191,
                        value: 4.62
                    },
                    {
                        height: 198,
                        value: 4.99
                    },
                    {
                        height: 206,
                        value: 5.42
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.51
                    },
                    {
                        height: 122,
                        value: 1.75
                    },
                    {
                        height: 130,
                        value: 2
                    },
                    {
                        height: 137,
                        value: 2.24
                    },
                    {
                        height: 145,
                        value: 2.56
                    },
                    {
                        height: 152,
                        value: 2.79
                    },
                    {
                        height: 160,
                        value: 3.11
                    },
                    {
                        height: 168,
                        value: 3.45
                    },
                    {
                        height: 175,
                        value: 3.76
                    },
                    {
                        height: 183,
                        value: 4.13
                    },
                    {
                        height: 191,
                        value: 4.52
                    },
                    {
                        height: 198,
                        value: 4.88
                    },
                    {
                        height: 206,
                        value: 5.31
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.47
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.95
                    },
                    {
                        height: 137,
                        value: 2.18
                    },
                    {
                        height: 145,
                        value: 2.49
                    },
                    {
                        height: 152,
                        value: 2.71
                    },
                    {
                        height: 160,
                        value: 3.02
                    },
                    {
                        height: 168,
                        value: 3.35
                    },
                    {
                        height: 175,
                        value: 3.66
                    },
                    {
                        height: 183,
                        value: 4.02
                    },
                    {
                        height: 191,
                        value: 4.4
                    },
                    {
                        height: 198,
                        value: 4.75
                    },
                    {
                        height: 206,
                        value: 5.17
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.42
                    },
                    {
                        height: 122,
                        value: 1.64
                    },
                    {
                        height: 130,
                        value: 1.88
                    },
                    {
                        height: 137,
                        value: 2.1
                    },
                    {
                        height: 145,
                        value: 2.4
                    },
                    {
                        height: 152,
                        value: 2.62
                    },
                    {
                        height: 160,
                        value: 2.92
                    },
                    {
                        height: 168,
                        value: 3.24
                    },
                    {
                        height: 175,
                        value: 3.53
                    },
                    {
                        height: 183,
                        value: 3.88
                    },
                    {
                        height: 191,
                        value: 4.25
                    },
                    {
                        height: 198,
                        value: 4.58
                    },
                    {
                        height: 206,
                        value: 4.99
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.36
                    },
                    {
                        height: 122,
                        value: 1.57
                    },
                    {
                        height: 130,
                        value: 1.8
                    },
                    {
                        height: 137,
                        value: 2.01
                    },
                    {
                        height: 145,
                        value: 2.3
                    },
                    {
                        height: 152,
                        value: 2.51
                    },
                    {
                        height: 160,
                        value: 2.8
                    },
                    {
                        height: 168,
                        value: 3.1
                    },
                    {
                        height: 175,
                        value: 3.38
                    },
                    {
                        height: 183,
                        value: 3.72
                    },
                    {
                        height: 191,
                        value: 4.07
                    },
                    {
                        height: 198,
                        value: 4.39
                    },
                    {
                        height: 206,
                        value: 4.78
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.3
                    },
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.92
                    },
                    {
                        height: 145,
                        value: 2.2
                    },
                    {
                        height: 152,
                        value: 2.4
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 2.97
                    },
                    {
                        height: 175,
                        value: 3.23
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.89
                    },
                    {
                        height: 198,
                        value: 4.2
                    },
                    {
                        height: 206,
                        value: 4.57
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.24
                    },
                    {
                        height: 122,
                        value: 1.43
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.83
                    },
                    {
                        height: 145,
                        value: 2.1
                    },
                    {
                        height: 152,
                        value: 2.29
                    },
                    {
                        height: 160,
                        value: 2.55
                    },
                    {
                        height: 168,
                        value: 2.83
                    },
                    {
                        height: 175,
                        value: 3.08
                    },
                    {
                        height: 183,
                        value: 3.39
                    },
                    {
                        height: 191,
                        value: 3.71
                    },
                    {
                        height: 198,
                        value: 4
                    },
                    {
                        height: 206,
                        value: 4.35
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.18
                    },
                    {
                        height: 122,
                        value: 1.36
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.74
                    },
                    {
                        height: 145,
                        value: 1.99
                    },
                    {
                        height: 152,
                        value: 2.17
                    },
                    {
                        height: 160,
                        value: 2.41
                    },
                    {
                        height: 168,
                        value: 2.68
                    },
                    {
                        height: 175,
                        value: 2.92
                    },
                    {
                        height: 183,
                        value: 3.21
                    },
                    {
                        height: 191,
                        value: 3.52
                    },
                    {
                        height: 198,
                        value: 3.79
                    },
                    {
                        height: 206,
                        value: 4.13
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.11
                    },
                    {
                        height: 122,
                        value: 1.28
                    },
                    {
                        height: 130,
                        value: 1.47
                    },
                    {
                        height: 137,
                        value: 1.64
                    },
                    {
                        height: 145,
                        value: 1.87
                    },
                    {
                        height: 152,
                        value: 2.04
                    },
                    {
                        height: 160,
                        value: 2.28
                    },
                    {
                        height: 168,
                        value: 2.52
                    },
                    {
                        height: 175,
                        value: 2.75
                    },
                    {
                        height: 183,
                        value: 3.03
                    },
                    {
                        height: 191,
                        value: 3.31
                    },
                    {
                        height: 198,
                        value: 3.58
                    },
                    {
                        height: 206,
                        value: 3.89
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.04
                    },
                    {
                        height: 122,
                        value: 1.2
                    },
                    {
                        height: 130,
                        value: 1.38
                    },
                    {
                        height: 137,
                        value: 1.54
                    },
                    {
                        height: 145,
                        value: 1.76
                    },
                    {
                        height: 152,
                        value: 1.92
                    },
                    {
                        height: 160,
                        value: 2.14
                    },
                    {
                        height: 168,
                        value: 2.37
                    },
                    {
                        height: 175,
                        value: 2.58
                    },
                    {
                        height: 183,
                        value: 2.84
                    },
                    {
                        height: 191,
                        value: 3.11
                    },
                    {
                        height: 198,
                        value: 3.36
                    },
                    {
                        height: 206,
                        value: 3.65
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.97
                    },
                    {
                        height: 122,
                        value: 1.12
                    },
                    {
                        height: 130,
                        value: 1.29
                    },
                    {
                        height: 137,
                        value: 1.44
                    },
                    {
                        height: 145,
                        value: 1.65
                    },
                    {
                        height: 152,
                        value: 1.79
                    },
                    {
                        height: 160,
                        value: 2
                    },
                    {
                        height: 168,
                        value: 2.22
                    },
                    {
                        height: 175,
                        value: 2.42
                    },
                    {
                        height: 183,
                        value: 2.66
                    },
                    {
                        height: 191,
                        value: 2.91
                    },
                    {
                        height: 198,
                        value: 3.14
                    },
                    {
                        height: 206,
                        value: 3.41
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 1.05
                    },
                    {
                        height: 130,
                        value: 1.2
                    },
                    {
                        height: 137,
                        value: 1.34
                    },
                    {
                        height: 145,
                        value: 1.54
                    },
                    {
                        height: 152,
                        value: 1.68
                    },
                    {
                        height: 160,
                        value: 1.87
                    },
                    {
                        height: 168,
                        value: 2.07
                    },
                    {
                        height: 175,
                        value: 2.26
                    },
                    {
                        height: 183,
                        value: 2.48
                    },
                    {
                        height: 191,
                        value: 2.72
                    },
                    {
                        height: 198,
                        value: 2.94
                    },
                    {
                        height: 206,
                        value: 3.19
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.99
                    },
                    {
                        height: 130,
                        value: 1.13
                    },
                    {
                        height: 137,
                        value: 1.26
                    },
                    {
                        height: 145,
                        value: 1.44
                    },
                    {
                        height: 152,
                        value: 1.57
                    },
                    {
                        height: 160,
                        value: 1.75
                    },
                    {
                        height: 168,
                        value: 1.94
                    },
                    {
                        height: 175,
                        value: 2.12
                    },
                    {
                        height: 183,
                        value: 2.33
                    },
                    {
                        height: 191,
                        value: 2.55
                    },
                    {
                        height: 198,
                        value: 2.75
                    },
                    {
                        height: 206,
                        value: 3
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 1.06
                    },
                    {
                        height: 137,
                        value: 1.19
                    },
                    {
                        height: 145,
                        value: 1.36
                    },
                    {
                        height: 152,
                        value: 1.48
                    },
                    {
                        height: 160,
                        value: 1.65
                    },
                    {
                        height: 168,
                        value: 1.83
                    },
                    {
                        height: 175,
                        value: 1.99
                    },
                    {
                        height: 183,
                        value: 2.19
                    },
                    {
                        height: 191,
                        value: 2.4
                    },
                    {
                        height: 198,
                        value: 2.59
                    },
                    {
                        height: 206,
                        value: 2.82
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.76
                    },
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 1
                    },
                    {
                        height: 137,
                        value: 1.12
                    },
                    {
                        height: 145,
                        value: 1.28
                    },
                    {
                        height: 152,
                        value: 1.4
                    },
                    {
                        height: 160,
                        value: 1.56
                    },
                    {
                        height: 168,
                        value: 1.73
                    },
                    {
                        height: 175,
                        value: 1.88
                    },
                    {
                        height: 183,
                        value: 2.07
                    },
                    {
                        height: 191,
                        value: 2.27
                    },
                    {
                        height: 198,
                        value: 2.45
                    },
                    {
                        height: 206,
                        value: 2.66
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.9
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.88
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.87
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 0.9
                    },
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 0.87
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.77
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "South East Asian",
        gender: "Male",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.36
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 3.01
                    },
                    {
                        height: 175,
                        value: 3.32
                    },
                    {
                        height: 183,
                        value: 3.7
                    },
                    {
                        height: 191,
                        value: 4.1
                    },
                    {
                        height: 198,
                        value: 4.47
                    },
                    {
                        height: 206,
                        value: 4.92
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.75
                    },
                    {
                        height: 137,
                        value: 1.99
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.55
                    },
                    {
                        height: 160,
                        value: 2.89
                    },
                    {
                        height: 168,
                        value: 3.25
                    },
                    {
                        height: 175,
                        value: 3.59
                    },
                    {
                        height: 183,
                        value: 3.99
                    },
                    {
                        height: 191,
                        value: 4.43
                    },
                    {
                        height: 198,
                        value: 4.83
                    },
                    {
                        height: 206,
                        value: 5.31
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.74
                    },
                    {
                        height: 130,
                        value: 2.02
                    },
                    {
                        height: 137,
                        value: 2.3
                    },
                    {
                        height: 145,
                        value: 2.64
                    },
                    {
                        height: 152,
                        value: 2.95
                    },
                    {
                        height: 160,
                        value: 3.34
                    },
                    {
                        height: 168,
                        value: 3.76
                    },
                    {
                        height: 175,
                        value: 4.15
                    },
                    {
                        height: 183,
                        value: 4.62
                    },
                    {
                        height: 191,
                        value: 5.12
                    },
                    {
                        height: 198,
                        value: 5.59
                    },
                    {
                        height: 206,
                        value: 6.15
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.96
                    },
                    {
                        height: 130,
                        value: 2.29
                    },
                    {
                        height: 137,
                        value: 2.6
                    },
                    {
                        height: 145,
                        value: 2.98
                    },
                    {
                        height: 152,
                        value: 3.34
                    },
                    {
                        height: 160,
                        value: 3.78
                    },
                    {
                        height: 168,
                        value: 4.25
                    },
                    {
                        height: 175,
                        value: 4.69
                    },
                    {
                        height: 183,
                        value: 5.23
                    },
                    {
                        height: 191,
                        value: 5.79
                    },
                    {
                        height: 198,
                        value: 6.32
                    },
                    {
                        height: 206,
                        value: 6.95
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.98
                    },
                    {
                        height: 130,
                        value: 2.31
                    },
                    {
                        height: 137,
                        value: 2.62
                    },
                    {
                        height: 145,
                        value: 3.01
                    },
                    {
                        height: 152,
                        value: 3.37
                    },
                    {
                        height: 160,
                        value: 3.81
                    },
                    {
                        height: 168,
                        value: 4.29
                    },
                    {
                        height: 175,
                        value: 4.73
                    },
                    {
                        height: 183,
                        value: 5.27
                    },
                    {
                        height: 191,
                        value: 5.85
                    },
                    {
                        height: 198,
                        value: 6.38
                    },
                    {
                        height: 206,
                        value: 7.02
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.95
                    },
                    {
                        height: 130,
                        value: 2.28
                    },
                    {
                        height: 137,
                        value: 2.58
                    },
                    {
                        height: 145,
                        value: 2.96
                    },
                    {
                        height: 152,
                        value: 3.32
                    },
                    {
                        height: 160,
                        value: 3.76
                    },
                    {
                        height: 168,
                        value: 4.22
                    },
                    {
                        height: 175,
                        value: 4.66
                    },
                    {
                        height: 183,
                        value: 5.19
                    },
                    {
                        height: 191,
                        value: 5.76
                    },
                    {
                        height: 198,
                        value: 6.28
                    },
                    {
                        height: 206,
                        value: 6.91
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.92
                    },
                    {
                        height: 130,
                        value: 2.23
                    },
                    {
                        height: 137,
                        value: 2.54
                    },
                    {
                        height: 145,
                        value: 2.91
                    },
                    {
                        height: 152,
                        value: 3.26
                    },
                    {
                        height: 160,
                        value: 3.69
                    },
                    {
                        height: 168,
                        value: 4.15
                    },
                    {
                        height: 175,
                        value: 4.58
                    },
                    {
                        height: 183,
                        value: 5.1
                    },
                    {
                        height: 191,
                        value: 5.66
                    },
                    {
                        height: 198,
                        value: 6.17
                    },
                    {
                        height: 206,
                        value: 6.79
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.19
                    },
                    {
                        height: 137,
                        value: 2.49
                    },
                    {
                        height: 145,
                        value: 2.85
                    },
                    {
                        height: 152,
                        value: 3.2
                    },
                    {
                        height: 160,
                        value: 3.62
                    },
                    {
                        height: 168,
                        value: 4.07
                    },
                    {
                        height: 175,
                        value: 4.49
                    },
                    {
                        height: 183,
                        value: 5.01
                    },
                    {
                        height: 191,
                        value: 5.55
                    },
                    {
                        height: 198,
                        value: 6.05
                    },
                    {
                        height: 206,
                        value: 6.66
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.84
                    },
                    {
                        height: 130,
                        value: 2.14
                    },
                    {
                        height: 137,
                        value: 2.43
                    },
                    {
                        height: 145,
                        value: 2.79
                    },
                    {
                        height: 152,
                        value: 3.12
                    },
                    {
                        height: 160,
                        value: 3.54
                    },
                    {
                        height: 168,
                        value: 3.98
                    },
                    {
                        height: 175,
                        value: 4.39
                    },
                    {
                        height: 183,
                        value: 4.89
                    },
                    {
                        height: 191,
                        value: 5.42
                    },
                    {
                        height: 198,
                        value: 5.91
                    },
                    {
                        height: 206,
                        value: 6.51
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.08
                    },
                    {
                        height: 137,
                        value: 2.36
                    },
                    {
                        height: 145,
                        value: 2.71
                    },
                    {
                        height: 152,
                        value: 3.04
                    },
                    {
                        height: 160,
                        value: 3.44
                    },
                    {
                        height: 168,
                        value: 3.87
                    },
                    {
                        height: 175,
                        value: 4.27
                    },
                    {
                        height: 183,
                        value: 4.75
                    },
                    {
                        height: 191,
                        value: 5.27
                    },
                    {
                        height: 198,
                        value: 5.75
                    },
                    {
                        height: 206,
                        value: 6.33
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.73
                    },
                    {
                        height: 130,
                        value: 2.02
                    },
                    {
                        height: 137,
                        value: 2.29
                    },
                    {
                        height: 145,
                        value: 2.62
                    },
                    {
                        height: 152,
                        value: 2.94
                    },
                    {
                        height: 160,
                        value: 3.33
                    },
                    {
                        height: 168,
                        value: 3.74
                    },
                    {
                        height: 175,
                        value: 4.13
                    },
                    {
                        height: 183,
                        value: 4.6
                    },
                    {
                        height: 191,
                        value: 5.1
                    },
                    {
                        height: 198,
                        value: 5.56
                    },
                    {
                        height: 206,
                        value: 6.12
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.66
                    },
                    {
                        height: 130,
                        value: 1.94
                    },
                    {
                        height: 137,
                        value: 2.2
                    },
                    {
                        height: 145,
                        value: 2.52
                    },
                    {
                        height: 152,
                        value: 2.83
                    },
                    {
                        height: 160,
                        value: 3.2
                    },
                    {
                        height: 168,
                        value: 3.6
                    },
                    {
                        height: 175,
                        value: 3.97
                    },
                    {
                        height: 183,
                        value: 4.42
                    },
                    {
                        height: 191,
                        value: 4.91
                    },
                    {
                        height: 198,
                        value: 5.35
                    },
                    {
                        height: 206,
                        value: 5.89
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.59
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.11
                    },
                    {
                        height: 145,
                        value: 2.42
                    },
                    {
                        height: 152,
                        value: 2.71
                    },
                    {
                        height: 160,
                        value: 3.06
                    },
                    {
                        height: 168,
                        value: 3.45
                    },
                    {
                        height: 175,
                        value: 3.8
                    },
                    {
                        height: 183,
                        value: 4.24
                    },
                    {
                        height: 191,
                        value: 4.7
                    },
                    {
                        height: 198,
                        value: 5.12
                    },
                    {
                        height: 206,
                        value: 5.64
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.52
                    },
                    {
                        height: 130,
                        value: 1.77
                    },
                    {
                        height: 137,
                        value: 2.01
                    },
                    {
                        height: 145,
                        value: 2.31
                    },
                    {
                        height: 152,
                        value: 2.59
                    },
                    {
                        height: 160,
                        value: 2.93
                    },
                    {
                        height: 168,
                        value: 3.3
                    },
                    {
                        height: 175,
                        value: 3.64
                    },
                    {
                        height: 183,
                        value: 4.05
                    },
                    {
                        height: 191,
                        value: 4.49
                    },
                    {
                        height: 198,
                        value: 4.9
                    },
                    {
                        height: 206,
                        value: 5.39
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.46
                    },
                    {
                        height: 130,
                        value: 1.7
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.21
                    },
                    {
                        height: 152,
                        value: 2.48
                    },
                    {
                        height: 160,
                        value: 2.8
                    },
                    {
                        height: 168,
                        value: 3.15
                    },
                    {
                        height: 175,
                        value: 3.48
                    },
                    {
                        height: 183,
                        value: 3.87
                    },
                    {
                        height: 191,
                        value: 4.3
                    },
                    {
                        height: 198,
                        value: 4.69
                    },
                    {
                        height: 206,
                        value: 5.16
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.37
                    },
                    {
                        height: 160,
                        value: 2.68
                    },
                    {
                        height: 168,
                        value: 3.02
                    },
                    {
                        height: 175,
                        value: 3.33
                    },
                    {
                        height: 183,
                        value: 3.71
                    },
                    {
                        height: 191,
                        value: 4.11
                    },
                    {
                        height: 198,
                        value: 4.49
                    },
                    {
                        height: 206,
                        value: 4.94
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.34
                    },
                    {
                        height: 130,
                        value: 1.56
                    },
                    {
                        height: 137,
                        value: 1.77
                    },
                    {
                        height: 145,
                        value: 2.03
                    },
                    {
                        height: 152,
                        value: 2.27
                    },
                    {
                        height: 160,
                        value: 2.57
                    },
                    {
                        height: 168,
                        value: 2.89
                    },
                    {
                        height: 175,
                        value: 3.19
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.95
                    },
                    {
                        height: 198,
                        value: 4.3
                    },
                    {
                        height: 206,
                        value: 4.74
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.29
                    },
                    {
                        height: 130,
                        value: 1.5
                    },
                    {
                        height: 137,
                        value: 1.7
                    },
                    {
                        height: 145,
                        value: 1.95
                    },
                    {
                        height: 152,
                        value: 2.19
                    },
                    {
                        height: 160,
                        value: 2.47
                    },
                    {
                        height: 168,
                        value: 2.78
                    },
                    {
                        height: 175,
                        value: 3.07
                    },
                    {
                        height: 183,
                        value: 3.42
                    },
                    {
                        height: 191,
                        value: 3.79
                    },
                    {
                        height: 198,
                        value: 4.14
                    },
                    {
                        height: 206,
                        value: 4.55
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.24
                    },
                    {
                        height: 130,
                        value: 1.44
                    },
                    {
                        height: 137,
                        value: 1.64
                    },
                    {
                        height: 145,
                        value: 1.88
                    },
                    {
                        height: 152,
                        value: 2.11
                    },
                    {
                        height: 160,
                        value: 2.38
                    },
                    {
                        height: 168,
                        value: 2.68
                    },
                    {
                        height: 175,
                        value: 2.96
                    },
                    {
                        height: 183,
                        value: 3.3
                    },
                    {
                        height: 191,
                        value: 3.66
                    },
                    {
                        height: 198,
                        value: 3.99
                    },
                    {
                        height: 206,
                        value: 4.39
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.28
                    },
                    {
                        height: 130,
                        value: 1.48
                    },
                    {
                        height: 137,
                        value: 1.66
                    },
                    {
                        height: 145,
                        value: 1.88
                    },
                    {
                        height: 152,
                        value: 2.09
                    },
                    {
                        height: 160,
                        value: 2.34
                    },
                    {
                        height: 168,
                        value: 2.61
                    },
                    {
                        height: 175,
                        value: 2.86
                    },
                    {
                        height: 183,
                        value: 3.16
                    },
                    {
                        height: 191,
                        value: 3.47
                    },
                    {
                        height: 198,
                        value: 3.76
                    },
                    {
                        height: 206,
                        value: 4.11
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.36
                    },
                    {
                        height: 130,
                        value: 1.57
                    },
                    {
                        height: 137,
                        value: 1.76
                    },
                    {
                        height: 145,
                        value: 2
                    },
                    {
                        height: 152,
                        value: 2.22
                    },
                    {
                        height: 160,
                        value: 2.49
                    },
                    {
                        height: 168,
                        value: 2.77
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.35
                    },
                    {
                        height: 191,
                        value: 3.69
                    },
                    {
                        height: 198,
                        value: 3.99
                    },
                    {
                        height: 206,
                        value: 4.36
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.64
                    },
                    {
                        height: 130,
                        value: 1.89
                    },
                    {
                        height: 137,
                        value: 2.12
                    },
                    {
                        height: 145,
                        value: 2.41
                    },
                    {
                        height: 152,
                        value: 2.67
                    },
                    {
                        height: 160,
                        value: 3
                    },
                    {
                        height: 168,
                        value: 3.34
                    },
                    {
                        height: 175,
                        value: 3.65
                    },
                    {
                        height: 183,
                        value: 4.04
                    },
                    {
                        height: 191,
                        value: 4.44
                    },
                    {
                        height: 198,
                        value: 4.81
                    },
                    {
                        height: 206,
                        value: 5.25
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.85
                    },
                    {
                        height: 130,
                        value: 2.13
                    },
                    {
                        height: 137,
                        value: 2.39
                    },
                    {
                        height: 145,
                        value: 2.71
                    },
                    {
                        height: 152,
                        value: 3.01
                    },
                    {
                        height: 160,
                        value: 3.37
                    },
                    {
                        height: 168,
                        value: 3.75
                    },
                    {
                        height: 175,
                        value: 4.11
                    },
                    {
                        height: 183,
                        value: 4.54
                    },
                    {
                        height: 191,
                        value: 4.99
                    },
                    {
                        height: 198,
                        value: 5.41
                    },
                    {
                        height: 206,
                        value: 5.9
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.84
                    },
                    {
                        height: 130,
                        value: 2.11
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.69
                    },
                    {
                        height: 152,
                        value: 2.99
                    },
                    {
                        height: 160,
                        value: 3.35
                    },
                    {
                        height: 168,
                        value: 3.74
                    },
                    {
                        height: 175,
                        value: 4.09
                    },
                    {
                        height: 183,
                        value: 4.52
                    },
                    {
                        height: 191,
                        value: 4.97
                    },
                    {
                        height: 198,
                        value: 5.38
                    },
                    {
                        height: 206,
                        value: 5.87
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.78
                    },
                    {
                        height: 130,
                        value: 2.05
                    },
                    {
                        height: 137,
                        value: 2.3
                    },
                    {
                        height: 145,
                        value: 2.61
                    },
                    {
                        height: 152,
                        value: 2.9
                    },
                    {
                        height: 160,
                        value: 3.25
                    },
                    {
                        height: 168,
                        value: 3.62
                    },
                    {
                        height: 175,
                        value: 3.97
                    },
                    {
                        height: 183,
                        value: 4.38
                    },
                    {
                        height: 191,
                        value: 4.82
                    },
                    {
                        height: 198,
                        value: 5.22
                    },
                    {
                        height: 206,
                        value: 5.7
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.73
                    },
                    {
                        height: 130,
                        value: 1.99
                    },
                    {
                        height: 137,
                        value: 2.24
                    },
                    {
                        height: 145,
                        value: 2.54
                    },
                    {
                        height: 152,
                        value: 2.82
                    },
                    {
                        height: 160,
                        value: 3.16
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.85
                    },
                    {
                        height: 183,
                        value: 4.26
                    },
                    {
                        height: 191,
                        value: 4.68
                    },
                    {
                        height: 198,
                        value: 5.07
                    },
                    {
                        height: 206,
                        value: 5.54
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.68
                    },
                    {
                        height: 130,
                        value: 1.93
                    },
                    {
                        height: 137,
                        value: 2.17
                    },
                    {
                        height: 145,
                        value: 2.46
                    },
                    {
                        height: 152,
                        value: 2.73
                    },
                    {
                        height: 160,
                        value: 3.06
                    },
                    {
                        height: 168,
                        value: 3.41
                    },
                    {
                        height: 175,
                        value: 3.73
                    },
                    {
                        height: 183,
                        value: 4.12
                    },
                    {
                        height: 191,
                        value: 4.53
                    },
                    {
                        height: 198,
                        value: 4.91
                    },
                    {
                        height: 206,
                        value: 5.36
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.62
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.37
                    },
                    {
                        height: 152,
                        value: 2.64
                    },
                    {
                        height: 160,
                        value: 2.95
                    },
                    {
                        height: 168,
                        value: 3.29
                    },
                    {
                        height: 175,
                        value: 3.61
                    },
                    {
                        height: 183,
                        value: 3.98
                    },
                    {
                        height: 191,
                        value: 4.38
                    },
                    {
                        height: 198,
                        value: 4.74
                    },
                    {
                        height: 206,
                        value: 5.18
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.56
                    },
                    {
                        height: 130,
                        value: 1.8
                    },
                    {
                        height: 137,
                        value: 2.02
                    },
                    {
                        height: 145,
                        value: 2.29
                    },
                    {
                        height: 152,
                        value: 2.54
                    },
                    {
                        height: 160,
                        value: 2.85
                    },
                    {
                        height: 168,
                        value: 3.17
                    },
                    {
                        height: 175,
                        value: 3.48
                    },
                    {
                        height: 183,
                        value: 3.84
                    },
                    {
                        height: 191,
                        value: 4.22
                    },
                    {
                        height: 198,
                        value: 4.57
                    },
                    {
                        height: 206,
                        value: 4.99
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.44
                    },
                    {
                        height: 160,
                        value: 2.73
                    },
                    {
                        height: 168,
                        value: 3.04
                    },
                    {
                        height: 175,
                        value: 3.33
                    },
                    {
                        height: 183,
                        value: 3.68
                    },
                    {
                        height: 191,
                        value: 4.05
                    },
                    {
                        height: 198,
                        value: 4.38
                    },
                    {
                        height: 206,
                        value: 4.78
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.09
                    },
                    {
                        height: 152,
                        value: 2.32
                    },
                    {
                        height: 160,
                        value: 2.6
                    },
                    {
                        height: 168,
                        value: 2.9
                    },
                    {
                        height: 175,
                        value: 3.17
                    },
                    {
                        height: 183,
                        value: 3.5
                    },
                    {
                        height: 191,
                        value: 3.85
                    },
                    {
                        height: 198,
                        value: 4.17
                    },
                    {
                        height: 206,
                        value: 4.56
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 1.98
                    },
                    {
                        height: 152,
                        value: 2.2
                    },
                    {
                        height: 160,
                        value: 2.46
                    },
                    {
                        height: 168,
                        value: 2.75
                    },
                    {
                        height: 175,
                        value: 3.01
                    },
                    {
                        height: 183,
                        value: 3.32
                    },
                    {
                        height: 191,
                        value: 3.65
                    },
                    {
                        height: 198,
                        value: 3.95
                    },
                    {
                        height: 206,
                        value: 4.32
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.28
                    },
                    {
                        height: 130,
                        value: 1.47
                    },
                    {
                        height: 137,
                        value: 1.65
                    },
                    {
                        height: 145,
                        value: 1.87
                    },
                    {
                        height: 152,
                        value: 2.08
                    },
                    {
                        height: 160,
                        value: 2.33
                    },
                    {
                        height: 168,
                        value: 2.6
                    },
                    {
                        height: 175,
                        value: 2.84
                    },
                    {
                        height: 183,
                        value: 3.14
                    },
                    {
                        height: 191,
                        value: 3.45
                    },
                    {
                        height: 198,
                        value: 3.74
                    },
                    {
                        height: 206,
                        value: 4.08
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.21
                    },
                    {
                        height: 130,
                        value: 1.39
                    },
                    {
                        height: 137,
                        value: 1.56
                    },
                    {
                        height: 145,
                        value: 1.77
                    },
                    {
                        height: 152,
                        value: 1.97
                    },
                    {
                        height: 160,
                        value: 2.2
                    },
                    {
                        height: 168,
                        value: 2.45
                    },
                    {
                        height: 175,
                        value: 2.69
                    },
                    {
                        height: 183,
                        value: 2.97
                    },
                    {
                        height: 191,
                        value: 3.26
                    },
                    {
                        height: 198,
                        value: 3.53
                    },
                    {
                        height: 206,
                        value: 3.86
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.32
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.68
                    },
                    {
                        height: 152,
                        value: 1.86
                    },
                    {
                        height: 160,
                        value: 2.09
                    },
                    {
                        height: 168,
                        value: 2.32
                    },
                    {
                        height: 175,
                        value: 2.54
                    },
                    {
                        height: 183,
                        value: 2.81
                    },
                    {
                        height: 191,
                        value: 3.09
                    },
                    {
                        height: 198,
                        value: 3.35
                    },
                    {
                        height: 206,
                        value: 3.65
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.08
                    },
                    {
                        height: 130,
                        value: 1.25
                    },
                    {
                        height: 137,
                        value: 1.4
                    },
                    {
                        height: 145,
                        value: 1.59
                    },
                    {
                        height: 152,
                        value: 1.77
                    },
                    {
                        height: 160,
                        value: 1.98
                    },
                    {
                        height: 168,
                        value: 2.21
                    },
                    {
                        height: 175,
                        value: 2.42
                    },
                    {
                        height: 183,
                        value: 2.67
                    },
                    {
                        height: 191,
                        value: 2.93
                    },
                    {
                        height: 198,
                        value: 3.18
                    },
                    {
                        height: 206,
                        value: 3.47
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.03
                    },
                    {
                        height: 130,
                        value: 1.19
                    },
                    {
                        height: 137,
                        value: 1.34
                    },
                    {
                        height: 145,
                        value: 1.52
                    },
                    {
                        height: 152,
                        value: 1.68
                    },
                    {
                        height: 160,
                        value: 1.89
                    },
                    {
                        height: 168,
                        value: 2.1
                    },
                    {
                        height: 175,
                        value: 2.3
                    },
                    {
                        height: 183,
                        value: 2.54
                    },
                    {
                        height: 191,
                        value: 2.79
                    },
                    {
                        height: 198,
                        value: 3.03
                    },
                    {
                        height: 206,
                        value: 3.3
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.99
                    },
                    {
                        height: 130,
                        value: 1.14
                    },
                    {
                        height: 137,
                        value: 1.28
                    },
                    {
                        height: 145,
                        value: 1.45
                    },
                    {
                        height: 152,
                        value: 1.61
                    },
                    {
                        height: 160,
                        value: 1.8
                    },
                    {
                        height: 168,
                        value: 2.01
                    },
                    {
                        height: 175,
                        value: 2.2
                    },
                    {
                        height: 183,
                        value: 2.43
                    },
                    {
                        height: 191,
                        value: 2.67
                    },
                    {
                        height: 198,
                        value: 2.89
                    },
                    {
                        height: 206,
                        value: 3.16
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.87
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 0.94
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 0.94
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "South East Asian",
        gender: "Female",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.08
                    },
                    {
                        height: 122,
                        value: 1.26
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.63
                    },
                    {
                        height: 145,
                        value: 1.86
                    },
                    {
                        height: 152,
                        value: 2.07
                    },
                    {
                        height: 160,
                        value: 2.32
                    },
                    {
                        height: 168,
                        value: 2.59
                    },
                    {
                        height: 175,
                        value: 2.84
                    },
                    {
                        height: 183,
                        value: 3.15
                    },
                    {
                        height: 191,
                        value: 3.47
                    },
                    {
                        height: 198,
                        value: 3.76
                    },
                    {
                        height: 206,
                        value: 4.11
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.19
                    },
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.8
                    },
                    {
                        height: 145,
                        value: 2.05
                    },
                    {
                        height: 152,
                        value: 2.28
                    },
                    {
                        height: 160,
                        value: 2.56
                    },
                    {
                        height: 168,
                        value: 2.86
                    },
                    {
                        height: 175,
                        value: 3.13
                    },
                    {
                        height: 183,
                        value: 3.47
                    },
                    {
                        height: 191,
                        value: 3.82
                    },
                    {
                        height: 198,
                        value: 4.15
                    },
                    {
                        height: 206,
                        value: 4.53
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.39
                    },
                    {
                        height: 122,
                        value: 1.62
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.1
                    },
                    {
                        height: 145,
                        value: 2.39
                    },
                    {
                        height: 152,
                        value: 2.66
                    },
                    {
                        height: 160,
                        value: 2.98
                    },
                    {
                        height: 168,
                        value: 3.33
                    },
                    {
                        height: 175,
                        value: 3.65
                    },
                    {
                        height: 183,
                        value: 4.04
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.83
                    },
                    {
                        height: 206,
                        value: 5.29
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.46
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.21
                    },
                    {
                        height: 145,
                        value: 2.52
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.14
                    },
                    {
                        height: 168,
                        value: 3.51
                    },
                    {
                        height: 175,
                        value: 3.85
                    },
                    {
                        height: 183,
                        value: 4.26
                    },
                    {
                        height: 191,
                        value: 4.7
                    },
                    {
                        height: 198,
                        value: 5.09
                    },
                    {
                        height: 206,
                        value: 5.57
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.47
                    },
                    {
                        height: 122,
                        value: 1.71
                    },
                    {
                        height: 130,
                        value: 1.98
                    },
                    {
                        height: 137,
                        value: 2.22
                    },
                    {
                        height: 145,
                        value: 2.53
                    },
                    {
                        height: 152,
                        value: 2.81
                    },
                    {
                        height: 160,
                        value: 3.16
                    },
                    {
                        height: 168,
                        value: 3.53
                    },
                    {
                        height: 175,
                        value: 3.87
                    },
                    {
                        height: 183,
                        value: 4.28
                    },
                    {
                        height: 191,
                        value: 4.72
                    },
                    {
                        height: 198,
                        value: 5.12
                    },
                    {
                        height: 206,
                        value: 5.6
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.46
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.22
                    },
                    {
                        height: 145,
                        value: 2.52
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.15
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.86
                    },
                    {
                        height: 183,
                        value: 4.27
                    },
                    {
                        height: 191,
                        value: 4.7
                    },
                    {
                        height: 198,
                        value: 5.1
                    },
                    {
                        height: 206,
                        value: 5.58
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.45
                    },
                    {
                        height: 122,
                        value: 1.69
                    },
                    {
                        height: 130,
                        value: 1.95
                    },
                    {
                        height: 137,
                        value: 2.19
                    },
                    {
                        height: 145,
                        value: 2.49
                    },
                    {
                        height: 152,
                        value: 2.77
                    },
                    {
                        height: 160,
                        value: 3.12
                    },
                    {
                        height: 168,
                        value: 3.48
                    },
                    {
                        height: 175,
                        value: 3.82
                    },
                    {
                        height: 183,
                        value: 4.22
                    },
                    {
                        height: 191,
                        value: 4.65
                    },
                    {
                        height: 198,
                        value: 5.05
                    },
                    {
                        height: 206,
                        value: 5.52
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.42
                    },
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.91
                    },
                    {
                        height: 137,
                        value: 2.15
                    },
                    {
                        height: 145,
                        value: 2.44
                    },
                    {
                        height: 152,
                        value: 2.72
                    },
                    {
                        height: 160,
                        value: 3.05
                    },
                    {
                        height: 168,
                        value: 3.41
                    },
                    {
                        height: 175,
                        value: 3.74
                    },
                    {
                        height: 183,
                        value: 4.14
                    },
                    {
                        height: 191,
                        value: 4.56
                    },
                    {
                        height: 198,
                        value: 4.94
                    },
                    {
                        height: 206,
                        value: 5.41
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.38
                    },
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.85
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.37
                    },
                    {
                        height: 152,
                        value: 2.64
                    },
                    {
                        height: 160,
                        value: 2.97
                    },
                    {
                        height: 168,
                        value: 3.31
                    },
                    {
                        height: 175,
                        value: 3.63
                    },
                    {
                        height: 183,
                        value: 4.02
                    },
                    {
                        height: 191,
                        value: 4.43
                    },
                    {
                        height: 198,
                        value: 4.8
                    },
                    {
                        height: 206,
                        value: 5.25
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.33
                    },
                    {
                        height: 122,
                        value: 1.55
                    },
                    {
                        height: 130,
                        value: 1.79
                    },
                    {
                        height: 137,
                        value: 2.02
                    },
                    {
                        height: 145,
                        value: 2.29
                    },
                    {
                        height: 152,
                        value: 2.55
                    },
                    {
                        height: 160,
                        value: 2.86
                    },
                    {
                        height: 168,
                        value: 3.2
                    },
                    {
                        height: 175,
                        value: 3.51
                    },
                    {
                        height: 183,
                        value: 3.88
                    },
                    {
                        height: 191,
                        value: 4.27
                    },
                    {
                        height: 198,
                        value: 4.64
                    },
                    {
                        height: 206,
                        value: 5.07
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.28
                    },
                    {
                        height: 122,
                        value: 1.49
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.94
                    },
                    {
                        height: 145,
                        value: 2.2
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.07
                    },
                    {
                        height: 175,
                        value: 3.37
                    },
                    {
                        height: 183,
                        value: 3.73
                    },
                    {
                        height: 191,
                        value: 4.11
                    },
                    {
                        height: 198,
                        value: 4.45
                    },
                    {
                        height: 206,
                        value: 4.87
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.22
                    },
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.85
                    },
                    {
                        height: 145,
                        value: 2.1
                    },
                    {
                        height: 152,
                        value: 2.34
                    },
                    {
                        height: 160,
                        value: 2.63
                    },
                    {
                        height: 168,
                        value: 2.93
                    },
                    {
                        height: 175,
                        value: 3.22
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.92
                    },
                    {
                        height: 198,
                        value: 4.25
                    },
                    {
                        height: 206,
                        value: 4.65
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.16
                    },
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.56
                    },
                    {
                        height: 137,
                        value: 1.76
                    },
                    {
                        height: 145,
                        value: 2
                    },
                    {
                        height: 152,
                        value: 2.22
                    },
                    {
                        height: 160,
                        value: 2.5
                    },
                    {
                        height: 168,
                        value: 2.79
                    },
                    {
                        height: 175,
                        value: 3.06
                    },
                    {
                        height: 183,
                        value: 3.38
                    },
                    {
                        height: 191,
                        value: 3.73
                    },
                    {
                        height: 198,
                        value: 4.04
                    },
                    {
                        height: 206,
                        value: 4.42
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.1
                    },
                    {
                        height: 122,
                        value: 1.28
                    },
                    {
                        height: 130,
                        value: 1.48
                    },
                    {
                        height: 137,
                        value: 1.66
                    },
                    {
                        height: 145,
                        value: 1.89
                    },
                    {
                        height: 152,
                        value: 2.1
                    },
                    {
                        height: 160,
                        value: 2.36
                    },
                    {
                        height: 168,
                        value: 2.64
                    },
                    {
                        height: 175,
                        value: 2.89
                    },
                    {
                        height: 183,
                        value: 3.2
                    },
                    {
                        height: 191,
                        value: 3.53
                    },
                    {
                        height: 198,
                        value: 3.83
                    },
                    {
                        height: 206,
                        value: 4.19
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 1.04
                    },
                    {
                        height: 122,
                        value: 1.21
                    },
                    {
                        height: 130,
                        value: 1.39
                    },
                    {
                        height: 137,
                        value: 1.57
                    },
                    {
                        height: 145,
                        value: 1.79
                    },
                    {
                        height: 152,
                        value: 1.99
                    },
                    {
                        height: 160,
                        value: 2.23
                    },
                    {
                        height: 168,
                        value: 2.49
                    },
                    {
                        height: 175,
                        value: 2.73
                    },
                    {
                        height: 183,
                        value: 3.02
                    },
                    {
                        height: 191,
                        value: 3.33
                    },
                    {
                        height: 198,
                        value: 3.61
                    },
                    {
                        height: 206,
                        value: 3.95
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.98
                    },
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.32
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.69
                    },
                    {
                        height: 152,
                        value: 1.88
                    },
                    {
                        height: 160,
                        value: 2.11
                    },
                    {
                        height: 168,
                        value: 2.35
                    },
                    {
                        height: 175,
                        value: 2.58
                    },
                    {
                        height: 183,
                        value: 2.86
                    },
                    {
                        height: 191,
                        value: 3.15
                    },
                    {
                        height: 198,
                        value: 3.41
                    },
                    {
                        height: 206,
                        value: 3.74
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 1.08
                    },
                    {
                        height: 130,
                        value: 1.25
                    },
                    {
                        height: 137,
                        value: 1.41
                    },
                    {
                        height: 145,
                        value: 1.6
                    },
                    {
                        height: 152,
                        value: 1.78
                    },
                    {
                        height: 160,
                        value: 2
                    },
                    {
                        height: 168,
                        value: 2.23
                    },
                    {
                        height: 175,
                        value: 2.45
                    },
                    {
                        height: 183,
                        value: 2.71
                    },
                    {
                        height: 191,
                        value: 2.98
                    },
                    {
                        height: 198,
                        value: 3.23
                    },
                    {
                        height: 206,
                        value: 3.54
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 1.03
                    },
                    {
                        height: 130,
                        value: 1.19
                    },
                    {
                        height: 137,
                        value: 1.33
                    },
                    {
                        height: 145,
                        value: 1.52
                    },
                    {
                        height: 152,
                        value: 1.69
                    },
                    {
                        height: 160,
                        value: 1.9
                    },
                    {
                        height: 168,
                        value: 2.12
                    },
                    {
                        height: 175,
                        value: 2.32
                    },
                    {
                        height: 183,
                        value: 2.57
                    },
                    {
                        height: 191,
                        value: 2.83
                    },
                    {
                        height: 198,
                        value: 3.07
                    },
                    {
                        height: 206,
                        value: 3.36
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.98
                    },
                    {
                        height: 130,
                        value: 1.13
                    },
                    {
                        height: 137,
                        value: 1.27
                    },
                    {
                        height: 145,
                        value: 1.44
                    },
                    {
                        height: 152,
                        value: 1.61
                    },
                    {
                        height: 160,
                        value: 1.81
                    },
                    {
                        height: 168,
                        value: 2.02
                    },
                    {
                        height: 175,
                        value: 2.21
                    },
                    {
                        height: 183,
                        value: 2.45
                    },
                    {
                        height: 191,
                        value: 2.7
                    },
                    {
                        height: 198,
                        value: 2.92
                    },
                    {
                        height: 206,
                        value: 3.2
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.03
                    },
                    {
                        height: 122,
                        value: 1.19
                    },
                    {
                        height: 130,
                        value: 1.36
                    },
                    {
                        height: 137,
                        value: 1.52
                    },
                    {
                        height: 145,
                        value: 1.71
                    },
                    {
                        height: 152,
                        value: 1.89
                    },
                    {
                        height: 160,
                        value: 2.11
                    },
                    {
                        height: 168,
                        value: 2.34
                    },
                    {
                        height: 175,
                        value: 2.55
                    },
                    {
                        height: 183,
                        value: 2.81
                    },
                    {
                        height: 191,
                        value: 3.07
                    },
                    {
                        height: 198,
                        value: 3.32
                    },
                    {
                        height: 206,
                        value: 3.61
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.11
                    },
                    {
                        height: 122,
                        value: 1.29
                    },
                    {
                        height: 130,
                        value: 1.47
                    },
                    {
                        height: 137,
                        value: 1.64
                    },
                    {
                        height: 145,
                        value: 1.85
                    },
                    {
                        height: 152,
                        value: 2.05
                    },
                    {
                        height: 160,
                        value: 2.28
                    },
                    {
                        height: 168,
                        value: 2.53
                    },
                    {
                        height: 175,
                        value: 2.76
                    },
                    {
                        height: 183,
                        value: 3.04
                    },
                    {
                        height: 191,
                        value: 3.33
                    },
                    {
                        height: 198,
                        value: 3.59
                    },
                    {
                        height: 206,
                        value: 3.9
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.34
                    },
                    {
                        height: 122,
                        value: 1.55
                    },
                    {
                        height: 130,
                        value: 1.77
                    },
                    {
                        height: 137,
                        value: 1.98
                    },
                    {
                        height: 145,
                        value: 2.23
                    },
                    {
                        height: 152,
                        value: 2.46
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.05
                    },
                    {
                        height: 175,
                        value: 3.32
                    },
                    {
                        height: 183,
                        value: 3.65
                    },
                    {
                        height: 191,
                        value: 4
                    },
                    {
                        height: 198,
                        value: 4.32
                    },
                    {
                        height: 206,
                        value: 4.69
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.39
                    },
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.84
                    },
                    {
                        height: 137,
                        value: 2.05
                    },
                    {
                        height: 145,
                        value: 2.32
                    },
                    {
                        height: 152,
                        value: 2.56
                    },
                    {
                        height: 160,
                        value: 2.85
                    },
                    {
                        height: 168,
                        value: 3.16
                    },
                    {
                        height: 175,
                        value: 3.45
                    },
                    {
                        height: 183,
                        value: 3.79
                    },
                    {
                        height: 191,
                        value: 4.15
                    },
                    {
                        height: 198,
                        value: 4.48
                    },
                    {
                        height: 206,
                        value: 4.88
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.37
                    },
                    {
                        height: 122,
                        value: 1.58
                    },
                    {
                        height: 130,
                        value: 1.81
                    },
                    {
                        height: 137,
                        value: 2.02
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.52
                    },
                    {
                        height: 160,
                        value: 2.81
                    },
                    {
                        height: 168,
                        value: 3.12
                    },
                    {
                        height: 175,
                        value: 3.4
                    },
                    {
                        height: 183,
                        value: 3.74
                    },
                    {
                        height: 191,
                        value: 4.09
                    },
                    {
                        height: 198,
                        value: 4.42
                    },
                    {
                        height: 206,
                        value: 4.81
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.34
                    },
                    {
                        height: 122,
                        value: 1.55
                    },
                    {
                        height: 130,
                        value: 1.77
                    },
                    {
                        height: 137,
                        value: 1.98
                    },
                    {
                        height: 145,
                        value: 2.23
                    },
                    {
                        height: 152,
                        value: 2.47
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.05
                    },
                    {
                        height: 175,
                        value: 3.33
                    },
                    {
                        height: 183,
                        value: 3.66
                    },
                    {
                        height: 191,
                        value: 4.01
                    },
                    {
                        height: 198,
                        value: 4.33
                    },
                    {
                        height: 206,
                        value: 4.71
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.31
                    },
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.73
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.18
                    },
                    {
                        height: 152,
                        value: 2.4
                    },
                    {
                        height: 160,
                        value: 2.68
                    },
                    {
                        height: 168,
                        value: 2.97
                    },
                    {
                        height: 175,
                        value: 3.24
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.9
                    },
                    {
                        height: 198,
                        value: 4.21
                    },
                    {
                        height: 206,
                        value: 4.58
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.26
                    },
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.66
                    },
                    {
                        height: 137,
                        value: 1.86
                    },
                    {
                        height: 145,
                        value: 2.1
                    },
                    {
                        height: 152,
                        value: 2.32
                    },
                    {
                        height: 160,
                        value: 2.59
                    },
                    {
                        height: 168,
                        value: 2.87
                    },
                    {
                        height: 175,
                        value: 3.13
                    },
                    {
                        height: 183,
                        value: 3.44
                    },
                    {
                        height: 191,
                        value: 3.76
                    },
                    {
                        height: 198,
                        value: 4.06
                    },
                    {
                        height: 206,
                        value: 4.42
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.21
                    },
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.78
                    },
                    {
                        height: 145,
                        value: 2.01
                    },
                    {
                        height: 152,
                        value: 2.22
                    },
                    {
                        height: 160,
                        value: 2.48
                    },
                    {
                        height: 168,
                        value: 2.75
                    },
                    {
                        height: 175,
                        value: 3
                    },
                    {
                        height: 183,
                        value: 3.3
                    },
                    {
                        height: 191,
                        value: 3.61
                    },
                    {
                        height: 198,
                        value: 3.89
                    },
                    {
                        height: 206,
                        value: 4.24
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.15
                    },
                    {
                        height: 122,
                        value: 1.33
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.71
                    },
                    {
                        height: 145,
                        value: 1.92
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.37
                    },
                    {
                        height: 168,
                        value: 2.63
                    },
                    {
                        height: 175,
                        value: 2.87
                    },
                    {
                        height: 183,
                        value: 3.15
                    },
                    {
                        height: 191,
                        value: 3.45
                    },
                    {
                        height: 198,
                        value: 3.72
                    },
                    {
                        height: 206,
                        value: 4.05
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.1
                    },
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.62
                    },
                    {
                        height: 145,
                        value: 1.83
                    },
                    {
                        height: 152,
                        value: 2.03
                    },
                    {
                        height: 160,
                        value: 2.26
                    },
                    {
                        height: 168,
                        value: 2.5
                    },
                    {
                        height: 175,
                        value: 2.73
                    },
                    {
                        height: 183,
                        value: 3
                    },
                    {
                        height: 191,
                        value: 3.29
                    },
                    {
                        height: 198,
                        value: 3.55
                    },
                    {
                        height: 206,
                        value: 3.86
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.04
                    },
                    {
                        height: 122,
                        value: 1.2
                    },
                    {
                        height: 130,
                        value: 1.38
                    },
                    {
                        height: 137,
                        value: 1.54
                    },
                    {
                        height: 145,
                        value: 1.74
                    },
                    {
                        height: 152,
                        value: 1.92
                    },
                    {
                        height: 160,
                        value: 2.14
                    },
                    {
                        height: 168,
                        value: 2.37
                    },
                    {
                        height: 175,
                        value: 2.59
                    },
                    {
                        height: 183,
                        value: 2.85
                    },
                    {
                        height: 191,
                        value: 3.12
                    },
                    {
                        height: 198,
                        value: 3.36
                    },
                    {
                        height: 206,
                        value: 3.66
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.98
                    },
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.3
                    },
                    {
                        height: 137,
                        value: 1.45
                    },
                    {
                        height: 145,
                        value: 1.64
                    },
                    {
                        height: 152,
                        value: 1.81
                    },
                    {
                        height: 160,
                        value: 2.02
                    },
                    {
                        height: 168,
                        value: 2.24
                    },
                    {
                        height: 175,
                        value: 2.44
                    },
                    {
                        height: 183,
                        value: 2.68
                    },
                    {
                        height: 191,
                        value: 2.94
                    },
                    {
                        height: 198,
                        value: 3.17
                    },
                    {
                        height: 206,
                        value: 3.45
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 1.06
                    },
                    {
                        height: 130,
                        value: 1.22
                    },
                    {
                        height: 137,
                        value: 1.36
                    },
                    {
                        height: 145,
                        value: 1.54
                    },
                    {
                        height: 152,
                        value: 1.7
                    },
                    {
                        height: 160,
                        value: 1.89
                    },
                    {
                        height: 168,
                        value: 2.1
                    },
                    {
                        height: 175,
                        value: 2.29
                    },
                    {
                        height: 183,
                        value: 2.52
                    },
                    {
                        height: 191,
                        value: 2.76
                    },
                    {
                        height: 198,
                        value: 2.97
                    },
                    {
                        height: 206,
                        value: 3.24
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 1
                    },
                    {
                        height: 130,
                        value: 1.14
                    },
                    {
                        height: 137,
                        value: 1.27
                    },
                    {
                        height: 145,
                        value: 1.44
                    },
                    {
                        height: 152,
                        value: 1.59
                    },
                    {
                        height: 160,
                        value: 1.77
                    },
                    {
                        height: 168,
                        value: 1.96
                    },
                    {
                        height: 175,
                        value: 2.14
                    },
                    {
                        height: 183,
                        value: 2.35
                    },
                    {
                        height: 191,
                        value: 2.58
                    },
                    {
                        height: 198,
                        value: 2.78
                    },
                    {
                        height: 206,
                        value: 3.03
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 1.07
                    },
                    {
                        height: 137,
                        value: 1.19
                    },
                    {
                        height: 145,
                        value: 1.34
                    },
                    {
                        height: 152,
                        value: 1.49
                    },
                    {
                        height: 160,
                        value: 1.66
                    },
                    {
                        height: 168,
                        value: 1.84
                    },
                    {
                        height: 175,
                        value: 2
                    },
                    {
                        height: 183,
                        value: 2.2
                    },
                    {
                        height: 191,
                        value: 2.41
                    },
                    {
                        height: 198,
                        value: 2.6
                    },
                    {
                        height: 206,
                        value: 2.83
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.76
                    },
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 1
                    },
                    {
                        height: 137,
                        value: 1.12
                    },
                    {
                        height: 145,
                        value: 1.26
                    },
                    {
                        height: 152,
                        value: 1.39
                    },
                    {
                        height: 160,
                        value: 1.55
                    },
                    {
                        height: 168,
                        value: 1.72
                    },
                    {
                        height: 175,
                        value: 1.88
                    },
                    {
                        height: 183,
                        value: 2.07
                    },
                    {
                        height: 191,
                        value: 2.26
                    },
                    {
                        height: 198,
                        value: 2.44
                    },
                    {
                        height: 206,
                        value: 2.65
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.71
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.94
                    },
                    {
                        height: 137,
                        value: 1.05
                    },
                    {
                        height: 145,
                        value: 1.19
                    },
                    {
                        height: 152,
                        value: 1.31
                    },
                    {
                        height: 160,
                        value: 1.46
                    },
                    {
                        height: 168,
                        value: 1.62
                    },
                    {
                        height: 175,
                        value: 1.77
                    },
                    {
                        height: 183,
                        value: 1.94
                    },
                    {
                        height: 191,
                        value: 2.13
                    },
                    {
                        height: 198,
                        value: 2.3
                    },
                    {
                        height: 206,
                        value: 2.5
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.67
                    },
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.99
                    },
                    {
                        height: 145,
                        value: 1.12
                    },
                    {
                        height: 152,
                        value: 1.24
                    },
                    {
                        height: 160,
                        value: 1.38
                    },
                    {
                        height: 168,
                        value: 1.53
                    },
                    {
                        height: 175,
                        value: 1.67
                    },
                    {
                        height: 183,
                        value: 1.83
                    },
                    {
                        height: 191,
                        value: 2.01
                    },
                    {
                        height: 198,
                        value: 2.17
                    },
                    {
                        height: 206,
                        value: 2.36
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 0.96
                    },
                    {
                        height: 122,
                        value: 0.95
                    },
                    {
                        height: 130,
                        value: 0.95
                    },
                    {
                        height: 137,
                        value: 0.94
                    },
                    {
                        height: 145,
                        value: 0.93
                    },
                    {
                        height: 152,
                        value: 0.93
                    },
                    {
                        height: 160,
                        value: 0.92
                    },
                    {
                        height: 168,
                        value: 0.92
                    },
                    {
                        height: 175,
                        value: 0.92
                    },
                    {
                        height: 183,
                        value: 0.91
                    },
                    {
                        height: 191,
                        value: 0.91
                    },
                    {
                        height: 198,
                        value: 0.9
                    },
                    {
                        height: 206,
                        value: 0.9
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 0.96
                    },
                    {
                        height: 122,
                        value: 0.95
                    },
                    {
                        height: 130,
                        value: 0.94
                    },
                    {
                        height: 137,
                        value: 0.94
                    },
                    {
                        height: 145,
                        value: 0.93
                    },
                    {
                        height: 152,
                        value: 0.93
                    },
                    {
                        height: 160,
                        value: 0.92
                    },
                    {
                        height: 168,
                        value: 0.92
                    },
                    {
                        height: 175,
                        value: 0.91
                    },
                    {
                        height: 183,
                        value: 0.91
                    },
                    {
                        height: 191,
                        value: 0.91
                    },
                    {
                        height: 198,
                        value: 0.9
                    },
                    {
                        height: 206,
                        value: 0.9
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 0.95
                    },
                    {
                        height: 122,
                        value: 0.94
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.93
                    },
                    {
                        height: 145,
                        value: 0.92
                    },
                    {
                        height: 152,
                        value: 0.92
                    },
                    {
                        height: 160,
                        value: 0.91
                    },
                    {
                        height: 168,
                        value: 0.91
                    },
                    {
                        height: 175,
                        value: 0.9
                    },
                    {
                        height: 183,
                        value: 0.9
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.89
                    },
                    {
                        height: 206,
                        value: 0.89
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.9
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 0.89
                    },
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 0.87
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "North East Asian",
        gender: "Male",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.75
                    },
                    {
                        height: 137,
                        value: 1.99
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.55
                    },
                    {
                        height: 160,
                        value: 2.89
                    },
                    {
                        height: 168,
                        value: 3.25
                    },
                    {
                        height: 175,
                        value: 3.59
                    },
                    {
                        height: 183,
                        value: 3.99
                    },
                    {
                        height: 191,
                        value: 4.43
                    },
                    {
                        height: 198,
                        value: 4.83
                    },
                    {
                        height: 206,
                        value: 5.32
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.62
                    },
                    {
                        height: 130,
                        value: 1.89
                    },
                    {
                        height: 137,
                        value: 2.14
                    },
                    {
                        height: 145,
                        value: 2.46
                    },
                    {
                        height: 152,
                        value: 2.76
                    },
                    {
                        height: 160,
                        value: 3.12
                    },
                    {
                        height: 168,
                        value: 3.51
                    },
                    {
                        height: 175,
                        value: 3.87
                    },
                    {
                        height: 183,
                        value: 4.31
                    },
                    {
                        height: 191,
                        value: 4.78
                    },
                    {
                        height: 198,
                        value: 5.22
                    },
                    {
                        height: 206,
                        value: 5.74
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.19
                    },
                    {
                        height: 137,
                        value: 2.48
                    },
                    {
                        height: 145,
                        value: 2.85
                    },
                    {
                        height: 152,
                        value: 3.19
                    },
                    {
                        height: 160,
                        value: 3.61
                    },
                    {
                        height: 168,
                        value: 4.06
                    },
                    {
                        height: 175,
                        value: 4.48
                    },
                    {
                        height: 183,
                        value: 4.99
                    },
                    {
                        height: 191,
                        value: 5.54
                    },
                    {
                        height: 198,
                        value: 6.04
                    },
                    {
                        height: 206,
                        value: 6.64
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 2.12
                    },
                    {
                        height: 130,
                        value: 2.47
                    },
                    {
                        height: 137,
                        value: 2.81
                    },
                    {
                        height: 145,
                        value: 3.22
                    },
                    {
                        height: 152,
                        value: 3.61
                    },
                    {
                        height: 160,
                        value: 4.08
                    },
                    {
                        height: 168,
                        value: 4.59
                    },
                    {
                        height: 175,
                        value: 5.07
                    },
                    {
                        height: 183,
                        value: 5.65
                    },
                    {
                        height: 191,
                        value: 6.26
                    },
                    {
                        height: 198,
                        value: 6.83
                    },
                    {
                        height: 206,
                        value: 7.51
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 2.14
                    },
                    {
                        height: 130,
                        value: 2.5
                    },
                    {
                        height: 137,
                        value: 2.83
                    },
                    {
                        height: 145,
                        value: 3.25
                    },
                    {
                        height: 152,
                        value: 3.64
                    },
                    {
                        height: 160,
                        value: 4.12
                    },
                    {
                        height: 168,
                        value: 4.63
                    },
                    {
                        height: 175,
                        value: 5.11
                    },
                    {
                        height: 183,
                        value: 5.7
                    },
                    {
                        height: 191,
                        value: 6.32
                    },
                    {
                        height: 198,
                        value: 6.89
                    },
                    {
                        height: 206,
                        value: 7.58
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 2.11
                    },
                    {
                        height: 130,
                        value: 2.46
                    },
                    {
                        height: 137,
                        value: 2.79
                    },
                    {
                        height: 145,
                        value: 3.2
                    },
                    {
                        height: 152,
                        value: 3.58
                    },
                    {
                        height: 160,
                        value: 4.06
                    },
                    {
                        height: 168,
                        value: 4.56
                    },
                    {
                        height: 175,
                        value: 5.04
                    },
                    {
                        height: 183,
                        value: 5.61
                    },
                    {
                        height: 191,
                        value: 6.22
                    },
                    {
                        height: 198,
                        value: 6.78
                    },
                    {
                        height: 206,
                        value: 7.47
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 2.07
                    },
                    {
                        height: 130,
                        value: 2.41
                    },
                    {
                        height: 137,
                        value: 2.74
                    },
                    {
                        height: 145,
                        value: 3.14
                    },
                    {
                        height: 152,
                        value: 3.52
                    },
                    {
                        height: 160,
                        value: 3.98
                    },
                    {
                        height: 168,
                        value: 4.48
                    },
                    {
                        height: 175,
                        value: 4.95
                    },
                    {
                        height: 183,
                        value: 5.51
                    },
                    {
                        height: 191,
                        value: 6.11
                    },
                    {
                        height: 198,
                        value: 6.66
                    },
                    {
                        height: 206,
                        value: 7.33
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 2.03
                    },
                    {
                        height: 130,
                        value: 2.37
                    },
                    {
                        height: 137,
                        value: 2.69
                    },
                    {
                        height: 145,
                        value: 3.08
                    },
                    {
                        height: 152,
                        value: 3.45
                    },
                    {
                        height: 160,
                        value: 3.91
                    },
                    {
                        height: 168,
                        value: 4.4
                    },
                    {
                        height: 175,
                        value: 4.85
                    },
                    {
                        height: 183,
                        value: 5.41
                    },
                    {
                        height: 191,
                        value: 6
                    },
                    {
                        height: 198,
                        value: 6.54
                    },
                    {
                        height: 206,
                        value: 7.2
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.98
                    },
                    {
                        height: 130,
                        value: 2.31
                    },
                    {
                        height: 137,
                        value: 2.63
                    },
                    {
                        height: 145,
                        value: 3.01
                    },
                    {
                        height: 152,
                        value: 3.37
                    },
                    {
                        height: 160,
                        value: 3.82
                    },
                    {
                        height: 168,
                        value: 4.3
                    },
                    {
                        height: 175,
                        value: 4.74
                    },
                    {
                        height: 183,
                        value: 5.28
                    },
                    {
                        height: 191,
                        value: 5.86
                    },
                    {
                        height: 198,
                        value: 6.39
                    },
                    {
                        height: 206,
                        value: 7.03
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.93
                    },
                    {
                        height: 130,
                        value: 2.25
                    },
                    {
                        height: 137,
                        value: 2.55
                    },
                    {
                        height: 145,
                        value: 2.93
                    },
                    {
                        height: 152,
                        value: 3.28
                    },
                    {
                        height: 160,
                        value: 3.71
                    },
                    {
                        height: 168,
                        value: 4.18
                    },
                    {
                        height: 175,
                        value: 4.61
                    },
                    {
                        height: 183,
                        value: 5.14
                    },
                    {
                        height: 191,
                        value: 5.69
                    },
                    {
                        height: 198,
                        value: 6.21
                    },
                    {
                        height: 206,
                        value: 6.83
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.18
                    },
                    {
                        height: 137,
                        value: 2.47
                    },
                    {
                        height: 145,
                        value: 2.83
                    },
                    {
                        height: 152,
                        value: 3.17
                    },
                    {
                        height: 160,
                        value: 3.59
                    },
                    {
                        height: 168,
                        value: 4.04
                    },
                    {
                        height: 175,
                        value: 4.46
                    },
                    {
                        height: 183,
                        value: 4.97
                    },
                    {
                        height: 191,
                        value: 5.51
                    },
                    {
                        height: 198,
                        value: 6.01
                    },
                    {
                        height: 206,
                        value: 6.61
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.8
                    },
                    {
                        height: 130,
                        value: 2.09
                    },
                    {
                        height: 137,
                        value: 2.38
                    },
                    {
                        height: 145,
                        value: 2.73
                    },
                    {
                        height: 152,
                        value: 3.05
                    },
                    {
                        height: 160,
                        value: 3.46
                    },
                    {
                        height: 168,
                        value: 3.89
                    },
                    {
                        height: 175,
                        value: 4.29
                    },
                    {
                        height: 183,
                        value: 4.78
                    },
                    {
                        height: 191,
                        value: 5.3
                    },
                    {
                        height: 198,
                        value: 5.78
                    },
                    {
                        height: 206,
                        value: 6.36
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 2
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.61
                    },
                    {
                        height: 152,
                        value: 2.92
                    },
                    {
                        height: 160,
                        value: 3.31
                    },
                    {
                        height: 168,
                        value: 3.72
                    },
                    {
                        height: 175,
                        value: 4.11
                    },
                    {
                        height: 183,
                        value: 4.58
                    },
                    {
                        height: 191,
                        value: 5.07
                    },
                    {
                        height: 198,
                        value: 5.53
                    },
                    {
                        height: 206,
                        value: 6.09
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.64
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.18
                    },
                    {
                        height: 145,
                        value: 2.5
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.16
                    },
                    {
                        height: 168,
                        value: 3.56
                    },
                    {
                        height: 175,
                        value: 3.93
                    },
                    {
                        height: 183,
                        value: 4.38
                    },
                    {
                        height: 191,
                        value: 4.85
                    },
                    {
                        height: 198,
                        value: 5.29
                    },
                    {
                        height: 206,
                        value: 5.82
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.57
                    },
                    {
                        height: 130,
                        value: 1.83
                    },
                    {
                        height: 137,
                        value: 2.08
                    },
                    {
                        height: 145,
                        value: 2.39
                    },
                    {
                        height: 152,
                        value: 2.67
                    },
                    {
                        height: 160,
                        value: 3.03
                    },
                    {
                        height: 168,
                        value: 3.4
                    },
                    {
                        height: 175,
                        value: 3.76
                    },
                    {
                        height: 183,
                        value: 4.18
                    },
                    {
                        height: 191,
                        value: 4.64
                    },
                    {
                        height: 198,
                        value: 5.06
                    },
                    {
                        height: 206,
                        value: 5.57
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 1.99
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.56
                    },
                    {
                        height: 160,
                        value: 2.9
                    },
                    {
                        height: 168,
                        value: 3.26
                    },
                    {
                        height: 175,
                        value: 3.6
                    },
                    {
                        height: 183,
                        value: 4.01
                    },
                    {
                        height: 191,
                        value: 4.44
                    },
                    {
                        height: 198,
                        value: 4.85
                    },
                    {
                        height: 206,
                        value: 5.33
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.44
                    },
                    {
                        height: 130,
                        value: 1.68
                    },
                    {
                        height: 137,
                        value: 1.91
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.46
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.13
                    },
                    {
                        height: 175,
                        value: 3.45
                    },
                    {
                        height: 183,
                        value: 3.84
                    },
                    {
                        height: 191,
                        value: 4.26
                    },
                    {
                        height: 198,
                        value: 4.65
                    },
                    {
                        height: 206,
                        value: 5.12
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.36
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 3.01
                    },
                    {
                        height: 175,
                        value: 3.32
                    },
                    {
                        height: 183,
                        value: 3.7
                    },
                    {
                        height: 191,
                        value: 4.1
                    },
                    {
                        height: 198,
                        value: 4.47
                    },
                    {
                        height: 206,
                        value: 4.92
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.34
                    },
                    {
                        height: 130,
                        value: 1.56
                    },
                    {
                        height: 137,
                        value: 1.77
                    },
                    {
                        height: 145,
                        value: 2.03
                    },
                    {
                        height: 152,
                        value: 2.28
                    },
                    {
                        height: 160,
                        value: 2.58
                    },
                    {
                        height: 168,
                        value: 2.9
                    },
                    {
                        height: 175,
                        value: 3.2
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.95
                    },
                    {
                        height: 198,
                        value: 4.31
                    },
                    {
                        height: 206,
                        value: 4.74
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.56
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 1.99
                    },
                    {
                        height: 152,
                        value: 2.21
                    },
                    {
                        height: 160,
                        value: 2.47
                    },
                    {
                        height: 168,
                        value: 2.75
                    },
                    {
                        height: 175,
                        value: 3.02
                    },
                    {
                        height: 183,
                        value: 3.33
                    },
                    {
                        height: 191,
                        value: 3.66
                    },
                    {
                        height: 198,
                        value: 3.97
                    },
                    {
                        height: 206,
                        value: 4.33
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.44
                    },
                    {
                        height: 130,
                        value: 1.66
                    },
                    {
                        height: 137,
                        value: 1.86
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.34
                    },
                    {
                        height: 160,
                        value: 2.62
                    },
                    {
                        height: 168,
                        value: 2.93
                    },
                    {
                        height: 175,
                        value: 3.2
                    },
                    {
                        height: 183,
                        value: 3.54
                    },
                    {
                        height: 191,
                        value: 3.89
                    },
                    {
                        height: 198,
                        value: 4.21
                    },
                    {
                        height: 206,
                        value: 4.6
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.73
                    },
                    {
                        height: 130,
                        value: 1.99
                    },
                    {
                        height: 137,
                        value: 2.24
                    },
                    {
                        height: 145,
                        value: 2.54
                    },
                    {
                        height: 152,
                        value: 2.82
                    },
                    {
                        height: 160,
                        value: 3.16
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.85
                    },
                    {
                        height: 183,
                        value: 4.26
                    },
                    {
                        height: 191,
                        value: 4.68
                    },
                    {
                        height: 198,
                        value: 5.07
                    },
                    {
                        height: 206,
                        value: 5.53
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.95
                    },
                    {
                        height: 130,
                        value: 2.24
                    },
                    {
                        height: 137,
                        value: 2.52
                    },
                    {
                        height: 145,
                        value: 2.86
                    },
                    {
                        height: 152,
                        value: 3.17
                    },
                    {
                        height: 160,
                        value: 3.55
                    },
                    {
                        height: 168,
                        value: 3.96
                    },
                    {
                        height: 175,
                        value: 4.33
                    },
                    {
                        height: 183,
                        value: 4.79
                    },
                    {
                        height: 191,
                        value: 5.26
                    },
                    {
                        height: 198,
                        value: 5.7
                    },
                    {
                        height: 206,
                        value: 6.23
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.94
                    },
                    {
                        height: 130,
                        value: 2.23
                    },
                    {
                        height: 137,
                        value: 2.5
                    },
                    {
                        height: 145,
                        value: 2.84
                    },
                    {
                        height: 152,
                        value: 3.15
                    },
                    {
                        height: 160,
                        value: 3.53
                    },
                    {
                        height: 168,
                        value: 3.94
                    },
                    {
                        height: 175,
                        value: 4.31
                    },
                    {
                        height: 183,
                        value: 4.76
                    },
                    {
                        height: 191,
                        value: 5.24
                    },
                    {
                        height: 198,
                        value: 5.67
                    },
                    {
                        height: 206,
                        value: 6.19
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.43
                    },
                    {
                        height: 145,
                        value: 2.76
                    },
                    {
                        height: 152,
                        value: 3.06
                    },
                    {
                        height: 160,
                        value: 3.43
                    },
                    {
                        height: 168,
                        value: 3.82
                    },
                    {
                        height: 175,
                        value: 4.18
                    },
                    {
                        height: 183,
                        value: 4.62
                    },
                    {
                        height: 191,
                        value: 5.08
                    },
                    {
                        height: 198,
                        value: 5.5
                    },
                    {
                        height: 206,
                        value: 6.01
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.82
                    },
                    {
                        height: 130,
                        value: 2.1
                    },
                    {
                        height: 137,
                        value: 2.36
                    },
                    {
                        height: 145,
                        value: 2.68
                    },
                    {
                        height: 152,
                        value: 2.97
                    },
                    {
                        height: 160,
                        value: 3.33
                    },
                    {
                        height: 168,
                        value: 3.71
                    },
                    {
                        height: 175,
                        value: 4.06
                    },
                    {
                        height: 183,
                        value: 4.49
                    },
                    {
                        height: 191,
                        value: 4.94
                    },
                    {
                        height: 198,
                        value: 5.35
                    },
                    {
                        height: 206,
                        value: 5.84
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.77
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.29
                    },
                    {
                        height: 145,
                        value: 2.59
                    },
                    {
                        height: 152,
                        value: 2.88
                    },
                    {
                        height: 160,
                        value: 3.23
                    },
                    {
                        height: 168,
                        value: 3.6
                    },
                    {
                        height: 175,
                        value: 3.94
                    },
                    {
                        height: 183,
                        value: 4.35
                    },
                    {
                        height: 191,
                        value: 4.78
                    },
                    {
                        height: 198,
                        value: 5.18
                    },
                    {
                        height: 206,
                        value: 5.65
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.71
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.21
                    },
                    {
                        height: 145,
                        value: 2.5
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.12
                    },
                    {
                        height: 168,
                        value: 3.47
                    },
                    {
                        height: 175,
                        value: 3.8
                    },
                    {
                        height: 183,
                        value: 4.2
                    },
                    {
                        height: 191,
                        value: 4.62
                    },
                    {
                        height: 198,
                        value: 5
                    },
                    {
                        height: 206,
                        value: 5.46
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.89
                    },
                    {
                        height: 137,
                        value: 2.13
                    },
                    {
                        height: 145,
                        value: 2.41
                    },
                    {
                        height: 152,
                        value: 2.68
                    },
                    {
                        height: 160,
                        value: 3
                    },
                    {
                        height: 168,
                        value: 3.35
                    },
                    {
                        height: 175,
                        value: 3.66
                    },
                    {
                        height: 183,
                        value: 4.05
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.82
                    },
                    {
                        height: 206,
                        value: 5.26
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.58
                    },
                    {
                        height: 130,
                        value: 1.82
                    },
                    {
                        height: 137,
                        value: 2.04
                    },
                    {
                        height: 145,
                        value: 2.31
                    },
                    {
                        height: 152,
                        value: 2.57
                    },
                    {
                        height: 160,
                        value: 2.88
                    },
                    {
                        height: 168,
                        value: 3.21
                    },
                    {
                        height: 175,
                        value: 3.51
                    },
                    {
                        height: 183,
                        value: 3.88
                    },
                    {
                        height: 191,
                        value: 4.27
                    },
                    {
                        height: 198,
                        value: 4.62
                    },
                    {
                        height: 206,
                        value: 5.04
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.73
                    },
                    {
                        height: 137,
                        value: 1.94
                    },
                    {
                        height: 145,
                        value: 2.2
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.74
                    },
                    {
                        height: 168,
                        value: 3.06
                    },
                    {
                        height: 175,
                        value: 3.34
                    },
                    {
                        height: 183,
                        value: 3.69
                    },
                    {
                        height: 191,
                        value: 4.06
                    },
                    {
                        height: 198,
                        value: 4.4
                    },
                    {
                        height: 206,
                        value: 4.8
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.09
                    },
                    {
                        height: 152,
                        value: 2.32
                    },
                    {
                        height: 160,
                        value: 2.6
                    },
                    {
                        height: 168,
                        value: 2.89
                    },
                    {
                        height: 175,
                        value: 3.17
                    },
                    {
                        height: 183,
                        value: 3.5
                    },
                    {
                        height: 191,
                        value: 3.85
                    },
                    {
                        height: 198,
                        value: 4.17
                    },
                    {
                        height: 206,
                        value: 4.55
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.74
                    },
                    {
                        height: 145,
                        value: 1.97
                    },
                    {
                        height: 152,
                        value: 2.19
                    },
                    {
                        height: 160,
                        value: 2.46
                    },
                    {
                        height: 168,
                        value: 2.74
                    },
                    {
                        height: 175,
                        value: 3
                    },
                    {
                        height: 183,
                        value: 3.31
                    },
                    {
                        height: 191,
                        value: 3.64
                    },
                    {
                        height: 198,
                        value: 3.94
                    },
                    {
                        height: 206,
                        value: 4.3
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.46
                    },
                    {
                        height: 137,
                        value: 1.65
                    },
                    {
                        height: 145,
                        value: 1.87
                    },
                    {
                        height: 152,
                        value: 2.07
                    },
                    {
                        height: 160,
                        value: 2.32
                    },
                    {
                        height: 168,
                        value: 2.59
                    },
                    {
                        height: 175,
                        value: 2.83
                    },
                    {
                        height: 183,
                        value: 3.13
                    },
                    {
                        height: 191,
                        value: 3.44
                    },
                    {
                        height: 198,
                        value: 3.73
                    },
                    {
                        height: 206,
                        value: 4.07
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.2
                    },
                    {
                        height: 130,
                        value: 1.39
                    },
                    {
                        height: 137,
                        value: 1.56
                    },
                    {
                        height: 145,
                        value: 1.77
                    },
                    {
                        height: 152,
                        value: 1.96
                    },
                    {
                        height: 160,
                        value: 2.2
                    },
                    {
                        height: 168,
                        value: 2.45
                    },
                    {
                        height: 175,
                        value: 2.68
                    },
                    {
                        height: 183,
                        value: 2.96
                    },
                    {
                        height: 191,
                        value: 3.26
                    },
                    {
                        height: 198,
                        value: 3.53
                    },
                    {
                        height: 206,
                        value: 3.85
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.32
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.68
                    },
                    {
                        height: 152,
                        value: 1.86
                    },
                    {
                        height: 160,
                        value: 2.09
                    },
                    {
                        height: 168,
                        value: 2.33
                    },
                    {
                        height: 175,
                        value: 2.55
                    },
                    {
                        height: 183,
                        value: 2.81
                    },
                    {
                        height: 191,
                        value: 3.09
                    },
                    {
                        height: 198,
                        value: 3.35
                    },
                    {
                        height: 206,
                        value: 3.66
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.09
                    },
                    {
                        height: 130,
                        value: 1.25
                    },
                    {
                        height: 137,
                        value: 1.41
                    },
                    {
                        height: 145,
                        value: 1.6
                    },
                    {
                        height: 152,
                        value: 1.77
                    },
                    {
                        height: 160,
                        value: 1.99
                    },
                    {
                        height: 168,
                        value: 2.22
                    },
                    {
                        height: 175,
                        value: 2.43
                    },
                    {
                        height: 183,
                        value: 2.68
                    },
                    {
                        height: 191,
                        value: 2.95
                    },
                    {
                        height: 198,
                        value: 3.19
                    },
                    {
                        height: 206,
                        value: 3.48
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.04
                    },
                    {
                        height: 130,
                        value: 1.2
                    },
                    {
                        height: 137,
                        value: 1.35
                    },
                    {
                        height: 145,
                        value: 1.53
                    },
                    {
                        height: 152,
                        value: 1.69
                    },
                    {
                        height: 160,
                        value: 1.9
                    },
                    {
                        height: 168,
                        value: 2.12
                    },
                    {
                        height: 175,
                        value: 2.32
                    },
                    {
                        height: 183,
                        value: 2.56
                    },
                    {
                        height: 191,
                        value: 2.81
                    },
                    {
                        height: 198,
                        value: 3.05
                    },
                    {
                        height: 206,
                        value: 3.33
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.76
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.77
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.76
                    },
                    {
                        height: 152,
                        value: 0.75
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.74
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.73
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.72
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "North East Asian",
        gender: "Female",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.22
                    },
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.85
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.34
                    },
                    {
                        height: 160,
                        value: 2.63
                    },
                    {
                        height: 168,
                        value: 2.94
                    },
                    {
                        height: 175,
                        value: 3.22
                    },
                    {
                        height: 183,
                        value: 3.57
                    },
                    {
                        height: 191,
                        value: 3.93
                    },
                    {
                        height: 198,
                        value: 4.26
                    },
                    {
                        height: 206,
                        value: 4.66
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.35
                    },
                    {
                        height: 122,
                        value: 1.57
                    },
                    {
                        height: 130,
                        value: 1.81
                    },
                    {
                        height: 137,
                        value: 2.04
                    },
                    {
                        height: 145,
                        value: 2.32
                    },
                    {
                        height: 152,
                        value: 2.58
                    },
                    {
                        height: 160,
                        value: 2.9
                    },
                    {
                        height: 168,
                        value: 3.24
                    },
                    {
                        height: 175,
                        value: 3.55
                    },
                    {
                        height: 183,
                        value: 3.93
                    },
                    {
                        height: 191,
                        value: 4.33
                    },
                    {
                        height: 198,
                        value: 4.7
                    },
                    {
                        height: 206,
                        value: 5.14
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.57
                    },
                    {
                        height: 122,
                        value: 1.83
                    },
                    {
                        height: 130,
                        value: 2.11
                    },
                    {
                        height: 137,
                        value: 2.38
                    },
                    {
                        height: 145,
                        value: 2.71
                    },
                    {
                        height: 152,
                        value: 3.01
                    },
                    {
                        height: 160,
                        value: 3.38
                    },
                    {
                        height: 168,
                        value: 3.78
                    },
                    {
                        height: 175,
                        value: 4.14
                    },
                    {
                        height: 183,
                        value: 4.58
                    },
                    {
                        height: 191,
                        value: 5.05
                    },
                    {
                        height: 198,
                        value: 5.48
                    },
                    {
                        height: 206,
                        value: 5.99
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.66
                    },
                    {
                        height: 122,
                        value: 1.93
                    },
                    {
                        height: 130,
                        value: 2.23
                    },
                    {
                        height: 137,
                        value: 2.51
                    },
                    {
                        height: 145,
                        value: 2.85
                    },
                    {
                        height: 152,
                        value: 3.17
                    },
                    {
                        height: 160,
                        value: 3.57
                    },
                    {
                        height: 168,
                        value: 3.98
                    },
                    {
                        height: 175,
                        value: 4.37
                    },
                    {
                        height: 183,
                        value: 4.83
                    },
                    {
                        height: 191,
                        value: 5.32
                    },
                    {
                        height: 198,
                        value: 5.77
                    },
                    {
                        height: 206,
                        value: 6.32
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.66
                    },
                    {
                        height: 122,
                        value: 1.94
                    },
                    {
                        height: 130,
                        value: 2.24
                    },
                    {
                        height: 137,
                        value: 2.52
                    },
                    {
                        height: 145,
                        value: 2.87
                    },
                    {
                        height: 152,
                        value: 3.19
                    },
                    {
                        height: 160,
                        value: 3.58
                    },
                    {
                        height: 168,
                        value: 4
                    },
                    {
                        height: 175,
                        value: 4.39
                    },
                    {
                        height: 183,
                        value: 4.86
                    },
                    {
                        height: 191,
                        value: 5.35
                    },
                    {
                        height: 198,
                        value: 5.8
                    },
                    {
                        height: 206,
                        value: 6.35
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.66
                    },
                    {
                        height: 122,
                        value: 1.93
                    },
                    {
                        height: 130,
                        value: 2.23
                    },
                    {
                        height: 137,
                        value: 2.51
                    },
                    {
                        height: 145,
                        value: 2.86
                    },
                    {
                        height: 152,
                        value: 3.18
                    },
                    {
                        height: 160,
                        value: 3.57
                    },
                    {
                        height: 168,
                        value: 3.99
                    },
                    {
                        height: 175,
                        value: 4.37
                    },
                    {
                        height: 183,
                        value: 4.84
                    },
                    {
                        height: 191,
                        value: 5.33
                    },
                    {
                        height: 198,
                        value: 5.78
                    },
                    {
                        height: 206,
                        value: 6.32
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.64
                    },
                    {
                        height: 122,
                        value: 1.91
                    },
                    {
                        height: 130,
                        value: 2.21
                    },
                    {
                        height: 137,
                        value: 2.49
                    },
                    {
                        height: 145,
                        value: 2.83
                    },
                    {
                        height: 152,
                        value: 3.14
                    },
                    {
                        height: 160,
                        value: 3.53
                    },
                    {
                        height: 168,
                        value: 3.94
                    },
                    {
                        height: 175,
                        value: 4.33
                    },
                    {
                        height: 183,
                        value: 4.79
                    },
                    {
                        height: 191,
                        value: 5.27
                    },
                    {
                        height: 198,
                        value: 5.72
                    },
                    {
                        height: 206,
                        value: 6.26
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.61
                    },
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.44
                    },
                    {
                        height: 145,
                        value: 2.77
                    },
                    {
                        height: 152,
                        value: 3.08
                    },
                    {
                        height: 160,
                        value: 3.46
                    },
                    {
                        height: 168,
                        value: 3.86
                    },
                    {
                        height: 175,
                        value: 4.24
                    },
                    {
                        height: 183,
                        value: 4.69
                    },
                    {
                        height: 191,
                        value: 5.17
                    },
                    {
                        height: 198,
                        value: 5.61
                    },
                    {
                        height: 206,
                        value: 6.13
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.56
                    },
                    {
                        height: 122,
                        value: 1.82
                    },
                    {
                        height: 130,
                        value: 2.1
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.69
                    },
                    {
                        height: 152,
                        value: 2.99
                    },
                    {
                        height: 160,
                        value: 3.36
                    },
                    {
                        height: 168,
                        value: 3.75
                    },
                    {
                        height: 175,
                        value: 4.12
                    },
                    {
                        height: 183,
                        value: 4.56
                    },
                    {
                        height: 191,
                        value: 5.02
                    },
                    {
                        height: 198,
                        value: 5.44
                    },
                    {
                        height: 206,
                        value: 5.96
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.51
                    },
                    {
                        height: 122,
                        value: 1.76
                    },
                    {
                        height: 130,
                        value: 2.03
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.6
                    },
                    {
                        height: 152,
                        value: 2.89
                    },
                    {
                        height: 160,
                        value: 3.25
                    },
                    {
                        height: 168,
                        value: 3.62
                    },
                    {
                        height: 175,
                        value: 3.98
                    },
                    {
                        height: 183,
                        value: 4.4
                    },
                    {
                        height: 191,
                        value: 4.85
                    },
                    {
                        height: 198,
                        value: 5.26
                    },
                    {
                        height: 206,
                        value: 5.75
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.45
                    },
                    {
                        height: 122,
                        value: 1.69
                    },
                    {
                        height: 130,
                        value: 1.95
                    },
                    {
                        height: 137,
                        value: 2.19
                    },
                    {
                        height: 145,
                        value: 2.49
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.12
                    },
                    {
                        height: 168,
                        value: 3.48
                    },
                    {
                        height: 175,
                        value: 3.82
                    },
                    {
                        height: 183,
                        value: 4.22
                    },
                    {
                        height: 191,
                        value: 4.65
                    },
                    {
                        height: 198,
                        value: 5.05
                    },
                    {
                        height: 206,
                        value: 5.52
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.38
                    },
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.1
                    },
                    {
                        height: 145,
                        value: 2.38
                    },
                    {
                        height: 152,
                        value: 2.65
                    },
                    {
                        height: 160,
                        value: 2.98
                    },
                    {
                        height: 168,
                        value: 3.32
                    },
                    {
                        height: 175,
                        value: 3.65
                    },
                    {
                        height: 183,
                        value: 4.03
                    },
                    {
                        height: 191,
                        value: 4.44
                    },
                    {
                        height: 198,
                        value: 4.82
                    },
                    {
                        height: 206,
                        value: 5.27
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.31
                    },
                    {
                        height: 122,
                        value: 1.53
                    },
                    {
                        height: 130,
                        value: 1.77
                    },
                    {
                        height: 137,
                        value: 1.99
                    },
                    {
                        height: 145,
                        value: 2.26
                    },
                    {
                        height: 152,
                        value: 2.52
                    },
                    {
                        height: 160,
                        value: 2.83
                    },
                    {
                        height: 168,
                        value: 3.16
                    },
                    {
                        height: 175,
                        value: 3.47
                    },
                    {
                        height: 183,
                        value: 3.83
                    },
                    {
                        height: 191,
                        value: 4.22
                    },
                    {
                        height: 198,
                        value: 4.58
                    },
                    {
                        height: 206,
                        value: 5.01
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.24
                    },
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.67
                    },
                    {
                        height: 137,
                        value: 1.88
                    },
                    {
                        height: 145,
                        value: 2.14
                    },
                    {
                        height: 152,
                        value: 2.38
                    },
                    {
                        height: 160,
                        value: 2.68
                    },
                    {
                        height: 168,
                        value: 2.99
                    },
                    {
                        height: 175,
                        value: 3.28
                    },
                    {
                        height: 183,
                        value: 3.63
                    },
                    {
                        height: 191,
                        value: 4
                    },
                    {
                        height: 198,
                        value: 4.34
                    },
                    {
                        height: 206,
                        value: 4.74
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 1.17
                    },
                    {
                        height: 122,
                        value: 1.37
                    },
                    {
                        height: 130,
                        value: 1.58
                    },
                    {
                        height: 137,
                        value: 1.78
                    },
                    {
                        height: 145,
                        value: 2.02
                    },
                    {
                        height: 152,
                        value: 2.25
                    },
                    {
                        height: 160,
                        value: 2.53
                    },
                    {
                        height: 168,
                        value: 2.82
                    },
                    {
                        height: 175,
                        value: 3.1
                    },
                    {
                        height: 183,
                        value: 3.43
                    },
                    {
                        height: 191,
                        value: 3.78
                    },
                    {
                        height: 198,
                        value: 4.1
                    },
                    {
                        height: 206,
                        value: 4.48
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 1.11
                    },
                    {
                        height: 122,
                        value: 1.29
                    },
                    {
                        height: 130,
                        value: 1.49
                    },
                    {
                        height: 137,
                        value: 1.68
                    },
                    {
                        height: 145,
                        value: 1.91
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.39
                    },
                    {
                        height: 168,
                        value: 2.67
                    },
                    {
                        height: 175,
                        value: 2.93
                    },
                    {
                        height: 183,
                        value: 3.24
                    },
                    {
                        height: 191,
                        value: 3.57
                    },
                    {
                        height: 198,
                        value: 3.87
                    },
                    {
                        height: 206,
                        value: 4.23
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 1.05
                    },
                    {
                        height: 122,
                        value: 1.23
                    },
                    {
                        height: 130,
                        value: 1.41
                    },
                    {
                        height: 137,
                        value: 1.59
                    },
                    {
                        height: 145,
                        value: 1.81
                    },
                    {
                        height: 152,
                        value: 2.02
                    },
                    {
                        height: 160,
                        value: 2.26
                    },
                    {
                        height: 168,
                        value: 2.53
                    },
                    {
                        height: 175,
                        value: 2.77
                    },
                    {
                        height: 183,
                        value: 3.07
                    },
                    {
                        height: 191,
                        value: 3.38
                    },
                    {
                        height: 198,
                        value: 3.67
                    },
                    {
                        height: 206,
                        value: 4.01
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 1
                    },
                    {
                        height: 122,
                        value: 1.16
                    },
                    {
                        height: 130,
                        value: 1.34
                    },
                    {
                        height: 137,
                        value: 1.51
                    },
                    {
                        height: 145,
                        value: 1.72
                    },
                    {
                        height: 152,
                        value: 1.91
                    },
                    {
                        height: 160,
                        value: 2.15
                    },
                    {
                        height: 168,
                        value: 2.4
                    },
                    {
                        height: 175,
                        value: 2.63
                    },
                    {
                        height: 183,
                        value: 2.91
                    },
                    {
                        height: 191,
                        value: 3.21
                    },
                    {
                        height: 198,
                        value: 3.48
                    },
                    {
                        height: 206,
                        value: 3.81
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.95
                    },
                    {
                        height: 122,
                        value: 1.11
                    },
                    {
                        height: 130,
                        value: 1.28
                    },
                    {
                        height: 137,
                        value: 1.44
                    },
                    {
                        height: 145,
                        value: 1.64
                    },
                    {
                        height: 152,
                        value: 1.82
                    },
                    {
                        height: 160,
                        value: 2.05
                    },
                    {
                        height: 168,
                        value: 2.29
                    },
                    {
                        height: 175,
                        value: 2.51
                    },
                    {
                        height: 183,
                        value: 2.77
                    },
                    {
                        height: 191,
                        value: 3.06
                    },
                    {
                        height: 198,
                        value: 3.32
                    },
                    {
                        height: 206,
                        value: 3.63
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.14
                    },
                    {
                        height: 122,
                        value: 1.32
                    },
                    {
                        height: 130,
                        value: 1.51
                    },
                    {
                        height: 137,
                        value: 1.69
                    },
                    {
                        height: 145,
                        value: 1.9
                    },
                    {
                        height: 152,
                        value: 2.1
                    },
                    {
                        height: 160,
                        value: 2.35
                    },
                    {
                        height: 168,
                        value: 2.6
                    },
                    {
                        height: 175,
                        value: 2.84
                    },
                    {
                        height: 183,
                        value: 3.12
                    },
                    {
                        height: 191,
                        value: 3.42
                    },
                    {
                        height: 198,
                        value: 3.69
                    },
                    {
                        height: 206,
                        value: 4.01
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.24
                    },
                    {
                        height: 122,
                        value: 1.43
                    },
                    {
                        height: 130,
                        value: 1.63
                    },
                    {
                        height: 137,
                        value: 1.83
                    },
                    {
                        height: 145,
                        value: 2.06
                    },
                    {
                        height: 152,
                        value: 2.28
                    },
                    {
                        height: 160,
                        value: 2.54
                    },
                    {
                        height: 168,
                        value: 2.82
                    },
                    {
                        height: 175,
                        value: 3.07
                    },
                    {
                        height: 183,
                        value: 3.38
                    },
                    {
                        height: 191,
                        value: 3.7
                    },
                    {
                        height: 198,
                        value: 3.99
                    },
                    {
                        height: 206,
                        value: 4.34
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.49
                    },
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.2
                    },
                    {
                        height: 145,
                        value: 2.48
                    },
                    {
                        height: 152,
                        value: 2.74
                    },
                    {
                        height: 160,
                        value: 3.05
                    },
                    {
                        height: 168,
                        value: 3.39
                    },
                    {
                        height: 175,
                        value: 3.69
                    },
                    {
                        height: 183,
                        value: 4.06
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.8
                    },
                    {
                        height: 206,
                        value: 5.22
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.55
                    },
                    {
                        height: 122,
                        value: 1.78
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.57
                    },
                    {
                        height: 152,
                        value: 2.85
                    },
                    {
                        height: 160,
                        value: 3.17
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.84
                    },
                    {
                        height: 183,
                        value: 4.22
                    },
                    {
                        height: 191,
                        value: 4.62
                    },
                    {
                        height: 198,
                        value: 4.98
                    },
                    {
                        height: 206,
                        value: 5.42
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.52
                    },
                    {
                        height: 122,
                        value: 1.76
                    },
                    {
                        height: 130,
                        value: 2.01
                    },
                    {
                        height: 137,
                        value: 2.25
                    },
                    {
                        height: 145,
                        value: 2.54
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.13
                    },
                    {
                        height: 168,
                        value: 3.47
                    },
                    {
                        height: 175,
                        value: 3.78
                    },
                    {
                        height: 183,
                        value: 4.16
                    },
                    {
                        height: 191,
                        value: 4.55
                    },
                    {
                        height: 198,
                        value: 4.91
                    },
                    {
                        height: 206,
                        value: 5.34
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.49
                    },
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.2
                    },
                    {
                        height: 145,
                        value: 2.48
                    },
                    {
                        height: 152,
                        value: 2.74
                    },
                    {
                        height: 160,
                        value: 3.06
                    },
                    {
                        height: 168,
                        value: 3.39
                    },
                    {
                        height: 175,
                        value: 3.7
                    },
                    {
                        height: 183,
                        value: 4.07
                    },
                    {
                        height: 191,
                        value: 4.46
                    },
                    {
                        height: 198,
                        value: 4.81
                    },
                    {
                        height: 206,
                        value: 5.23
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.45
                    },
                    {
                        height: 122,
                        value: 1.68
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.14
                    },
                    {
                        height: 145,
                        value: 2.42
                    },
                    {
                        height: 152,
                        value: 2.67
                    },
                    {
                        height: 160,
                        value: 2.98
                    },
                    {
                        height: 168,
                        value: 3.3
                    },
                    {
                        height: 175,
                        value: 3.6
                    },
                    {
                        height: 183,
                        value: 3.96
                    },
                    {
                        height: 191,
                        value: 4.34
                    },
                    {
                        height: 198,
                        value: 4.68
                    },
                    {
                        height: 206,
                        value: 5.09
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.4
                    },
                    {
                        height: 122,
                        value: 1.62
                    },
                    {
                        height: 130,
                        value: 1.85
                    },
                    {
                        height: 137,
                        value: 2.07
                    },
                    {
                        height: 145,
                        value: 2.33
                    },
                    {
                        height: 152,
                        value: 2.58
                    },
                    {
                        height: 160,
                        value: 2.87
                    },
                    {
                        height: 168,
                        value: 3.19
                    },
                    {
                        height: 175,
                        value: 3.48
                    },
                    {
                        height: 183,
                        value: 3.82
                    },
                    {
                        height: 191,
                        value: 4.18
                    },
                    {
                        height: 198,
                        value: 4.52
                    },
                    {
                        height: 206,
                        value: 4.91
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.34
                    },
                    {
                        height: 122,
                        value: 1.55
                    },
                    {
                        height: 130,
                        value: 1.77
                    },
                    {
                        height: 137,
                        value: 1.98
                    },
                    {
                        height: 145,
                        value: 2.24
                    },
                    {
                        height: 152,
                        value: 2.47
                    },
                    {
                        height: 160,
                        value: 2.76
                    },
                    {
                        height: 168,
                        value: 3.06
                    },
                    {
                        height: 175,
                        value: 3.33
                    },
                    {
                        height: 183,
                        value: 3.66
                    },
                    {
                        height: 191,
                        value: 4.01
                    },
                    {
                        height: 198,
                        value: 4.33
                    },
                    {
                        height: 206,
                        value: 4.71
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.28
                    },
                    {
                        height: 122,
                        value: 1.48
                    },
                    {
                        height: 130,
                        value: 1.7
                    },
                    {
                        height: 137,
                        value: 1.9
                    },
                    {
                        height: 145,
                        value: 2.14
                    },
                    {
                        height: 152,
                        value: 2.36
                    },
                    {
                        height: 160,
                        value: 2.64
                    },
                    {
                        height: 168,
                        value: 2.92
                    },
                    {
                        height: 175,
                        value: 3.19
                    },
                    {
                        height: 183,
                        value: 3.5
                    },
                    {
                        height: 191,
                        value: 3.84
                    },
                    {
                        height: 198,
                        value: 4.14
                    },
                    {
                        height: 206,
                        value: 4.5
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.22
                    },
                    {
                        height: 122,
                        value: 1.41
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.81
                    },
                    {
                        height: 145,
                        value: 2.04
                    },
                    {
                        height: 152,
                        value: 2.25
                    },
                    {
                        height: 160,
                        value: 2.51
                    },
                    {
                        height: 168,
                        value: 2.78
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.34
                    },
                    {
                        height: 191,
                        value: 3.65
                    },
                    {
                        height: 198,
                        value: 3.94
                    },
                    {
                        height: 206,
                        value: 4.29
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.16
                    },
                    {
                        height: 122,
                        value: 1.34
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.71
                    },
                    {
                        height: 145,
                        value: 1.93
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.38
                    },
                    {
                        height: 168,
                        value: 2.64
                    },
                    {
                        height: 175,
                        value: 2.88
                    },
                    {
                        height: 183,
                        value: 3.16
                    },
                    {
                        height: 191,
                        value: 3.46
                    },
                    {
                        height: 198,
                        value: 3.74
                    },
                    {
                        height: 206,
                        value: 4.07
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.09
                    },
                    {
                        height: 122,
                        value: 1.26
                    },
                    {
                        height: 130,
                        value: 1.44
                    },
                    {
                        height: 137,
                        value: 1.61
                    },
                    {
                        height: 145,
                        value: 1.82
                    },
                    {
                        height: 152,
                        value: 2.01
                    },
                    {
                        height: 160,
                        value: 2.24
                    },
                    {
                        height: 168,
                        value: 2.49
                    },
                    {
                        height: 175,
                        value: 2.71
                    },
                    {
                        height: 183,
                        value: 2.98
                    },
                    {
                        height: 191,
                        value: 3.27
                    },
                    {
                        height: 198,
                        value: 3.52
                    },
                    {
                        height: 206,
                        value: 3.83
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.03
                    },
                    {
                        height: 122,
                        value: 1.18
                    },
                    {
                        height: 130,
                        value: 1.35
                    },
                    {
                        height: 137,
                        value: 1.51
                    },
                    {
                        height: 145,
                        value: 1.71
                    },
                    {
                        height: 152,
                        value: 1.89
                    },
                    {
                        height: 160,
                        value: 2.1
                    },
                    {
                        height: 168,
                        value: 2.33
                    },
                    {
                        height: 175,
                        value: 2.54
                    },
                    {
                        height: 183,
                        value: 2.8
                    },
                    {
                        height: 191,
                        value: 3.06
                    },
                    {
                        height: 198,
                        value: 3.31
                    },
                    {
                        height: 206,
                        value: 3.6
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.96
                    },
                    {
                        height: 122,
                        value: 1.11
                    },
                    {
                        height: 130,
                        value: 1.27
                    },
                    {
                        height: 137,
                        value: 1.42
                    },
                    {
                        height: 145,
                        value: 1.6
                    },
                    {
                        height: 152,
                        value: 1.77
                    },
                    {
                        height: 160,
                        value: 1.97
                    },
                    {
                        height: 168,
                        value: 2.18
                    },
                    {
                        height: 175,
                        value: 2.38
                    },
                    {
                        height: 183,
                        value: 2.62
                    },
                    {
                        height: 191,
                        value: 2.87
                    },
                    {
                        height: 198,
                        value: 3.09
                    },
                    {
                        height: 206,
                        value: 3.36
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.9
                    },
                    {
                        height: 122,
                        value: 1.04
                    },
                    {
                        height: 130,
                        value: 1.19
                    },
                    {
                        height: 137,
                        value: 1.32
                    },
                    {
                        height: 145,
                        value: 1.49
                    },
                    {
                        height: 152,
                        value: 1.65
                    },
                    {
                        height: 160,
                        value: 1.84
                    },
                    {
                        height: 168,
                        value: 2.04
                    },
                    {
                        height: 175,
                        value: 2.23
                    },
                    {
                        height: 183,
                        value: 2.45
                    },
                    {
                        height: 191,
                        value: 2.68
                    },
                    {
                        height: 198,
                        value: 2.89
                    },
                    {
                        height: 206,
                        value: 3.15
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.97
                    },
                    {
                        height: 130,
                        value: 1.11
                    },
                    {
                        height: 137,
                        value: 1.24
                    },
                    {
                        height: 145,
                        value: 1.4
                    },
                    {
                        height: 152,
                        value: 1.55
                    },
                    {
                        height: 160,
                        value: 1.73
                    },
                    {
                        height: 168,
                        value: 1.91
                    },
                    {
                        height: 175,
                        value: 2.09
                    },
                    {
                        height: 183,
                        value: 2.3
                    },
                    {
                        height: 191,
                        value: 2.51
                    },
                    {
                        height: 198,
                        value: 2.71
                    },
                    {
                        height: 206,
                        value: 2.95
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 1.05
                    },
                    {
                        height: 137,
                        value: 1.17
                    },
                    {
                        height: 145,
                        value: 1.32
                    },
                    {
                        height: 152,
                        value: 1.46
                    },
                    {
                        height: 160,
                        value: 1.62
                    },
                    {
                        height: 168,
                        value: 1.8
                    },
                    {
                        height: 175,
                        value: 1.96
                    },
                    {
                        height: 183,
                        value: 2.16
                    },
                    {
                        height: 191,
                        value: 2.37
                    },
                    {
                        height: 198,
                        value: 2.55
                    },
                    {
                        height: 206,
                        value: 2.78
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.75
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.99
                    },
                    {
                        height: 137,
                        value: 1.1
                    },
                    {
                        height: 145,
                        value: 1.24
                    },
                    {
                        height: 152,
                        value: 1.38
                    },
                    {
                        height: 160,
                        value: 1.53
                    },
                    {
                        height: 168,
                        value: 1.7
                    },
                    {
                        height: 175,
                        value: 1.85
                    },
                    {
                        height: 183,
                        value: 2.04
                    },
                    {
                        height: 191,
                        value: 2.23
                    },
                    {
                        height: 198,
                        value: 2.41
                    },
                    {
                        height: 206,
                        value: 2.62
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.92
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.91
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.9
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.89
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.88
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.87
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.91
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.9
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.9
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 0.89
                    },
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "African American",
        gender: "Male",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.32
                    },
                    {
                        height: 130,
                        value: 1.54
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 2
                    },
                    {
                        height: 152,
                        value: 2.25
                    },
                    {
                        height: 160,
                        value: 2.54
                    },
                    {
                        height: 168,
                        value: 2.86
                    },
                    {
                        height: 175,
                        value: 3.16
                    },
                    {
                        height: 183,
                        value: 3.51
                    },
                    {
                        height: 191,
                        value: 3.9
                    },
                    {
                        height: 198,
                        value: 4.25
                    },
                    {
                        height: 206,
                        value: 4.68
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.43
                    },
                    {
                        height: 130,
                        value: 1.66
                    },
                    {
                        height: 137,
                        value: 1.89
                    },
                    {
                        height: 145,
                        value: 2.16
                    },
                    {
                        height: 152,
                        value: 2.43
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.09
                    },
                    {
                        height: 175,
                        value: 3.41
                    },
                    {
                        height: 183,
                        value: 3.8
                    },
                    {
                        height: 191,
                        value: 4.21
                    },
                    {
                        height: 198,
                        value: 4.59
                    },
                    {
                        height: 206,
                        value: 5.05
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.18
                    },
                    {
                        height: 145,
                        value: 2.51
                    },
                    {
                        height: 152,
                        value: 2.81
                    },
                    {
                        height: 160,
                        value: 3.18
                    },
                    {
                        height: 168,
                        value: 3.57
                    },
                    {
                        height: 175,
                        value: 3.94
                    },
                    {
                        height: 183,
                        value: 4.39
                    },
                    {
                        height: 191,
                        value: 4.87
                    },
                    {
                        height: 198,
                        value: 5.31
                    },
                    {
                        height: 206,
                        value: 5.85
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.18
                    },
                    {
                        height: 137,
                        value: 2.47
                    },
                    {
                        height: 145,
                        value: 2.83
                    },
                    {
                        height: 152,
                        value: 3.17
                    },
                    {
                        height: 160,
                        value: 3.59
                    },
                    {
                        height: 168,
                        value: 4.04
                    },
                    {
                        height: 175,
                        value: 4.46
                    },
                    {
                        height: 183,
                        value: 4.97
                    },
                    {
                        height: 191,
                        value: 5.51
                    },
                    {
                        height: 198,
                        value: 6.01
                    },
                    {
                        height: 206,
                        value: 6.61
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.2
                    },
                    {
                        height: 137,
                        value: 2.49
                    },
                    {
                        height: 145,
                        value: 2.86
                    },
                    {
                        height: 152,
                        value: 3.2
                    },
                    {
                        height: 160,
                        value: 3.63
                    },
                    {
                        height: 168,
                        value: 4.08
                    },
                    {
                        height: 175,
                        value: 4.5
                    },
                    {
                        height: 183,
                        value: 5.01
                    },
                    {
                        height: 191,
                        value: 5.56
                    },
                    {
                        height: 198,
                        value: 6.06
                    },
                    {
                        height: 206,
                        value: 6.67
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.86
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.45
                    },
                    {
                        height: 145,
                        value: 2.81
                    },
                    {
                        height: 152,
                        value: 3.15
                    },
                    {
                        height: 160,
                        value: 3.57
                    },
                    {
                        height: 168,
                        value: 4.02
                    },
                    {
                        height: 175,
                        value: 4.43
                    },
                    {
                        height: 183,
                        value: 4.94
                    },
                    {
                        height: 191,
                        value: 5.47
                    },
                    {
                        height: 198,
                        value: 5.97
                    },
                    {
                        height: 206,
                        value: 6.57
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.82
                    },
                    {
                        height: 130,
                        value: 2.12
                    },
                    {
                        height: 137,
                        value: 2.41
                    },
                    {
                        height: 145,
                        value: 2.76
                    },
                    {
                        height: 152,
                        value: 3.1
                    },
                    {
                        height: 160,
                        value: 3.51
                    },
                    {
                        height: 168,
                        value: 3.94
                    },
                    {
                        height: 175,
                        value: 4.35
                    },
                    {
                        height: 183,
                        value: 4.85
                    },
                    {
                        height: 191,
                        value: 5.38
                    },
                    {
                        height: 198,
                        value: 5.86
                    },
                    {
                        height: 206,
                        value: 6.45
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.08
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.71
                    },
                    {
                        height: 152,
                        value: 3.04
                    },
                    {
                        height: 160,
                        value: 3.44
                    },
                    {
                        height: 168,
                        value: 3.87
                    },
                    {
                        height: 175,
                        value: 4.27
                    },
                    {
                        height: 183,
                        value: 4.76
                    },
                    {
                        height: 191,
                        value: 5.28
                    },
                    {
                        height: 198,
                        value: 5.75
                    },
                    {
                        height: 206,
                        value: 6.33
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.75
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.31
                    },
                    {
                        height: 145,
                        value: 2.65
                    },
                    {
                        height: 152,
                        value: 2.97
                    },
                    {
                        height: 160,
                        value: 3.36
                    },
                    {
                        height: 168,
                        value: 3.78
                    },
                    {
                        height: 175,
                        value: 4.17
                    },
                    {
                        height: 183,
                        value: 4.65
                    },
                    {
                        height: 191,
                        value: 5.15
                    },
                    {
                        height: 198,
                        value: 5.62
                    },
                    {
                        height: 206,
                        value: 6.18
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.98
                    },
                    {
                        height: 137,
                        value: 2.25
                    },
                    {
                        height: 145,
                        value: 2.58
                    },
                    {
                        height: 152,
                        value: 2.89
                    },
                    {
                        height: 160,
                        value: 3.27
                    },
                    {
                        height: 168,
                        value: 3.68
                    },
                    {
                        height: 175,
                        value: 4.06
                    },
                    {
                        height: 183,
                        value: 4.52
                    },
                    {
                        height: 191,
                        value: 5.01
                    },
                    {
                        height: 198,
                        value: 5.47
                    },
                    {
                        height: 206,
                        value: 6.01
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.64
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.17
                    },
                    {
                        height: 145,
                        value: 2.49
                    },
                    {
                        height: 152,
                        value: 2.79
                    },
                    {
                        height: 160,
                        value: 3.16
                    },
                    {
                        height: 168,
                        value: 3.56
                    },
                    {
                        height: 175,
                        value: 3.93
                    },
                    {
                        height: 183,
                        value: 4.37
                    },
                    {
                        height: 191,
                        value: 4.85
                    },
                    {
                        height: 198,
                        value: 5.29
                    },
                    {
                        height: 206,
                        value: 5.82
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.58
                    },
                    {
                        height: 130,
                        value: 1.84
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.4
                    },
                    {
                        height: 152,
                        value: 2.69
                    },
                    {
                        height: 160,
                        value: 3.04
                    },
                    {
                        height: 168,
                        value: 3.42
                    },
                    {
                        height: 175,
                        value: 3.78
                    },
                    {
                        height: 183,
                        value: 4.21
                    },
                    {
                        height: 191,
                        value: 4.66
                    },
                    {
                        height: 198,
                        value: 5.09
                    },
                    {
                        height: 206,
                        value: 5.6
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 2
                    },
                    {
                        height: 145,
                        value: 2.3
                    },
                    {
                        height: 152,
                        value: 2.57
                    },
                    {
                        height: 160,
                        value: 2.91
                    },
                    {
                        height: 168,
                        value: 3.28
                    },
                    {
                        height: 175,
                        value: 3.62
                    },
                    {
                        height: 183,
                        value: 4.03
                    },
                    {
                        height: 191,
                        value: 4.47
                    },
                    {
                        height: 198,
                        value: 4.87
                    },
                    {
                        height: 206,
                        value: 5.36
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.69
                    },
                    {
                        height: 137,
                        value: 1.91
                    },
                    {
                        height: 145,
                        value: 2.2
                    },
                    {
                        height: 152,
                        value: 2.46
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.13
                    },
                    {
                        height: 175,
                        value: 3.46
                    },
                    {
                        height: 183,
                        value: 3.85
                    },
                    {
                        height: 191,
                        value: 4.27
                    },
                    {
                        height: 198,
                        value: 4.66
                    },
                    {
                        height: 206,
                        value: 5.12
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.38
                    },
                    {
                        height: 130,
                        value: 1.61
                    },
                    {
                        height: 137,
                        value: 1.83
                    },
                    {
                        height: 145,
                        value: 2.1
                    },
                    {
                        height: 152,
                        value: 2.35
                    },
                    {
                        height: 160,
                        value: 2.66
                    },
                    {
                        height: 168,
                        value: 3
                    },
                    {
                        height: 175,
                        value: 3.31
                    },
                    {
                        height: 183,
                        value: 3.68
                    },
                    {
                        height: 191,
                        value: 4.08
                    },
                    {
                        height: 198,
                        value: 4.45
                    },
                    {
                        height: 206,
                        value: 4.9
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.33
                    },
                    {
                        height: 130,
                        value: 1.54
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 2.01
                    },
                    {
                        height: 152,
                        value: 2.25
                    },
                    {
                        height: 160,
                        value: 2.55
                    },
                    {
                        height: 168,
                        value: 2.87
                    },
                    {
                        height: 175,
                        value: 3.17
                    },
                    {
                        height: 183,
                        value: 3.53
                    },
                    {
                        height: 191,
                        value: 3.91
                    },
                    {
                        height: 198,
                        value: 4.26
                    },
                    {
                        height: 206,
                        value: 4.69
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.48
                    },
                    {
                        height: 137,
                        value: 1.68
                    },
                    {
                        height: 145,
                        value: 1.93
                    },
                    {
                        height: 152,
                        value: 2.16
                    },
                    {
                        height: 160,
                        value: 2.45
                    },
                    {
                        height: 168,
                        value: 2.75
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.38
                    },
                    {
                        height: 191,
                        value: 3.75
                    },
                    {
                        height: 198,
                        value: 4.09
                    },
                    {
                        height: 206,
                        value: 4.5
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.22
                    },
                    {
                        height: 130,
                        value: 1.42
                    },
                    {
                        height: 137,
                        value: 1.62
                    },
                    {
                        height: 145,
                        value: 1.85
                    },
                    {
                        height: 152,
                        value: 2.08
                    },
                    {
                        height: 160,
                        value: 2.35
                    },
                    {
                        height: 168,
                        value: 2.65
                    },
                    {
                        height: 175,
                        value: 2.92
                    },
                    {
                        height: 183,
                        value: 3.25
                    },
                    {
                        height: 191,
                        value: 3.61
                    },
                    {
                        height: 198,
                        value: 3.93
                    },
                    {
                        height: 206,
                        value: 4.33
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.18
                    },
                    {
                        height: 130,
                        value: 1.37
                    },
                    {
                        height: 137,
                        value: 1.56
                    },
                    {
                        height: 145,
                        value: 1.79
                    },
                    {
                        height: 152,
                        value: 2
                    },
                    {
                        height: 160,
                        value: 2.27
                    },
                    {
                        height: 168,
                        value: 2.55
                    },
                    {
                        height: 175,
                        value: 2.81
                    },
                    {
                        height: 183,
                        value: 3.13
                    },
                    {
                        height: 191,
                        value: 3.47
                    },
                    {
                        height: 198,
                        value: 3.79
                    },
                    {
                        height: 206,
                        value: 4.17
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.2
                    },
                    {
                        height: 130,
                        value: 1.38
                    },
                    {
                        height: 137,
                        value: 1.55
                    },
                    {
                        height: 145,
                        value: 1.76
                    },
                    {
                        height: 152,
                        value: 1.95
                    },
                    {
                        height: 160,
                        value: 2.18
                    },
                    {
                        height: 168,
                        value: 2.43
                    },
                    {
                        height: 175,
                        value: 2.66
                    },
                    {
                        height: 183,
                        value: 2.94
                    },
                    {
                        height: 191,
                        value: 3.24
                    },
                    {
                        height: 198,
                        value: 3.5
                    },
                    {
                        height: 206,
                        value: 3.83
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.46
                    },
                    {
                        height: 137,
                        value: 1.64
                    },
                    {
                        height: 145,
                        value: 1.86
                    },
                    {
                        height: 152,
                        value: 2.07
                    },
                    {
                        height: 160,
                        value: 2.32
                    },
                    {
                        height: 168,
                        value: 2.58
                    },
                    {
                        height: 175,
                        value: 2.83
                    },
                    {
                        height: 183,
                        value: 3.12
                    },
                    {
                        height: 191,
                        value: 3.44
                    },
                    {
                        height: 198,
                        value: 3.72
                    },
                    {
                        height: 206,
                        value: 4.06
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.53
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 1.98
                    },
                    {
                        height: 145,
                        value: 2.24
                    },
                    {
                        height: 152,
                        value: 2.49
                    },
                    {
                        height: 160,
                        value: 2.79
                    },
                    {
                        height: 168,
                        value: 3.11
                    },
                    {
                        height: 175,
                        value: 3.4
                    },
                    {
                        height: 183,
                        value: 3.76
                    },
                    {
                        height: 191,
                        value: 4.13
                    },
                    {
                        height: 198,
                        value: 4.48
                    },
                    {
                        height: 206,
                        value: 4.89
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 1.98
                    },
                    {
                        height: 137,
                        value: 2.22
                    },
                    {
                        height: 145,
                        value: 2.52
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.14
                    },
                    {
                        height: 168,
                        value: 3.5
                    },
                    {
                        height: 175,
                        value: 3.83
                    },
                    {
                        height: 183,
                        value: 4.23
                    },
                    {
                        height: 191,
                        value: 4.65
                    },
                    {
                        height: 198,
                        value: 5.04
                    },
                    {
                        height: 206,
                        value: 5.5
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.71
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.21
                    },
                    {
                        height: 145,
                        value: 2.51
                    },
                    {
                        height: 152,
                        value: 2.79
                    },
                    {
                        height: 160,
                        value: 3.12
                    },
                    {
                        height: 168,
                        value: 3.48
                    },
                    {
                        height: 175,
                        value: 3.81
                    },
                    {
                        height: 183,
                        value: 4.21
                    },
                    {
                        height: 191,
                        value: 4.63
                    },
                    {
                        height: 198,
                        value: 5.01
                    },
                    {
                        height: 206,
                        value: 5.47
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.66
                    },
                    {
                        height: 130,
                        value: 1.91
                    },
                    {
                        height: 137,
                        value: 2.15
                    },
                    {
                        height: 145,
                        value: 2.44
                    },
                    {
                        height: 152,
                        value: 2.7
                    },
                    {
                        height: 160,
                        value: 3.03
                    },
                    {
                        height: 168,
                        value: 3.38
                    },
                    {
                        height: 175,
                        value: 3.7
                    },
                    {
                        height: 183,
                        value: 4.08
                    },
                    {
                        height: 191,
                        value: 4.49
                    },
                    {
                        height: 198,
                        value: 4.86
                    },
                    {
                        height: 206,
                        value: 5.31
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.37
                    },
                    {
                        height: 152,
                        value: 2.63
                    },
                    {
                        height: 160,
                        value: 2.94
                    },
                    {
                        height: 168,
                        value: 3.28
                    },
                    {
                        height: 175,
                        value: 3.59
                    },
                    {
                        height: 183,
                        value: 3.97
                    },
                    {
                        height: 191,
                        value: 4.36
                    },
                    {
                        height: 198,
                        value: 4.72
                    },
                    {
                        height: 206,
                        value: 5.16
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.56
                    },
                    {
                        height: 130,
                        value: 1.8
                    },
                    {
                        height: 137,
                        value: 2.02
                    },
                    {
                        height: 145,
                        value: 2.29
                    },
                    {
                        height: 152,
                        value: 2.54
                    },
                    {
                        height: 160,
                        value: 2.85
                    },
                    {
                        height: 168,
                        value: 3.18
                    },
                    {
                        height: 175,
                        value: 3.48
                    },
                    {
                        height: 183,
                        value: 3.84
                    },
                    {
                        height: 191,
                        value: 4.22
                    },
                    {
                        height: 198,
                        value: 4.58
                    },
                    {
                        height: 206,
                        value: 5
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.74
                    },
                    {
                        height: 137,
                        value: 1.95
                    },
                    {
                        height: 145,
                        value: 2.21
                    },
                    {
                        height: 152,
                        value: 2.46
                    },
                    {
                        height: 160,
                        value: 2.75
                    },
                    {
                        height: 168,
                        value: 3.07
                    },
                    {
                        height: 175,
                        value: 3.36
                    },
                    {
                        height: 183,
                        value: 3.71
                    },
                    {
                        height: 191,
                        value: 4.08
                    },
                    {
                        height: 198,
                        value: 4.42
                    },
                    {
                        height: 206,
                        value: 4.82
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.67
                    },
                    {
                        height: 137,
                        value: 1.88
                    },
                    {
                        height: 145,
                        value: 2.13
                    },
                    {
                        height: 152,
                        value: 2.37
                    },
                    {
                        height: 160,
                        value: 2.65
                    },
                    {
                        height: 168,
                        value: 2.96
                    },
                    {
                        height: 175,
                        value: 3.24
                    },
                    {
                        height: 183,
                        value: 3.58
                    },
                    {
                        height: 191,
                        value: 3.93
                    },
                    {
                        height: 198,
                        value: 4.26
                    },
                    {
                        height: 206,
                        value: 4.65
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.8
                    },
                    {
                        height: 145,
                        value: 2.04
                    },
                    {
                        height: 152,
                        value: 2.27
                    },
                    {
                        height: 160,
                        value: 2.54
                    },
                    {
                        height: 168,
                        value: 2.83
                    },
                    {
                        height: 175,
                        value: 3.1
                    },
                    {
                        height: 183,
                        value: 3.43
                    },
                    {
                        height: 191,
                        value: 3.77
                    },
                    {
                        height: 198,
                        value: 4.08
                    },
                    {
                        height: 206,
                        value: 4.46
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.33
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.72
                    },
                    {
                        height: 145,
                        value: 1.95
                    },
                    {
                        height: 152,
                        value: 2.16
                    },
                    {
                        height: 160,
                        value: 2.42
                    },
                    {
                        height: 168,
                        value: 2.7
                    },
                    {
                        height: 175,
                        value: 2.96
                    },
                    {
                        height: 183,
                        value: 3.26
                    },
                    {
                        height: 191,
                        value: 3.59
                    },
                    {
                        height: 198,
                        value: 3.89
                    },
                    {
                        height: 206,
                        value: 4.24
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.26
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.63
                    },
                    {
                        height: 145,
                        value: 1.84
                    },
                    {
                        height: 152,
                        value: 2.05
                    },
                    {
                        height: 160,
                        value: 2.3
                    },
                    {
                        height: 168,
                        value: 2.56
                    },
                    {
                        height: 175,
                        value: 2.8
                    },
                    {
                        height: 183,
                        value: 3.09
                    },
                    {
                        height: 191,
                        value: 3.4
                    },
                    {
                        height: 198,
                        value: 3.68
                    },
                    {
                        height: 206,
                        value: 4.02
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.19
                    },
                    {
                        height: 130,
                        value: 1.37
                    },
                    {
                        height: 137,
                        value: 1.54
                    },
                    {
                        height: 145,
                        value: 1.74
                    },
                    {
                        height: 152,
                        value: 1.94
                    },
                    {
                        height: 160,
                        value: 2.17
                    },
                    {
                        height: 168,
                        value: 2.42
                    },
                    {
                        height: 175,
                        value: 2.65
                    },
                    {
                        height: 183,
                        value: 2.92
                    },
                    {
                        height: 191,
                        value: 3.22
                    },
                    {
                        height: 198,
                        value: 3.48
                    },
                    {
                        height: 206,
                        value: 3.8
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.12
                    },
                    {
                        height: 130,
                        value: 1.29
                    },
                    {
                        height: 137,
                        value: 1.45
                    },
                    {
                        height: 145,
                        value: 1.65
                    },
                    {
                        height: 152,
                        value: 1.83
                    },
                    {
                        height: 160,
                        value: 2.05
                    },
                    {
                        height: 168,
                        value: 2.29
                    },
                    {
                        height: 175,
                        value: 2.5
                    },
                    {
                        height: 183,
                        value: 2.76
                    },
                    {
                        height: 191,
                        value: 3.04
                    },
                    {
                        height: 198,
                        value: 3.29
                    },
                    {
                        height: 206,
                        value: 3.6
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.06
                    },
                    {
                        height: 130,
                        value: 1.23
                    },
                    {
                        height: 137,
                        value: 1.38
                    },
                    {
                        height: 145,
                        value: 1.56
                    },
                    {
                        height: 152,
                        value: 1.73
                    },
                    {
                        height: 160,
                        value: 1.94
                    },
                    {
                        height: 168,
                        value: 2.17
                    },
                    {
                        height: 175,
                        value: 2.37
                    },
                    {
                        height: 183,
                        value: 2.62
                    },
                    {
                        height: 191,
                        value: 2.88
                    },
                    {
                        height: 198,
                        value: 3.12
                    },
                    {
                        height: 206,
                        value: 3.4
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.01
                    },
                    {
                        height: 130,
                        value: 1.16
                    },
                    {
                        height: 137,
                        value: 1.31
                    },
                    {
                        height: 145,
                        value: 1.48
                    },
                    {
                        height: 152,
                        value: 1.65
                    },
                    {
                        height: 160,
                        value: 1.84
                    },
                    {
                        height: 168,
                        value: 2.06
                    },
                    {
                        height: 175,
                        value: 2.25
                    },
                    {
                        height: 183,
                        value: 2.49
                    },
                    {
                        height: 191,
                        value: 2.73
                    },
                    {
                        height: 198,
                        value: 2.96
                    },
                    {
                        height: 206,
                        value: 3.23
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.96
                    },
                    {
                        height: 130,
                        value: 1.11
                    },
                    {
                        height: 137,
                        value: 1.25
                    },
                    {
                        height: 145,
                        value: 1.41
                    },
                    {
                        height: 152,
                        value: 1.57
                    },
                    {
                        height: 160,
                        value: 1.76
                    },
                    {
                        height: 168,
                        value: 1.96
                    },
                    {
                        height: 175,
                        value: 2.14
                    },
                    {
                        height: 183,
                        value: 2.37
                    },
                    {
                        height: 191,
                        value: 2.6
                    },
                    {
                        height: 198,
                        value: 2.82
                    },
                    {
                        height: 206,
                        value: 3.08
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 1.06
                    },
                    {
                        height: 137,
                        value: 1.19
                    },
                    {
                        height: 145,
                        value: 1.35
                    },
                    {
                        height: 152,
                        value: 1.5
                    },
                    {
                        height: 160,
                        value: 1.68
                    },
                    {
                        height: 168,
                        value: 1.87
                    },
                    {
                        height: 175,
                        value: 2.05
                    },
                    {
                        height: 183,
                        value: 2.26
                    },
                    {
                        height: 191,
                        value: 2.49
                    },
                    {
                        height: 198,
                        value: 2.69
                    },
                    {
                        height: 206,
                        value: 2.94
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.77
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.76
                    },
                    {
                        height: 152,
                        value: 0.75
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.74
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.73
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.72
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "African American",
        gender: "Female",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.07
                    },
                    {
                        height: 122,
                        value: 1.25
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.63
                    },
                    {
                        height: 145,
                        value: 1.85
                    },
                    {
                        height: 152,
                        value: 2.06
                    },
                    {
                        height: 160,
                        value: 2.31
                    },
                    {
                        height: 168,
                        value: 2.58
                    },
                    {
                        height: 175,
                        value: 2.83
                    },
                    {
                        height: 183,
                        value: 3.13
                    },
                    {
                        height: 191,
                        value: 3.45
                    },
                    {
                        height: 198,
                        value: 3.75
                    },
                    {
                        height: 206,
                        value: 4.1
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.18
                    },
                    {
                        height: 122,
                        value: 1.38
                    },
                    {
                        height: 130,
                        value: 1.59
                    },
                    {
                        height: 137,
                        value: 1.79
                    },
                    {
                        height: 145,
                        value: 2.04
                    },
                    {
                        height: 152,
                        value: 2.27
                    },
                    {
                        height: 160,
                        value: 2.55
                    },
                    {
                        height: 168,
                        value: 2.85
                    },
                    {
                        height: 175,
                        value: 3.12
                    },
                    {
                        height: 183,
                        value: 3.46
                    },
                    {
                        height: 191,
                        value: 3.81
                    },
                    {
                        height: 198,
                        value: 4.13
                    },
                    {
                        height: 206,
                        value: 4.52
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.38
                    },
                    {
                        height: 122,
                        value: 1.61
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.38
                    },
                    {
                        height: 152,
                        value: 2.65
                    },
                    {
                        height: 160,
                        value: 2.97
                    },
                    {
                        height: 168,
                        value: 3.32
                    },
                    {
                        height: 175,
                        value: 3.64
                    },
                    {
                        height: 183,
                        value: 4.03
                    },
                    {
                        height: 191,
                        value: 4.44
                    },
                    {
                        height: 198,
                        value: 4.81
                    },
                    {
                        height: 206,
                        value: 5.27
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.45
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.96
                    },
                    {
                        height: 137,
                        value: 2.2
                    },
                    {
                        height: 145,
                        value: 2.51
                    },
                    {
                        height: 152,
                        value: 2.79
                    },
                    {
                        height: 160,
                        value: 3.13
                    },
                    {
                        height: 168,
                        value: 3.5
                    },
                    {
                        height: 175,
                        value: 3.84
                    },
                    {
                        height: 183,
                        value: 4.25
                    },
                    {
                        height: 191,
                        value: 4.68
                    },
                    {
                        height: 198,
                        value: 5.07
                    },
                    {
                        height: 206,
                        value: 5.55
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.46
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.97
                    },
                    {
                        height: 137,
                        value: 2.22
                    },
                    {
                        height: 145,
                        value: 2.52
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.15
                    },
                    {
                        height: 168,
                        value: 3.52
                    },
                    {
                        height: 175,
                        value: 3.86
                    },
                    {
                        height: 183,
                        value: 4.27
                    },
                    {
                        height: 191,
                        value: 4.7
                    },
                    {
                        height: 198,
                        value: 5.1
                    },
                    {
                        height: 206,
                        value: 5.58
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.46
                    },
                    {
                        height: 122,
                        value: 1.7
                    },
                    {
                        height: 130,
                        value: 1.96
                    },
                    {
                        height: 137,
                        value: 2.21
                    },
                    {
                        height: 145,
                        value: 2.51
                    },
                    {
                        height: 152,
                        value: 2.79
                    },
                    {
                        height: 160,
                        value: 3.14
                    },
                    {
                        height: 168,
                        value: 3.5
                    },
                    {
                        height: 175,
                        value: 3.84
                    },
                    {
                        height: 183,
                        value: 4.25
                    },
                    {
                        height: 191,
                        value: 4.68
                    },
                    {
                        height: 198,
                        value: 5.08
                    },
                    {
                        height: 206,
                        value: 5.56
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.44
                    },
                    {
                        height: 122,
                        value: 1.68
                    },
                    {
                        height: 130,
                        value: 1.94
                    },
                    {
                        height: 137,
                        value: 2.18
                    },
                    {
                        height: 145,
                        value: 2.48
                    },
                    {
                        height: 152,
                        value: 2.76
                    },
                    {
                        height: 160,
                        value: 3.1
                    },
                    {
                        height: 168,
                        value: 3.47
                    },
                    {
                        height: 175,
                        value: 3.8
                    },
                    {
                        height: 183,
                        value: 4.21
                    },
                    {
                        height: 191,
                        value: 4.63
                    },
                    {
                        height: 198,
                        value: 5.03
                    },
                    {
                        height: 206,
                        value: 5.5
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.41
                    },
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.9
                    },
                    {
                        height: 137,
                        value: 2.14
                    },
                    {
                        height: 145,
                        value: 2.43
                    },
                    {
                        height: 152,
                        value: 2.71
                    },
                    {
                        height: 160,
                        value: 3.04
                    },
                    {
                        height: 168,
                        value: 3.4
                    },
                    {
                        height: 175,
                        value: 3.72
                    },
                    {
                        height: 183,
                        value: 4.12
                    },
                    {
                        height: 191,
                        value: 4.54
                    },
                    {
                        height: 198,
                        value: 4.93
                    },
                    {
                        height: 206,
                        value: 5.39
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.37
                    },
                    {
                        height: 122,
                        value: 1.6
                    },
                    {
                        height: 130,
                        value: 1.85
                    },
                    {
                        height: 137,
                        value: 2.08
                    },
                    {
                        height: 145,
                        value: 2.36
                    },
                    {
                        height: 152,
                        value: 2.63
                    },
                    {
                        height: 160,
                        value: 2.95
                    },
                    {
                        height: 168,
                        value: 3.3
                    },
                    {
                        height: 175,
                        value: 3.62
                    },
                    {
                        height: 183,
                        value: 4
                    },
                    {
                        height: 191,
                        value: 4.41
                    },
                    {
                        height: 198,
                        value: 4.78
                    },
                    {
                        height: 206,
                        value: 5.23
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.32
                    },
                    {
                        height: 122,
                        value: 1.54
                    },
                    {
                        height: 130,
                        value: 1.78
                    },
                    {
                        height: 137,
                        value: 2.01
                    },
                    {
                        height: 145,
                        value: 2.28
                    },
                    {
                        height: 152,
                        value: 2.54
                    },
                    {
                        height: 160,
                        value: 2.85
                    },
                    {
                        height: 168,
                        value: 3.18
                    },
                    {
                        height: 175,
                        value: 3.49
                    },
                    {
                        height: 183,
                        value: 3.87
                    },
                    {
                        height: 191,
                        value: 4.26
                    },
                    {
                        height: 198,
                        value: 4.62
                    },
                    {
                        height: 206,
                        value: 5.05
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.27
                    },
                    {
                        height: 122,
                        value: 1.48
                    },
                    {
                        height: 130,
                        value: 1.71
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.44
                    },
                    {
                        height: 160,
                        value: 2.74
                    },
                    {
                        height: 168,
                        value: 3.06
                    },
                    {
                        height: 175,
                        value: 3.36
                    },
                    {
                        height: 183,
                        value: 3.71
                    },
                    {
                        height: 191,
                        value: 4.09
                    },
                    {
                        height: 198,
                        value: 4.44
                    },
                    {
                        height: 206,
                        value: 4.85
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.21
                    },
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.64
                    },
                    {
                        height: 137,
                        value: 1.84
                    },
                    {
                        height: 145,
                        value: 2.09
                    },
                    {
                        height: 152,
                        value: 2.33
                    },
                    {
                        height: 160,
                        value: 2.62
                    },
                    {
                        height: 168,
                        value: 2.92
                    },
                    {
                        height: 175,
                        value: 3.2
                    },
                    {
                        height: 183,
                        value: 3.55
                    },
                    {
                        height: 191,
                        value: 3.91
                    },
                    {
                        height: 198,
                        value: 4.24
                    },
                    {
                        height: 206,
                        value: 4.63
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.15
                    },
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 1.99
                    },
                    {
                        height: 152,
                        value: 2.21
                    },
                    {
                        height: 160,
                        value: 2.49
                    },
                    {
                        height: 168,
                        value: 2.78
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.37
                    },
                    {
                        height: 191,
                        value: 3.71
                    },
                    {
                        height: 198,
                        value: 4.03
                    },
                    {
                        height: 206,
                        value: 4.4
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.09
                    },
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.47
                    },
                    {
                        height: 137,
                        value: 1.66
                    },
                    {
                        height: 145,
                        value: 1.88
                    },
                    {
                        height: 152,
                        value: 2.1
                    },
                    {
                        height: 160,
                        value: 2.35
                    },
                    {
                        height: 168,
                        value: 2.63
                    },
                    {
                        height: 175,
                        value: 2.88
                    },
                    {
                        height: 183,
                        value: 3.19
                    },
                    {
                        height: 191,
                        value: 3.51
                    },
                    {
                        height: 198,
                        value: 3.81
                    },
                    {
                        height: 206,
                        value: 4.17
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 1.03
                    },
                    {
                        height: 122,
                        value: 1.2
                    },
                    {
                        height: 130,
                        value: 1.39
                    },
                    {
                        height: 137,
                        value: 1.56
                    },
                    {
                        height: 145,
                        value: 1.78
                    },
                    {
                        height: 152,
                        value: 1.98
                    },
                    {
                        height: 160,
                        value: 2.22
                    },
                    {
                        height: 168,
                        value: 2.48
                    },
                    {
                        height: 175,
                        value: 2.72
                    },
                    {
                        height: 183,
                        value: 3.01
                    },
                    {
                        height: 191,
                        value: 3.32
                    },
                    {
                        height: 198,
                        value: 3.6
                    },
                    {
                        height: 206,
                        value: 3.94
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.98
                    },
                    {
                        height: 122,
                        value: 1.14
                    },
                    {
                        height: 130,
                        value: 1.31
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.68
                    },
                    {
                        height: 152,
                        value: 1.87
                    },
                    {
                        height: 160,
                        value: 2.1
                    },
                    {
                        height: 168,
                        value: 2.35
                    },
                    {
                        height: 175,
                        value: 2.57
                    },
                    {
                        height: 183,
                        value: 2.85
                    },
                    {
                        height: 191,
                        value: 3.14
                    },
                    {
                        height: 198,
                        value: 3.4
                    },
                    {
                        height: 206,
                        value: 3.72
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 1.08
                    },
                    {
                        height: 130,
                        value: 1.24
                    },
                    {
                        height: 137,
                        value: 1.4
                    },
                    {
                        height: 145,
                        value: 1.59
                    },
                    {
                        height: 152,
                        value: 1.77
                    },
                    {
                        height: 160,
                        value: 1.99
                    },
                    {
                        height: 168,
                        value: 2.22
                    },
                    {
                        height: 175,
                        value: 2.44
                    },
                    {
                        height: 183,
                        value: 2.7
                    },
                    {
                        height: 191,
                        value: 2.97
                    },
                    {
                        height: 198,
                        value: 3.22
                    },
                    {
                        height: 206,
                        value: 3.52
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 1.02
                    },
                    {
                        height: 130,
                        value: 1.18
                    },
                    {
                        height: 137,
                        value: 1.33
                    },
                    {
                        height: 145,
                        value: 1.51
                    },
                    {
                        height: 152,
                        value: 1.68
                    },
                    {
                        height: 160,
                        value: 1.89
                    },
                    {
                        height: 168,
                        value: 2.11
                    },
                    {
                        height: 175,
                        value: 2.31
                    },
                    {
                        height: 183,
                        value: 2.56
                    },
                    {
                        height: 191,
                        value: 2.82
                    },
                    {
                        height: 198,
                        value: 3.06
                    },
                    {
                        height: 206,
                        value: 3.35
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.97
                    },
                    {
                        height: 130,
                        value: 1.12
                    },
                    {
                        height: 137,
                        value: 1.27
                    },
                    {
                        height: 145,
                        value: 1.44
                    },
                    {
                        height: 152,
                        value: 1.6
                    },
                    {
                        height: 160,
                        value: 1.8
                    },
                    {
                        height: 168,
                        value: 2.01
                    },
                    {
                        height: 175,
                        value: 2.2
                    },
                    {
                        height: 183,
                        value: 2.44
                    },
                    {
                        height: 191,
                        value: 2.69
                    },
                    {
                        height: 198,
                        value: 2.91
                    },
                    {
                        height: 206,
                        value: 3.19
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1
                    },
                    {
                        height: 122,
                        value: 1.16
                    },
                    {
                        height: 130,
                        value: 1.32
                    },
                    {
                        height: 137,
                        value: 1.48
                    },
                    {
                        height: 145,
                        value: 1.67
                    },
                    {
                        height: 152,
                        value: 1.84
                    },
                    {
                        height: 160,
                        value: 2.05
                    },
                    {
                        height: 168,
                        value: 2.28
                    },
                    {
                        height: 175,
                        value: 2.48
                    },
                    {
                        height: 183,
                        value: 2.73
                    },
                    {
                        height: 191,
                        value: 2.99
                    },
                    {
                        height: 198,
                        value: 3.23
                    },
                    {
                        height: 206,
                        value: 3.51
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.08
                    },
                    {
                        height: 122,
                        value: 1.25
                    },
                    {
                        height: 130,
                        value: 1.43
                    },
                    {
                        height: 137,
                        value: 1.6
                    },
                    {
                        height: 145,
                        value: 1.8
                    },
                    {
                        height: 152,
                        value: 1.99
                    },
                    {
                        height: 160,
                        value: 2.22
                    },
                    {
                        height: 168,
                        value: 2.46
                    },
                    {
                        height: 175,
                        value: 2.69
                    },
                    {
                        height: 183,
                        value: 2.95
                    },
                    {
                        height: 191,
                        value: 3.23
                    },
                    {
                        height: 198,
                        value: 3.49
                    },
                    {
                        height: 206,
                        value: 3.8
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.3
                    },
                    {
                        height: 122,
                        value: 1.5
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.92
                    },
                    {
                        height: 145,
                        value: 2.17
                    },
                    {
                        height: 152,
                        value: 2.4
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 2.96
                    },
                    {
                        height: 175,
                        value: 3.23
                    },
                    {
                        height: 183,
                        value: 3.55
                    },
                    {
                        height: 191,
                        value: 3.89
                    },
                    {
                        height: 198,
                        value: 4.2
                    },
                    {
                        height: 206,
                        value: 4.57
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.35
                    },
                    {
                        height: 122,
                        value: 1.56
                    },
                    {
                        height: 130,
                        value: 1.79
                    },
                    {
                        height: 137,
                        value: 2
                    },
                    {
                        height: 145,
                        value: 2.25
                    },
                    {
                        height: 152,
                        value: 2.49
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.08
                    },
                    {
                        height: 175,
                        value: 3.36
                    },
                    {
                        height: 183,
                        value: 3.69
                    },
                    {
                        height: 191,
                        value: 4.04
                    },
                    {
                        height: 198,
                        value: 4.36
                    },
                    {
                        height: 206,
                        value: 4.74
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.33
                    },
                    {
                        height: 122,
                        value: 1.54
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 1.97
                    },
                    {
                        height: 145,
                        value: 2.22
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.74
                    },
                    {
                        height: 168,
                        value: 3.03
                    },
                    {
                        height: 175,
                        value: 3.31
                    },
                    {
                        height: 183,
                        value: 3.64
                    },
                    {
                        height: 191,
                        value: 3.98
                    },
                    {
                        height: 198,
                        value: 4.3
                    },
                    {
                        height: 206,
                        value: 4.68
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.3
                    },
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.72
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.17
                    },
                    {
                        height: 152,
                        value: 2.4
                    },
                    {
                        height: 160,
                        value: 2.68
                    },
                    {
                        height: 168,
                        value: 2.97
                    },
                    {
                        height: 175,
                        value: 3.24
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.9
                    },
                    {
                        height: 198,
                        value: 4.21
                    },
                    {
                        height: 206,
                        value: 4.58
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.27
                    },
                    {
                        height: 122,
                        value: 1.47
                    },
                    {
                        height: 130,
                        value: 1.68
                    },
                    {
                        height: 137,
                        value: 1.88
                    },
                    {
                        height: 145,
                        value: 2.12
                    },
                    {
                        height: 152,
                        value: 2.34
                    },
                    {
                        height: 160,
                        value: 2.61
                    },
                    {
                        height: 168,
                        value: 2.89
                    },
                    {
                        height: 175,
                        value: 3.15
                    },
                    {
                        height: 183,
                        value: 3.47
                    },
                    {
                        height: 191,
                        value: 3.8
                    },
                    {
                        height: 198,
                        value: 4.1
                    },
                    {
                        height: 206,
                        value: 4.46
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.23
                    },
                    {
                        height: 122,
                        value: 1.42
                    },
                    {
                        height: 130,
                        value: 1.62
                    },
                    {
                        height: 137,
                        value: 1.81
                    },
                    {
                        height: 145,
                        value: 2.04
                    },
                    {
                        height: 152,
                        value: 2.26
                    },
                    {
                        height: 160,
                        value: 2.51
                    },
                    {
                        height: 168,
                        value: 2.79
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.34
                    },
                    {
                        height: 191,
                        value: 3.66
                    },
                    {
                        height: 198,
                        value: 3.95
                    },
                    {
                        height: 206,
                        value: 4.3
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.17
                    },
                    {
                        height: 122,
                        value: 1.36
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.73
                    },
                    {
                        height: 145,
                        value: 1.96
                    },
                    {
                        height: 152,
                        value: 2.16
                    },
                    {
                        height: 160,
                        value: 2.41
                    },
                    {
                        height: 168,
                        value: 2.67
                    },
                    {
                        height: 175,
                        value: 2.92
                    },
                    {
                        height: 183,
                        value: 3.21
                    },
                    {
                        height: 191,
                        value: 3.51
                    },
                    {
                        height: 198,
                        value: 3.79
                    },
                    {
                        height: 206,
                        value: 4.12
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.12
                    },
                    {
                        height: 122,
                        value: 1.3
                    },
                    {
                        height: 130,
                        value: 1.48
                    },
                    {
                        height: 137,
                        value: 1.66
                    },
                    {
                        height: 145,
                        value: 1.87
                    },
                    {
                        height: 152,
                        value: 2.07
                    },
                    {
                        height: 160,
                        value: 2.31
                    },
                    {
                        height: 168,
                        value: 2.56
                    },
                    {
                        height: 175,
                        value: 2.79
                    },
                    {
                        height: 183,
                        value: 3.07
                    },
                    {
                        height: 191,
                        value: 3.36
                    },
                    {
                        height: 198,
                        value: 3.62
                    },
                    {
                        height: 206,
                        value: 3.94
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.07
                    },
                    {
                        height: 122,
                        value: 1.24
                    },
                    {
                        height: 130,
                        value: 1.41
                    },
                    {
                        height: 137,
                        value: 1.58
                    },
                    {
                        height: 145,
                        value: 1.78
                    },
                    {
                        height: 152,
                        value: 1.97
                    },
                    {
                        height: 160,
                        value: 2.2
                    },
                    {
                        height: 168,
                        value: 2.44
                    },
                    {
                        height: 175,
                        value: 2.66
                    },
                    {
                        height: 183,
                        value: 2.92
                    },
                    {
                        height: 191,
                        value: 3.2
                    },
                    {
                        height: 198,
                        value: 3.45
                    },
                    {
                        height: 206,
                        value: 3.75
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.01
                    },
                    {
                        height: 122,
                        value: 1.17
                    },
                    {
                        height: 130,
                        value: 1.34
                    },
                    {
                        height: 137,
                        value: 1.5
                    },
                    {
                        height: 145,
                        value: 1.69
                    },
                    {
                        height: 152,
                        value: 1.87
                    },
                    {
                        height: 160,
                        value: 2.08
                    },
                    {
                        height: 168,
                        value: 2.31
                    },
                    {
                        height: 175,
                        value: 2.52
                    },
                    {
                        height: 183,
                        value: 2.77
                    },
                    {
                        height: 191,
                        value: 3.03
                    },
                    {
                        height: 198,
                        value: 3.27
                    },
                    {
                        height: 206,
                        value: 3.56
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.96
                    },
                    {
                        height: 122,
                        value: 1.1
                    },
                    {
                        height: 130,
                        value: 1.26
                    },
                    {
                        height: 137,
                        value: 1.41
                    },
                    {
                        height: 145,
                        value: 1.59
                    },
                    {
                        height: 152,
                        value: 1.76
                    },
                    {
                        height: 160,
                        value: 1.96
                    },
                    {
                        height: 168,
                        value: 2.18
                    },
                    {
                        height: 175,
                        value: 2.37
                    },
                    {
                        height: 183,
                        value: 2.61
                    },
                    {
                        height: 191,
                        value: 2.86
                    },
                    {
                        height: 198,
                        value: 3.08
                    },
                    {
                        height: 206,
                        value: 3.35
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.9
                    },
                    {
                        height: 122,
                        value: 1.04
                    },
                    {
                        height: 130,
                        value: 1.19
                    },
                    {
                        height: 137,
                        value: 1.32
                    },
                    {
                        height: 145,
                        value: 1.49
                    },
                    {
                        height: 152,
                        value: 1.65
                    },
                    {
                        height: 160,
                        value: 1.84
                    },
                    {
                        height: 168,
                        value: 2.04
                    },
                    {
                        height: 175,
                        value: 2.23
                    },
                    {
                        height: 183,
                        value: 2.45
                    },
                    {
                        height: 191,
                        value: 2.68
                    },
                    {
                        height: 198,
                        value: 2.89
                    },
                    {
                        height: 206,
                        value: 3.15
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.97
                    },
                    {
                        height: 130,
                        value: 1.11
                    },
                    {
                        height: 137,
                        value: 1.24
                    },
                    {
                        height: 145,
                        value: 1.4
                    },
                    {
                        height: 152,
                        value: 1.54
                    },
                    {
                        height: 160,
                        value: 1.72
                    },
                    {
                        height: 168,
                        value: 1.91
                    },
                    {
                        height: 175,
                        value: 2.08
                    },
                    {
                        height: 183,
                        value: 2.29
                    },
                    {
                        height: 191,
                        value: 2.51
                    },
                    {
                        height: 198,
                        value: 2.71
                    },
                    {
                        height: 206,
                        value: 2.94
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.78
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 1.04
                    },
                    {
                        height: 137,
                        value: 1.16
                    },
                    {
                        height: 145,
                        value: 1.31
                    },
                    {
                        height: 152,
                        value: 1.44
                    },
                    {
                        height: 160,
                        value: 1.61
                    },
                    {
                        height: 168,
                        value: 1.79
                    },
                    {
                        height: 175,
                        value: 1.95
                    },
                    {
                        height: 183,
                        value: 2.14
                    },
                    {
                        height: 191,
                        value: 2.35
                    },
                    {
                        height: 198,
                        value: 2.53
                    },
                    {
                        height: 206,
                        value: 2.75
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.74
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.97
                    },
                    {
                        height: 137,
                        value: 1.09
                    },
                    {
                        height: 145,
                        value: 1.23
                    },
                    {
                        height: 152,
                        value: 1.36
                    },
                    {
                        height: 160,
                        value: 1.51
                    },
                    {
                        height: 168,
                        value: 1.68
                    },
                    {
                        height: 175,
                        value: 1.83
                    },
                    {
                        height: 183,
                        value: 2.01
                    },
                    {
                        height: 191,
                        value: 2.2
                    },
                    {
                        height: 198,
                        value: 2.37
                    },
                    {
                        height: 206,
                        value: 2.58
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.69
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 1.02
                    },
                    {
                        height: 145,
                        value: 1.15
                    },
                    {
                        height: 152,
                        value: 1.27
                    },
                    {
                        height: 160,
                        value: 1.42
                    },
                    {
                        height: 168,
                        value: 1.58
                    },
                    {
                        height: 175,
                        value: 1.72
                    },
                    {
                        height: 183,
                        value: 1.89
                    },
                    {
                        height: 191,
                        value: 2.07
                    },
                    {
                        height: 198,
                        value: 2.23
                    },
                    {
                        height: 206,
                        value: 2.43
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.65
                    },
                    {
                        height: 122,
                        value: 0.75
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.97
                    },
                    {
                        height: 145,
                        value: 1.09
                    },
                    {
                        height: 152,
                        value: 1.2
                    },
                    {
                        height: 160,
                        value: 1.34
                    },
                    {
                        height: 168,
                        value: 1.49
                    },
                    {
                        height: 175,
                        value: 1.62
                    },
                    {
                        height: 183,
                        value: 1.78
                    },
                    {
                        height: 191,
                        value: 1.95
                    },
                    {
                        height: 198,
                        value: 2.11
                    },
                    {
                        height: 206,
                        value: 2.29
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.88
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.87
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.9
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 0.9
                    },
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.87
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.86
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 0.89
                    },
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 0.87
                    },
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "Other",
        gender: "Male",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.44
                    },
                    {
                        height: 130,
                        value: 1.68
                    },
                    {
                        height: 137,
                        value: 1.9
                    },
                    {
                        height: 145,
                        value: 2.18
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.77
                    },
                    {
                        height: 168,
                        value: 3.12
                    },
                    {
                        height: 175,
                        value: 3.44
                    },
                    {
                        height: 183,
                        value: 3.83
                    },
                    {
                        height: 191,
                        value: 4.25
                    },
                    {
                        height: 198,
                        value: 4.63
                    },
                    {
                        height: 206,
                        value: 5.1
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.55
                    },
                    {
                        height: 130,
                        value: 1.81
                    },
                    {
                        height: 137,
                        value: 2.06
                    },
                    {
                        height: 145,
                        value: 2.36
                    },
                    {
                        height: 152,
                        value: 2.64
                    },
                    {
                        height: 160,
                        value: 2.99
                    },
                    {
                        height: 168,
                        value: 3.37
                    },
                    {
                        height: 175,
                        value: 3.71
                    },
                    {
                        height: 183,
                        value: 4.14
                    },
                    {
                        height: 191,
                        value: 4.59
                    },
                    {
                        height: 198,
                        value: 5
                    },
                    {
                        height: 206,
                        value: 5.5
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.8
                    },
                    {
                        height: 130,
                        value: 2.1
                    },
                    {
                        height: 137,
                        value: 2.38
                    },
                    {
                        height: 145,
                        value: 2.73
                    },
                    {
                        height: 152,
                        value: 3.06
                    },
                    {
                        height: 160,
                        value: 3.46
                    },
                    {
                        height: 168,
                        value: 3.89
                    },
                    {
                        height: 175,
                        value: 4.3
                    },
                    {
                        height: 183,
                        value: 4.79
                    },
                    {
                        height: 191,
                        value: 5.31
                    },
                    {
                        height: 198,
                        value: 5.79
                    },
                    {
                        height: 206,
                        value: 6.37
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 2.03
                    },
                    {
                        height: 130,
                        value: 2.37
                    },
                    {
                        height: 137,
                        value: 2.69
                    },
                    {
                        height: 145,
                        value: 3.09
                    },
                    {
                        height: 152,
                        value: 3.46
                    },
                    {
                        height: 160,
                        value: 3.91
                    },
                    {
                        height: 168,
                        value: 4.4
                    },
                    {
                        height: 175,
                        value: 4.86
                    },
                    {
                        height: 183,
                        value: 5.41
                    },
                    {
                        height: 191,
                        value: 6
                    },
                    {
                        height: 198,
                        value: 6.55
                    },
                    {
                        height: 206,
                        value: 7.2
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 2.05
                    },
                    {
                        height: 130,
                        value: 2.39
                    },
                    {
                        height: 137,
                        value: 2.72
                    },
                    {
                        height: 145,
                        value: 3.12
                    },
                    {
                        height: 152,
                        value: 3.49
                    },
                    {
                        height: 160,
                        value: 3.95
                    },
                    {
                        height: 168,
                        value: 4.44
                    },
                    {
                        height: 175,
                        value: 4.9
                    },
                    {
                        height: 183,
                        value: 5.46
                    },
                    {
                        height: 191,
                        value: 6.06
                    },
                    {
                        height: 198,
                        value: 6.61
                    },
                    {
                        height: 206,
                        value: 7.27
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 2.02
                    },
                    {
                        height: 130,
                        value: 2.36
                    },
                    {
                        height: 137,
                        value: 2.67
                    },
                    {
                        height: 145,
                        value: 3.07
                    },
                    {
                        height: 152,
                        value: 3.44
                    },
                    {
                        height: 160,
                        value: 3.89
                    },
                    {
                        height: 168,
                        value: 4.38
                    },
                    {
                        height: 175,
                        value: 4.83
                    },
                    {
                        height: 183,
                        value: 5.38
                    },
                    {
                        height: 191,
                        value: 5.96
                    },
                    {
                        height: 198,
                        value: 6.51
                    },
                    {
                        height: 206,
                        value: 7.16
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.99
                    },
                    {
                        height: 130,
                        value: 2.31
                    },
                    {
                        height: 137,
                        value: 2.63
                    },
                    {
                        height: 145,
                        value: 3.01
                    },
                    {
                        height: 152,
                        value: 3.38
                    },
                    {
                        height: 160,
                        value: 3.82
                    },
                    {
                        height: 168,
                        value: 4.3
                    },
                    {
                        height: 175,
                        value: 4.74
                    },
                    {
                        height: 183,
                        value: 5.28
                    },
                    {
                        height: 191,
                        value: 5.86
                    },
                    {
                        height: 198,
                        value: 6.39
                    },
                    {
                        height: 206,
                        value: 7.03
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.95
                    },
                    {
                        height: 130,
                        value: 2.27
                    },
                    {
                        height: 137,
                        value: 2.58
                    },
                    {
                        height: 145,
                        value: 2.96
                    },
                    {
                        height: 152,
                        value: 3.31
                    },
                    {
                        height: 160,
                        value: 3.75
                    },
                    {
                        height: 168,
                        value: 4.22
                    },
                    {
                        height: 175,
                        value: 4.65
                    },
                    {
                        height: 183,
                        value: 5.18
                    },
                    {
                        height: 191,
                        value: 5.75
                    },
                    {
                        height: 198,
                        value: 6.27
                    },
                    {
                        height: 206,
                        value: 6.9
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.9
                    },
                    {
                        height: 130,
                        value: 2.22
                    },
                    {
                        height: 137,
                        value: 2.52
                    },
                    {
                        height: 145,
                        value: 2.89
                    },
                    {
                        height: 152,
                        value: 3.24
                    },
                    {
                        height: 160,
                        value: 3.66
                    },
                    {
                        height: 168,
                        value: 4.12
                    },
                    {
                        height: 175,
                        value: 4.55
                    },
                    {
                        height: 183,
                        value: 5.06
                    },
                    {
                        height: 191,
                        value: 5.61
                    },
                    {
                        height: 198,
                        value: 6.12
                    },
                    {
                        height: 206,
                        value: 6.74
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.85
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.45
                    },
                    {
                        height: 145,
                        value: 2.81
                    },
                    {
                        height: 152,
                        value: 3.15
                    },
                    {
                        height: 160,
                        value: 3.56
                    },
                    {
                        height: 168,
                        value: 4.01
                    },
                    {
                        height: 175,
                        value: 4.42
                    },
                    {
                        height: 183,
                        value: 4.92
                    },
                    {
                        height: 191,
                        value: 5.46
                    },
                    {
                        height: 198,
                        value: 5.96
                    },
                    {
                        height: 206,
                        value: 6.55
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.79
                    },
                    {
                        height: 130,
                        value: 2.09
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.72
                    },
                    {
                        height: 152,
                        value: 3.04
                    },
                    {
                        height: 160,
                        value: 3.45
                    },
                    {
                        height: 168,
                        value: 3.88
                    },
                    {
                        height: 175,
                        value: 4.28
                    },
                    {
                        height: 183,
                        value: 4.76
                    },
                    {
                        height: 191,
                        value: 5.28
                    },
                    {
                        height: 198,
                        value: 5.76
                    },
                    {
                        height: 206,
                        value: 6.34
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 2.01
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.61
                    },
                    {
                        height: 152,
                        value: 2.93
                    },
                    {
                        height: 160,
                        value: 3.31
                    },
                    {
                        height: 168,
                        value: 3.73
                    },
                    {
                        height: 175,
                        value: 4.11
                    },
                    {
                        height: 183,
                        value: 4.58
                    },
                    {
                        height: 191,
                        value: 5.08
                    },
                    {
                        height: 198,
                        value: 5.54
                    },
                    {
                        height: 206,
                        value: 6.1
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.18
                    },
                    {
                        height: 145,
                        value: 2.5
                    },
                    {
                        height: 152,
                        value: 2.8
                    },
                    {
                        height: 160,
                        value: 3.17
                    },
                    {
                        height: 168,
                        value: 3.57
                    },
                    {
                        height: 175,
                        value: 3.94
                    },
                    {
                        height: 183,
                        value: 4.39
                    },
                    {
                        height: 191,
                        value: 4.87
                    },
                    {
                        height: 198,
                        value: 5.31
                    },
                    {
                        height: 206,
                        value: 5.84
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.58
                    },
                    {
                        height: 130,
                        value: 1.84
                    },
                    {
                        height: 137,
                        value: 2.09
                    },
                    {
                        height: 145,
                        value: 2.39
                    },
                    {
                        height: 152,
                        value: 2.68
                    },
                    {
                        height: 160,
                        value: 3.03
                    },
                    {
                        height: 168,
                        value: 3.41
                    },
                    {
                        height: 175,
                        value: 3.77
                    },
                    {
                        height: 183,
                        value: 4.2
                    },
                    {
                        height: 191,
                        value: 4.65
                    },
                    {
                        height: 198,
                        value: 5.07
                    },
                    {
                        height: 206,
                        value: 5.58
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.51
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 2
                    },
                    {
                        height: 145,
                        value: 2.29
                    },
                    {
                        height: 152,
                        value: 2.56
                    },
                    {
                        height: 160,
                        value: 2.9
                    },
                    {
                        height: 168,
                        value: 3.26
                    },
                    {
                        height: 175,
                        value: 3.6
                    },
                    {
                        height: 183,
                        value: 4.01
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.85
                    },
                    {
                        height: 206,
                        value: 5.34
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.44
                    },
                    {
                        height: 130,
                        value: 1.68
                    },
                    {
                        height: 137,
                        value: 1.91
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.45
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.13
                    },
                    {
                        height: 175,
                        value: 3.45
                    },
                    {
                        height: 183,
                        value: 3.84
                    },
                    {
                        height: 191,
                        value: 4.26
                    },
                    {
                        height: 198,
                        value: 4.65
                    },
                    {
                        height: 206,
                        value: 5.11
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.61
                    },
                    {
                        height: 137,
                        value: 1.83
                    },
                    {
                        height: 145,
                        value: 2.1
                    },
                    {
                        height: 152,
                        value: 2.36
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 3
                    },
                    {
                        height: 175,
                        value: 3.31
                    },
                    {
                        height: 183,
                        value: 3.69
                    },
                    {
                        height: 191,
                        value: 4.09
                    },
                    {
                        height: 198,
                        value: 4.46
                    },
                    {
                        height: 206,
                        value: 4.9
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.33
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.76
                    },
                    {
                        height: 145,
                        value: 2.02
                    },
                    {
                        height: 152,
                        value: 2.26
                    },
                    {
                        height: 160,
                        value: 2.56
                    },
                    {
                        height: 168,
                        value: 2.88
                    },
                    {
                        height: 175,
                        value: 3.18
                    },
                    {
                        height: 183,
                        value: 3.54
                    },
                    {
                        height: 191,
                        value: 3.93
                    },
                    {
                        height: 198,
                        value: 4.29
                    },
                    {
                        height: 206,
                        value: 4.72
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1.28
                    },
                    {
                        height: 130,
                        value: 1.5
                    },
                    {
                        height: 137,
                        value: 1.7
                    },
                    {
                        height: 145,
                        value: 1.95
                    },
                    {
                        height: 152,
                        value: 2.18
                    },
                    {
                        height: 160,
                        value: 2.47
                    },
                    {
                        height: 168,
                        value: 2.78
                    },
                    {
                        height: 175,
                        value: 3.07
                    },
                    {
                        height: 183,
                        value: 3.41
                    },
                    {
                        height: 191,
                        value: 3.79
                    },
                    {
                        height: 198,
                        value: 4.13
                    },
                    {
                        height: 206,
                        value: 4.54
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 1.31
                    },
                    {
                        height: 130,
                        value: 1.5
                    },
                    {
                        height: 137,
                        value: 1.69
                    },
                    {
                        height: 145,
                        value: 1.92
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.38
                    },
                    {
                        height: 168,
                        value: 2.66
                    },
                    {
                        height: 175,
                        value: 2.91
                    },
                    {
                        height: 183,
                        value: 3.21
                    },
                    {
                        height: 191,
                        value: 3.53
                    },
                    {
                        height: 198,
                        value: 3.83
                    },
                    {
                        height: 206,
                        value: 4.18
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 1.39
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.79
                    },
                    {
                        height: 145,
                        value: 2.04
                    },
                    {
                        height: 152,
                        value: 2.26
                    },
                    {
                        height: 160,
                        value: 2.53
                    },
                    {
                        height: 168,
                        value: 2.82
                    },
                    {
                        height: 175,
                        value: 3.09
                    },
                    {
                        height: 183,
                        value: 3.41
                    },
                    {
                        height: 191,
                        value: 3.75
                    },
                    {
                        height: 198,
                        value: 4.06
                    },
                    {
                        height: 206,
                        value: 4.44
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 1.67
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.16
                    },
                    {
                        height: 145,
                        value: 2.45
                    },
                    {
                        height: 152,
                        value: 2.72
                    },
                    {
                        height: 160,
                        value: 3.05
                    },
                    {
                        height: 168,
                        value: 3.4
                    },
                    {
                        height: 175,
                        value: 3.72
                    },
                    {
                        height: 183,
                        value: 4.11
                    },
                    {
                        height: 191,
                        value: 4.52
                    },
                    {
                        height: 198,
                        value: 4.89
                    },
                    {
                        height: 206,
                        value: 5.34
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 1.88
                    },
                    {
                        height: 130,
                        value: 2.16
                    },
                    {
                        height: 137,
                        value: 2.43
                    },
                    {
                        height: 145,
                        value: 2.76
                    },
                    {
                        height: 152,
                        value: 3.06
                    },
                    {
                        height: 160,
                        value: 3.43
                    },
                    {
                        height: 168,
                        value: 3.82
                    },
                    {
                        height: 175,
                        value: 4.18
                    },
                    {
                        height: 183,
                        value: 4.62
                    },
                    {
                        height: 191,
                        value: 5.08
                    },
                    {
                        height: 198,
                        value: 5.5
                    },
                    {
                        height: 206,
                        value: 6.01
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 1.87
                    },
                    {
                        height: 130,
                        value: 2.15
                    },
                    {
                        height: 137,
                        value: 2.42
                    },
                    {
                        height: 145,
                        value: 2.74
                    },
                    {
                        height: 152,
                        value: 3.04
                    },
                    {
                        height: 160,
                        value: 3.41
                    },
                    {
                        height: 168,
                        value: 3.8
                    },
                    {
                        height: 175,
                        value: 4.16
                    },
                    {
                        height: 183,
                        value: 4.59
                    },
                    {
                        height: 191,
                        value: 5.05
                    },
                    {
                        height: 198,
                        value: 5.47
                    },
                    {
                        height: 206,
                        value: 5.98
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 1.81
                    },
                    {
                        height: 130,
                        value: 2.09
                    },
                    {
                        height: 137,
                        value: 2.34
                    },
                    {
                        height: 145,
                        value: 2.66
                    },
                    {
                        height: 152,
                        value: 2.95
                    },
                    {
                        height: 160,
                        value: 3.31
                    },
                    {
                        height: 168,
                        value: 3.69
                    },
                    {
                        height: 175,
                        value: 4.04
                    },
                    {
                        height: 183,
                        value: 4.46
                    },
                    {
                        height: 191,
                        value: 4.9
                    },
                    {
                        height: 198,
                        value: 5.31
                    },
                    {
                        height: 206,
                        value: 5.8
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 1.76
                    },
                    {
                        height: 130,
                        value: 2.03
                    },
                    {
                        height: 137,
                        value: 2.28
                    },
                    {
                        height: 145,
                        value: 2.58
                    },
                    {
                        height: 152,
                        value: 2.87
                    },
                    {
                        height: 160,
                        value: 3.21
                    },
                    {
                        height: 168,
                        value: 3.58
                    },
                    {
                        height: 175,
                        value: 3.92
                    },
                    {
                        height: 183,
                        value: 4.33
                    },
                    {
                        height: 191,
                        value: 4.76
                    },
                    {
                        height: 198,
                        value: 5.16
                    },
                    {
                        height: 206,
                        value: 5.63
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 1.71
                    },
                    {
                        height: 130,
                        value: 1.96
                    },
                    {
                        height: 137,
                        value: 2.21
                    },
                    {
                        height: 145,
                        value: 2.5
                    },
                    {
                        height: 152,
                        value: 2.78
                    },
                    {
                        height: 160,
                        value: 3.11
                    },
                    {
                        height: 168,
                        value: 3.47
                    },
                    {
                        height: 175,
                        value: 3.8
                    },
                    {
                        height: 183,
                        value: 4.2
                    },
                    {
                        height: 191,
                        value: 4.61
                    },
                    {
                        height: 198,
                        value: 5
                    },
                    {
                        height: 206,
                        value: 5.46
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 1.65
                    },
                    {
                        height: 130,
                        value: 1.9
                    },
                    {
                        height: 137,
                        value: 2.13
                    },
                    {
                        height: 145,
                        value: 2.42
                    },
                    {
                        height: 152,
                        value: 2.68
                    },
                    {
                        height: 160,
                        value: 3.01
                    },
                    {
                        height: 168,
                        value: 3.35
                    },
                    {
                        height: 175,
                        value: 3.67
                    },
                    {
                        height: 183,
                        value: 4.05
                    },
                    {
                        height: 191,
                        value: 4.45
                    },
                    {
                        height: 198,
                        value: 4.82
                    },
                    {
                        height: 206,
                        value: 5.27
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 1.59
                    },
                    {
                        height: 130,
                        value: 1.83
                    },
                    {
                        height: 137,
                        value: 2.05
                    },
                    {
                        height: 145,
                        value: 2.33
                    },
                    {
                        height: 152,
                        value: 2.59
                    },
                    {
                        height: 160,
                        value: 2.9
                    },
                    {
                        height: 168,
                        value: 3.23
                    },
                    {
                        height: 175,
                        value: 3.54
                    },
                    {
                        height: 183,
                        value: 3.9
                    },
                    {
                        height: 191,
                        value: 4.29
                    },
                    {
                        height: 198,
                        value: 4.65
                    },
                    {
                        height: 206,
                        value: 5.08
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 1.52
                    },
                    {
                        height: 130,
                        value: 1.75
                    },
                    {
                        height: 137,
                        value: 1.97
                    },
                    {
                        height: 145,
                        value: 2.23
                    },
                    {
                        height: 152,
                        value: 2.48
                    },
                    {
                        height: 160,
                        value: 2.78
                    },
                    {
                        height: 168,
                        value: 3.1
                    },
                    {
                        height: 175,
                        value: 3.39
                    },
                    {
                        height: 183,
                        value: 3.74
                    },
                    {
                        height: 191,
                        value: 4.12
                    },
                    {
                        height: 198,
                        value: 4.46
                    },
                    {
                        height: 206,
                        value: 4.87
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.67
                    },
                    {
                        height: 137,
                        value: 1.87
                    },
                    {
                        height: 145,
                        value: 2.13
                    },
                    {
                        height: 152,
                        value: 2.36
                    },
                    {
                        height: 160,
                        value: 2.65
                    },
                    {
                        height: 168,
                        value: 2.95
                    },
                    {
                        height: 175,
                        value: 3.23
                    },
                    {
                        height: 183,
                        value: 3.56
                    },
                    {
                        height: 191,
                        value: 3.92
                    },
                    {
                        height: 198,
                        value: 4.25
                    },
                    {
                        height: 206,
                        value: 4.64
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 1.37
                    },
                    {
                        height: 130,
                        value: 1.58
                    },
                    {
                        height: 137,
                        value: 1.78
                    },
                    {
                        height: 145,
                        value: 2.01
                    },
                    {
                        height: 152,
                        value: 2.24
                    },
                    {
                        height: 160,
                        value: 2.51
                    },
                    {
                        height: 168,
                        value: 2.79
                    },
                    {
                        height: 175,
                        value: 3.06
                    },
                    {
                        height: 183,
                        value: 3.38
                    },
                    {
                        height: 191,
                        value: 3.71
                    },
                    {
                        height: 198,
                        value: 4.02
                    },
                    {
                        height: 206,
                        value: 4.39
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 1.3
                    },
                    {
                        height: 130,
                        value: 1.5
                    },
                    {
                        height: 137,
                        value: 1.68
                    },
                    {
                        height: 145,
                        value: 1.91
                    },
                    {
                        height: 152,
                        value: 2.12
                    },
                    {
                        height: 160,
                        value: 2.37
                    },
                    {
                        height: 168,
                        value: 2.64
                    },
                    {
                        height: 175,
                        value: 2.89
                    },
                    {
                        height: 183,
                        value: 3.19
                    },
                    {
                        height: 191,
                        value: 3.51
                    },
                    {
                        height: 198,
                        value: 3.8
                    },
                    {
                        height: 206,
                        value: 4.15
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 1.23
                    },
                    {
                        height: 130,
                        value: 1.41
                    },
                    {
                        height: 137,
                        value: 1.59
                    },
                    {
                        height: 145,
                        value: 1.8
                    },
                    {
                        height: 152,
                        value: 2
                    },
                    {
                        height: 160,
                        value: 2.24
                    },
                    {
                        height: 168,
                        value: 2.5
                    },
                    {
                        height: 175,
                        value: 2.73
                    },
                    {
                        height: 183,
                        value: 3.02
                    },
                    {
                        height: 191,
                        value: 3.32
                    },
                    {
                        height: 198,
                        value: 3.6
                    },
                    {
                        height: 206,
                        value: 3.93
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 1.16
                    },
                    {
                        height: 130,
                        value: 1.34
                    },
                    {
                        height: 137,
                        value: 1.5
                    },
                    {
                        height: 145,
                        value: 1.71
                    },
                    {
                        height: 152,
                        value: 1.89
                    },
                    {
                        height: 160,
                        value: 2.12
                    },
                    {
                        height: 168,
                        value: 2.36
                    },
                    {
                        height: 175,
                        value: 2.59
                    },
                    {
                        height: 183,
                        value: 2.86
                    },
                    {
                        height: 191,
                        value: 3.14
                    },
                    {
                        height: 198,
                        value: 3.41
                    },
                    {
                        height: 206,
                        value: 3.72
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 1.1
                    },
                    {
                        height: 130,
                        value: 1.27
                    },
                    {
                        height: 137,
                        value: 1.43
                    },
                    {
                        height: 145,
                        value: 1.62
                    },
                    {
                        height: 152,
                        value: 1.8
                    },
                    {
                        height: 160,
                        value: 2.01
                    },
                    {
                        height: 168,
                        value: 2.25
                    },
                    {
                        height: 175,
                        value: 2.46
                    },
                    {
                        height: 183,
                        value: 2.71
                    },
                    {
                        height: 191,
                        value: 2.99
                    },
                    {
                        height: 198,
                        value: 3.23
                    },
                    {
                        height: 206,
                        value: 3.53
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 1.05
                    },
                    {
                        height: 130,
                        value: 1.21
                    },
                    {
                        height: 137,
                        value: 1.36
                    },
                    {
                        height: 145,
                        value: 1.54
                    },
                    {
                        height: 152,
                        value: 1.71
                    },
                    {
                        height: 160,
                        value: 1.92
                    },
                    {
                        height: 168,
                        value: 2.14
                    },
                    {
                        height: 175,
                        value: 2.34
                    },
                    {
                        height: 183,
                        value: 2.59
                    },
                    {
                        height: 191,
                        value: 2.84
                    },
                    {
                        height: 198,
                        value: 3.08
                    },
                    {
                        height: 206,
                        value: 3.36
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 1
                    },
                    {
                        height: 130,
                        value: 1.16
                    },
                    {
                        height: 137,
                        value: 1.3
                    },
                    {
                        height: 145,
                        value: 1.47
                    },
                    {
                        height: 152,
                        value: 1.64
                    },
                    {
                        height: 160,
                        value: 1.83
                    },
                    {
                        height: 168,
                        value: 2.04
                    },
                    {
                        height: 175,
                        value: 2.24
                    },
                    {
                        height: 183,
                        value: 2.47
                    },
                    {
                        height: 191,
                        value: 2.71
                    },
                    {
                        height: 198,
                        value: 2.94
                    },
                    {
                        height: 206,
                        value: 3.21
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.85
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.85
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.84
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.9
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.85
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.89
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.88
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.83
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.87
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.86
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.82
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 122,
                        value: 0.88
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.85
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.84
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.86
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.74
                    },
                    {
                        height: 198,
                        value: 0.74
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.76
                    },
                    {
                        height: 168,
                        value: 0.75
                    },
                    {
                        height: 175,
                        value: 0.75
                    },
                    {
                        height: 183,
                        value: 0.74
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.73
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 122,
                        value: 0.78
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.77
                    },
                    {
                        height: 145,
                        value: 0.76
                    },
                    {
                        height: 152,
                        value: 0.76
                    },
                    {
                        height: 160,
                        value: 0.75
                    },
                    {
                        height: 168,
                        value: 0.74
                    },
                    {
                        height: 175,
                        value: 0.74
                    },
                    {
                        height: 183,
                        value: 0.73
                    },
                    {
                        height: 191,
                        value: 0.73
                    },
                    {
                        height: 198,
                        value: 0.73
                    },
                    {
                        height: 206,
                        value: 0.72
                    }
                ]
            }
        ]
    },
    {
        ethnicity: "Other",
        gender: "Female",
        fvc: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.15
                    },
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.75
                    },
                    {
                        height: 145,
                        value: 1.99
                    },
                    {
                        height: 152,
                        value: 2.21
                    },
                    {
                        height: 160,
                        value: 2.49
                    },
                    {
                        height: 168,
                        value: 2.78
                    },
                    {
                        height: 175,
                        value: 3.04
                    },
                    {
                        height: 183,
                        value: 3.37
                    },
                    {
                        height: 191,
                        value: 3.71
                    },
                    {
                        height: 198,
                        value: 4.03
                    },
                    {
                        height: 206,
                        value: 4.4
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.27
                    },
                    {
                        height: 122,
                        value: 1.48
                    },
                    {
                        height: 130,
                        value: 1.71
                    },
                    {
                        height: 137,
                        value: 1.93
                    },
                    {
                        height: 145,
                        value: 2.19
                    },
                    {
                        height: 152,
                        value: 2.44
                    },
                    {
                        height: 160,
                        value: 2.74
                    },
                    {
                        height: 168,
                        value: 3.06
                    },
                    {
                        height: 175,
                        value: 3.36
                    },
                    {
                        height: 183,
                        value: 3.71
                    },
                    {
                        height: 191,
                        value: 4.09
                    },
                    {
                        height: 198,
                        value: 4.44
                    },
                    {
                        height: 206,
                        value: 4.86
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.48
                    },
                    {
                        height: 122,
                        value: 1.73
                    },
                    {
                        height: 130,
                        value: 2
                    },
                    {
                        height: 137,
                        value: 2.25
                    },
                    {
                        height: 145,
                        value: 2.56
                    },
                    {
                        height: 152,
                        value: 2.84
                    },
                    {
                        height: 160,
                        value: 3.19
                    },
                    {
                        height: 168,
                        value: 3.57
                    },
                    {
                        height: 175,
                        value: 3.91
                    },
                    {
                        height: 183,
                        value: 4.33
                    },
                    {
                        height: 191,
                        value: 4.77
                    },
                    {
                        height: 198,
                        value: 5.17
                    },
                    {
                        height: 206,
                        value: 5.66
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.56
                    },
                    {
                        height: 122,
                        value: 1.82
                    },
                    {
                        height: 130,
                        value: 2.1
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.69
                    },
                    {
                        height: 152,
                        value: 3
                    },
                    {
                        height: 160,
                        value: 3.37
                    },
                    {
                        height: 168,
                        value: 3.76
                    },
                    {
                        height: 175,
                        value: 4.12
                    },
                    {
                        height: 183,
                        value: 4.56
                    },
                    {
                        height: 191,
                        value: 5.03
                    },
                    {
                        height: 198,
                        value: 5.45
                    },
                    {
                        height: 206,
                        value: 5.97
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.57
                    },
                    {
                        height: 122,
                        value: 1.83
                    },
                    {
                        height: 130,
                        value: 2.12
                    },
                    {
                        height: 137,
                        value: 2.38
                    },
                    {
                        height: 145,
                        value: 2.71
                    },
                    {
                        height: 152,
                        value: 3.01
                    },
                    {
                        height: 160,
                        value: 3.38
                    },
                    {
                        height: 168,
                        value: 3.78
                    },
                    {
                        height: 175,
                        value: 4.15
                    },
                    {
                        height: 183,
                        value: 4.59
                    },
                    {
                        height: 191,
                        value: 5.05
                    },
                    {
                        height: 198,
                        value: 5.48
                    },
                    {
                        height: 206,
                        value: 6
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.57
                    },
                    {
                        height: 122,
                        value: 1.83
                    },
                    {
                        height: 130,
                        value: 2.11
                    },
                    {
                        height: 137,
                        value: 2.37
                    },
                    {
                        height: 145,
                        value: 2.7
                    },
                    {
                        height: 152,
                        value: 3
                    },
                    {
                        height: 160,
                        value: 3.37
                    },
                    {
                        height: 168,
                        value: 3.77
                    },
                    {
                        height: 175,
                        value: 4.13
                    },
                    {
                        height: 183,
                        value: 4.57
                    },
                    {
                        height: 191,
                        value: 5.03
                    },
                    {
                        height: 198,
                        value: 5.46
                    },
                    {
                        height: 206,
                        value: 5.97
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.55
                    },
                    {
                        height: 122,
                        value: 1.81
                    },
                    {
                        height: 130,
                        value: 2.09
                    },
                    {
                        height: 137,
                        value: 2.35
                    },
                    {
                        height: 145,
                        value: 2.67
                    },
                    {
                        height: 152,
                        value: 2.97
                    },
                    {
                        height: 160,
                        value: 3.34
                    },
                    {
                        height: 168,
                        value: 3.73
                    },
                    {
                        height: 175,
                        value: 4.09
                    },
                    {
                        height: 183,
                        value: 4.52
                    },
                    {
                        height: 191,
                        value: 4.98
                    },
                    {
                        height: 198,
                        value: 5.4
                    },
                    {
                        height: 206,
                        value: 5.91
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.52
                    },
                    {
                        height: 122,
                        value: 1.77
                    },
                    {
                        height: 130,
                        value: 2.04
                    },
                    {
                        height: 137,
                        value: 2.3
                    },
                    {
                        height: 145,
                        value: 2.62
                    },
                    {
                        height: 152,
                        value: 2.91
                    },
                    {
                        height: 160,
                        value: 3.27
                    },
                    {
                        height: 168,
                        value: 3.65
                    },
                    {
                        height: 175,
                        value: 4
                    },
                    {
                        height: 183,
                        value: 4.43
                    },
                    {
                        height: 191,
                        value: 4.88
                    },
                    {
                        height: 198,
                        value: 5.29
                    },
                    {
                        height: 206,
                        value: 5.79
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.47
                    },
                    {
                        height: 122,
                        value: 1.72
                    },
                    {
                        height: 130,
                        value: 1.98
                    },
                    {
                        height: 137,
                        value: 2.23
                    },
                    {
                        height: 145,
                        value: 2.54
                    },
                    {
                        height: 152,
                        value: 2.83
                    },
                    {
                        height: 160,
                        value: 3.17
                    },
                    {
                        height: 168,
                        value: 3.55
                    },
                    {
                        height: 175,
                        value: 3.89
                    },
                    {
                        height: 183,
                        value: 4.3
                    },
                    {
                        height: 191,
                        value: 4.74
                    },
                    {
                        height: 198,
                        value: 5.14
                    },
                    {
                        height: 206,
                        value: 5.62
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.42
                    },
                    {
                        height: 122,
                        value: 1.66
                    },
                    {
                        height: 130,
                        value: 1.92
                    },
                    {
                        height: 137,
                        value: 2.16
                    },
                    {
                        height: 145,
                        value: 2.45
                    },
                    {
                        height: 152,
                        value: 2.73
                    },
                    {
                        height: 160,
                        value: 3.07
                    },
                    {
                        height: 168,
                        value: 3.42
                    },
                    {
                        height: 175,
                        value: 3.75
                    },
                    {
                        height: 183,
                        value: 4.15
                    },
                    {
                        height: 191,
                        value: 4.58
                    },
                    {
                        height: 198,
                        value: 4.97
                    },
                    {
                        height: 206,
                        value: 5.43
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.37
                    },
                    {
                        height: 122,
                        value: 1.59
                    },
                    {
                        height: 130,
                        value: 1.84
                    },
                    {
                        height: 137,
                        value: 2.07
                    },
                    {
                        height: 145,
                        value: 2.36
                    },
                    {
                        height: 152,
                        value: 2.62
                    },
                    {
                        height: 160,
                        value: 2.94
                    },
                    {
                        height: 168,
                        value: 3.29
                    },
                    {
                        height: 175,
                        value: 3.61
                    },
                    {
                        height: 183,
                        value: 3.99
                    },
                    {
                        height: 191,
                        value: 4.4
                    },
                    {
                        height: 198,
                        value: 4.77
                    },
                    {
                        height: 206,
                        value: 5.22
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.31
                    },
                    {
                        height: 122,
                        value: 1.52
                    },
                    {
                        height: 130,
                        value: 1.76
                    },
                    {
                        height: 137,
                        value: 1.98
                    },
                    {
                        height: 145,
                        value: 2.25
                    },
                    {
                        height: 152,
                        value: 2.5
                    },
                    {
                        height: 160,
                        value: 2.81
                    },
                    {
                        height: 168,
                        value: 3.14
                    },
                    {
                        height: 175,
                        value: 3.44
                    },
                    {
                        height: 183,
                        value: 3.81
                    },
                    {
                        height: 191,
                        value: 4.2
                    },
                    {
                        height: 198,
                        value: 4.55
                    },
                    {
                        height: 206,
                        value: 4.98
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.24
                    },
                    {
                        height: 122,
                        value: 1.45
                    },
                    {
                        height: 130,
                        value: 1.67
                    },
                    {
                        height: 137,
                        value: 1.88
                    },
                    {
                        height: 145,
                        value: 2.14
                    },
                    {
                        height: 152,
                        value: 2.38
                    },
                    {
                        height: 160,
                        value: 2.67
                    },
                    {
                        height: 168,
                        value: 2.98
                    },
                    {
                        height: 175,
                        value: 3.27
                    },
                    {
                        height: 183,
                        value: 3.62
                    },
                    {
                        height: 191,
                        value: 3.99
                    },
                    {
                        height: 198,
                        value: 4.33
                    },
                    {
                        height: 206,
                        value: 4.73
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 1.17
                    },
                    {
                        height: 122,
                        value: 1.37
                    },
                    {
                        height: 130,
                        value: 1.58
                    },
                    {
                        height: 137,
                        value: 1.78
                    },
                    {
                        height: 145,
                        value: 2.02
                    },
                    {
                        height: 152,
                        value: 2.25
                    },
                    {
                        height: 160,
                        value: 2.53
                    },
                    {
                        height: 168,
                        value: 2.82
                    },
                    {
                        height: 175,
                        value: 3.1
                    },
                    {
                        height: 183,
                        value: 3.43
                    },
                    {
                        height: 191,
                        value: 3.78
                    },
                    {
                        height: 198,
                        value: 4.1
                    },
                    {
                        height: 206,
                        value: 4.48
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 1.11
                    },
                    {
                        height: 122,
                        value: 1.29
                    },
                    {
                        height: 130,
                        value: 1.49
                    },
                    {
                        height: 137,
                        value: 1.68
                    },
                    {
                        height: 145,
                        value: 1.91
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.39
                    },
                    {
                        height: 168,
                        value: 2.67
                    },
                    {
                        height: 175,
                        value: 2.93
                    },
                    {
                        height: 183,
                        value: 3.24
                    },
                    {
                        height: 191,
                        value: 3.57
                    },
                    {
                        height: 198,
                        value: 3.87
                    },
                    {
                        height: 206,
                        value: 4.23
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 1.05
                    },
                    {
                        height: 122,
                        value: 1.22
                    },
                    {
                        height: 130,
                        value: 1.41
                    },
                    {
                        height: 137,
                        value: 1.59
                    },
                    {
                        height: 145,
                        value: 1.81
                    },
                    {
                        height: 152,
                        value: 2.01
                    },
                    {
                        height: 160,
                        value: 2.26
                    },
                    {
                        height: 168,
                        value: 2.52
                    },
                    {
                        height: 175,
                        value: 2.76
                    },
                    {
                        height: 183,
                        value: 3.06
                    },
                    {
                        height: 191,
                        value: 3.37
                    },
                    {
                        height: 198,
                        value: 3.66
                    },
                    {
                        height: 206,
                        value: 4
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.99
                    },
                    {
                        height: 122,
                        value: 1.16
                    },
                    {
                        height: 130,
                        value: 1.34
                    },
                    {
                        height: 137,
                        value: 1.5
                    },
                    {
                        height: 145,
                        value: 1.71
                    },
                    {
                        height: 152,
                        value: 1.9
                    },
                    {
                        height: 160,
                        value: 2.14
                    },
                    {
                        height: 168,
                        value: 2.39
                    },
                    {
                        height: 175,
                        value: 2.62
                    },
                    {
                        height: 183,
                        value: 2.9
                    },
                    {
                        height: 191,
                        value: 3.19
                    },
                    {
                        height: 198,
                        value: 3.46
                    },
                    {
                        height: 206,
                        value: 3.79
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 1.1
                    },
                    {
                        height: 130,
                        value: 1.27
                    },
                    {
                        height: 137,
                        value: 1.43
                    },
                    {
                        height: 145,
                        value: 1.62
                    },
                    {
                        height: 152,
                        value: 1.81
                    },
                    {
                        height: 160,
                        value: 2.03
                    },
                    {
                        height: 168,
                        value: 2.27
                    },
                    {
                        height: 175,
                        value: 2.49
                    },
                    {
                        height: 183,
                        value: 2.75
                    },
                    {
                        height: 191,
                        value: 3.03
                    },
                    {
                        height: 198,
                        value: 3.29
                    },
                    {
                        height: 206,
                        value: 3.6
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.9
                    },
                    {
                        height: 122,
                        value: 1.05
                    },
                    {
                        height: 130,
                        value: 1.21
                    },
                    {
                        height: 137,
                        value: 1.36
                    },
                    {
                        height: 145,
                        value: 1.55
                    },
                    {
                        height: 152,
                        value: 1.72
                    },
                    {
                        height: 160,
                        value: 1.93
                    },
                    {
                        height: 168,
                        value: 2.16
                    },
                    {
                        height: 175,
                        value: 2.37
                    },
                    {
                        height: 183,
                        value: 2.62
                    },
                    {
                        height: 191,
                        value: 2.89
                    },
                    {
                        height: 198,
                        value: 3.13
                    },
                    {
                        height: 206,
                        value: 3.42
                    }
                ]
            }
        ],
        fev1: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 1.08
                    },
                    {
                        height: 122,
                        value: 1.25
                    },
                    {
                        height: 130,
                        value: 1.43
                    },
                    {
                        height: 137,
                        value: 1.6
                    },
                    {
                        height: 145,
                        value: 1.8
                    },
                    {
                        height: 152,
                        value: 1.99
                    },
                    {
                        height: 160,
                        value: 2.22
                    },
                    {
                        height: 168,
                        value: 2.46
                    },
                    {
                        height: 175,
                        value: 2.68
                    },
                    {
                        height: 183,
                        value: 2.95
                    },
                    {
                        height: 191,
                        value: 3.23
                    },
                    {
                        height: 198,
                        value: 3.49
                    },
                    {
                        height: 206,
                        value: 3.79
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 1.17
                    },
                    {
                        height: 122,
                        value: 1.35
                    },
                    {
                        height: 130,
                        value: 1.55
                    },
                    {
                        height: 137,
                        value: 1.73
                    },
                    {
                        height: 145,
                        value: 1.95
                    },
                    {
                        height: 152,
                        value: 2.15
                    },
                    {
                        height: 160,
                        value: 2.4
                    },
                    {
                        height: 168,
                        value: 2.66
                    },
                    {
                        height: 175,
                        value: 2.9
                    },
                    {
                        height: 183,
                        value: 3.19
                    },
                    {
                        height: 191,
                        value: 3.5
                    },
                    {
                        height: 198,
                        value: 3.77
                    },
                    {
                        height: 206,
                        value: 4.1
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 1.41
                    },
                    {
                        height: 122,
                        value: 1.62
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.08
                    },
                    {
                        height: 145,
                        value: 2.34
                    },
                    {
                        height: 152,
                        value: 2.59
                    },
                    {
                        height: 160,
                        value: 2.89
                    },
                    {
                        height: 168,
                        value: 3.2
                    },
                    {
                        height: 175,
                        value: 3.49
                    },
                    {
                        height: 183,
                        value: 3.84
                    },
                    {
                        height: 191,
                        value: 4.2
                    },
                    {
                        height: 198,
                        value: 4.54
                    },
                    {
                        height: 206,
                        value: 4.93
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 1.46
                    },
                    {
                        height: 122,
                        value: 1.69
                    },
                    {
                        height: 130,
                        value: 1.93
                    },
                    {
                        height: 137,
                        value: 2.16
                    },
                    {
                        height: 145,
                        value: 2.43
                    },
                    {
                        height: 152,
                        value: 2.69
                    },
                    {
                        height: 160,
                        value: 3
                    },
                    {
                        height: 168,
                        value: 3.33
                    },
                    {
                        height: 175,
                        value: 3.63
                    },
                    {
                        height: 183,
                        value: 3.99
                    },
                    {
                        height: 191,
                        value: 4.37
                    },
                    {
                        height: 198,
                        value: 4.71
                    },
                    {
                        height: 206,
                        value: 5.13
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 1.44
                    },
                    {
                        height: 122,
                        value: 1.66
                    },
                    {
                        height: 130,
                        value: 1.9
                    },
                    {
                        height: 137,
                        value: 2.13
                    },
                    {
                        height: 145,
                        value: 2.4
                    },
                    {
                        height: 152,
                        value: 2.65
                    },
                    {
                        height: 160,
                        value: 2.96
                    },
                    {
                        height: 168,
                        value: 3.28
                    },
                    {
                        height: 175,
                        value: 3.57
                    },
                    {
                        height: 183,
                        value: 3.93
                    },
                    {
                        height: 191,
                        value: 4.3
                    },
                    {
                        height: 198,
                        value: 4.65
                    },
                    {
                        height: 206,
                        value: 5.05
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 1.41
                    },
                    {
                        height: 122,
                        value: 1.63
                    },
                    {
                        height: 130,
                        value: 1.86
                    },
                    {
                        height: 137,
                        value: 2.08
                    },
                    {
                        height: 145,
                        value: 2.35
                    },
                    {
                        height: 152,
                        value: 2.6
                    },
                    {
                        height: 160,
                        value: 2.89
                    },
                    {
                        height: 168,
                        value: 3.21
                    },
                    {
                        height: 175,
                        value: 3.5
                    },
                    {
                        height: 183,
                        value: 3.85
                    },
                    {
                        height: 191,
                        value: 4.21
                    },
                    {
                        height: 198,
                        value: 4.55
                    },
                    {
                        height: 206,
                        value: 4.95
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 1.37
                    },
                    {
                        height: 122,
                        value: 1.59
                    },
                    {
                        height: 130,
                        value: 1.81
                    },
                    {
                        height: 137,
                        value: 2.03
                    },
                    {
                        height: 145,
                        value: 2.29
                    },
                    {
                        height: 152,
                        value: 2.53
                    },
                    {
                        height: 160,
                        value: 2.82
                    },
                    {
                        height: 168,
                        value: 3.13
                    },
                    {
                        height: 175,
                        value: 3.41
                    },
                    {
                        height: 183,
                        value: 3.75
                    },
                    {
                        height: 191,
                        value: 4.1
                    },
                    {
                        height: 198,
                        value: 4.43
                    },
                    {
                        height: 206,
                        value: 4.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 1.32
                    },
                    {
                        height: 122,
                        value: 1.53
                    },
                    {
                        height: 130,
                        value: 1.75
                    },
                    {
                        height: 137,
                        value: 1.96
                    },
                    {
                        height: 145,
                        value: 2.21
                    },
                    {
                        height: 152,
                        value: 2.44
                    },
                    {
                        height: 160,
                        value: 2.72
                    },
                    {
                        height: 168,
                        value: 3.01
                    },
                    {
                        height: 175,
                        value: 3.29
                    },
                    {
                        height: 183,
                        value: 3.61
                    },
                    {
                        height: 191,
                        value: 3.96
                    },
                    {
                        height: 198,
                        value: 4.27
                    },
                    {
                        height: 206,
                        value: 4.65
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 1.27
                    },
                    {
                        height: 122,
                        value: 1.47
                    },
                    {
                        height: 130,
                        value: 1.68
                    },
                    {
                        height: 137,
                        value: 1.87
                    },
                    {
                        height: 145,
                        value: 2.11
                    },
                    {
                        height: 152,
                        value: 2.34
                    },
                    {
                        height: 160,
                        value: 2.61
                    },
                    {
                        height: 168,
                        value: 2.89
                    },
                    {
                        height: 175,
                        value: 3.15
                    },
                    {
                        height: 183,
                        value: 3.46
                    },
                    {
                        height: 191,
                        value: 3.79
                    },
                    {
                        height: 198,
                        value: 4.09
                    },
                    {
                        height: 206,
                        value: 4.45
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 1.21
                    },
                    {
                        height: 122,
                        value: 1.4
                    },
                    {
                        height: 130,
                        value: 1.6
                    },
                    {
                        height: 137,
                        value: 1.79
                    },
                    {
                        height: 145,
                        value: 2.02
                    },
                    {
                        height: 152,
                        value: 2.23
                    },
                    {
                        height: 160,
                        value: 2.49
                    },
                    {
                        height: 168,
                        value: 2.76
                    },
                    {
                        height: 175,
                        value: 3.01
                    },
                    {
                        height: 183,
                        value: 3.31
                    },
                    {
                        height: 191,
                        value: 3.63
                    },
                    {
                        height: 198,
                        value: 3.92
                    },
                    {
                        height: 206,
                        value: 4.26
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 1.16
                    },
                    {
                        height: 122,
                        value: 1.34
                    },
                    {
                        height: 130,
                        value: 1.53
                    },
                    {
                        height: 137,
                        value: 1.71
                    },
                    {
                        height: 145,
                        value: 1.93
                    },
                    {
                        height: 152,
                        value: 2.13
                    },
                    {
                        height: 160,
                        value: 2.37
                    },
                    {
                        height: 168,
                        value: 2.63
                    },
                    {
                        height: 175,
                        value: 2.87
                    },
                    {
                        height: 183,
                        value: 3.16
                    },
                    {
                        height: 191,
                        value: 3.46
                    },
                    {
                        height: 198,
                        value: 3.73
                    },
                    {
                        height: 206,
                        value: 4.06
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 1.1
                    },
                    {
                        height: 122,
                        value: 1.27
                    },
                    {
                        height: 130,
                        value: 1.45
                    },
                    {
                        height: 137,
                        value: 1.62
                    },
                    {
                        height: 145,
                        value: 1.83
                    },
                    {
                        height: 152,
                        value: 2.02
                    },
                    {
                        height: 160,
                        value: 2.25
                    },
                    {
                        height: 168,
                        value: 2.5
                    },
                    {
                        height: 175,
                        value: 2.72
                    },
                    {
                        height: 183,
                        value: 2.99
                    },
                    {
                        height: 191,
                        value: 3.28
                    },
                    {
                        height: 198,
                        value: 3.54
                    },
                    {
                        height: 206,
                        value: 3.85
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 1.03
                    },
                    {
                        height: 122,
                        value: 1.19
                    },
                    {
                        height: 130,
                        value: 1.37
                    },
                    {
                        height: 137,
                        value: 1.53
                    },
                    {
                        height: 145,
                        value: 1.72
                    },
                    {
                        height: 152,
                        value: 1.9
                    },
                    {
                        height: 160,
                        value: 2.12
                    },
                    {
                        height: 168,
                        value: 2.35
                    },
                    {
                        height: 175,
                        value: 2.57
                    },
                    {
                        height: 183,
                        value: 2.82
                    },
                    {
                        height: 191,
                        value: 3.09
                    },
                    {
                        height: 198,
                        value: 3.33
                    },
                    {
                        height: 206,
                        value: 3.63
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.97
                    },
                    {
                        height: 122,
                        value: 1.12
                    },
                    {
                        height: 130,
                        value: 1.28
                    },
                    {
                        height: 137,
                        value: 1.43
                    },
                    {
                        height: 145,
                        value: 1.61
                    },
                    {
                        height: 152,
                        value: 1.78
                    },
                    {
                        height: 160,
                        value: 1.99
                    },
                    {
                        height: 168,
                        value: 2.21
                    },
                    {
                        height: 175,
                        value: 2.41
                    },
                    {
                        height: 183,
                        value: 2.65
                    },
                    {
                        height: 191,
                        value: 2.9
                    },
                    {
                        height: 198,
                        value: 3.13
                    },
                    {
                        height: 206,
                        value: 3.4
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 1.05
                    },
                    {
                        height: 130,
                        value: 1.2
                    },
                    {
                        height: 137,
                        value: 1.34
                    },
                    {
                        height: 145,
                        value: 1.51
                    },
                    {
                        height: 152,
                        value: 1.67
                    },
                    {
                        height: 160,
                        value: 1.86
                    },
                    {
                        height: 168,
                        value: 2.06
                    },
                    {
                        height: 175,
                        value: 2.25
                    },
                    {
                        height: 183,
                        value: 2.47
                    },
                    {
                        height: 191,
                        value: 2.71
                    },
                    {
                        height: 198,
                        value: 2.92
                    },
                    {
                        height: 206,
                        value: 3.18
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.98
                    },
                    {
                        height: 130,
                        value: 1.12
                    },
                    {
                        height: 137,
                        value: 1.25
                    },
                    {
                        height: 145,
                        value: 1.41
                    },
                    {
                        height: 152,
                        value: 1.56
                    },
                    {
                        height: 160,
                        value: 1.74
                    },
                    {
                        height: 168,
                        value: 1.93
                    },
                    {
                        height: 175,
                        value: 2.11
                    },
                    {
                        height: 183,
                        value: 2.31
                    },
                    {
                        height: 191,
                        value: 2.53
                    },
                    {
                        height: 198,
                        value: 2.74
                    },
                    {
                        height: 206,
                        value: 2.98
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 1.05
                    },
                    {
                        height: 137,
                        value: 1.17
                    },
                    {
                        height: 145,
                        value: 1.33
                    },
                    {
                        height: 152,
                        value: 1.46
                    },
                    {
                        height: 160,
                        value: 1.63
                    },
                    {
                        height: 168,
                        value: 1.81
                    },
                    {
                        height: 175,
                        value: 1.97
                    },
                    {
                        height: 183,
                        value: 2.17
                    },
                    {
                        height: 191,
                        value: 2.38
                    },
                    {
                        height: 198,
                        value: 2.57
                    },
                    {
                        height: 206,
                        value: 2.79
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.75
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.99
                    },
                    {
                        height: 137,
                        value: 1.11
                    },
                    {
                        height: 145,
                        value: 1.25
                    },
                    {
                        height: 152,
                        value: 1.38
                    },
                    {
                        height: 160,
                        value: 1.54
                    },
                    {
                        height: 168,
                        value: 1.7
                    },
                    {
                        height: 175,
                        value: 1.86
                    },
                    {
                        height: 183,
                        value: 2.04
                    },
                    {
                        height: 191,
                        value: 2.24
                    },
                    {
                        height: 198,
                        value: 2.41
                    },
                    {
                        height: 206,
                        value: 2.63
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.71
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 1.04
                    },
                    {
                        height: 145,
                        value: 1.18
                    },
                    {
                        height: 152,
                        value: 1.3
                    },
                    {
                        height: 160,
                        value: 1.45
                    },
                    {
                        height: 168,
                        value: 1.61
                    },
                    {
                        height: 175,
                        value: 1.75
                    },
                    {
                        height: 183,
                        value: 1.93
                    },
                    {
                        height: 191,
                        value: 2.11
                    },
                    {
                        height: 198,
                        value: 2.28
                    },
                    {
                        height: 206,
                        value: 2.48
                    }
                ]
            }
        ],
        fev1FvcRatio: [
            {
                age: 5,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.92
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.91
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.9
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.89
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 10,
                values: [
                    {
                        height: 114,
                        value: 0.92
                    },
                    {
                        height: 122,
                        value: 0.91
                    },
                    {
                        height: 130,
                        value: 0.91
                    },
                    {
                        height: 137,
                        value: 0.9
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.89
                    },
                    {
                        height: 160,
                        value: 0.89
                    },
                    {
                        height: 168,
                        value: 0.88
                    },
                    {
                        height: 175,
                        value: 0.88
                    },
                    {
                        height: 183,
                        value: 0.87
                    },
                    {
                        height: 191,
                        value: 0.87
                    },
                    {
                        height: 198,
                        value: 0.87
                    },
                    {
                        height: 206,
                        value: 0.86
                    }
                ]
            },
            {
                age: 15,
                values: [
                    {
                        height: 114,
                        value: 0.94
                    },
                    {
                        height: 122,
                        value: 0.93
                    },
                    {
                        height: 130,
                        value: 0.93
                    },
                    {
                        height: 137,
                        value: 0.92
                    },
                    {
                        height: 145,
                        value: 0.92
                    },
                    {
                        height: 152,
                        value: 0.91
                    },
                    {
                        height: 160,
                        value: 0.91
                    },
                    {
                        height: 168,
                        value: 0.9
                    },
                    {
                        height: 175,
                        value: 0.9
                    },
                    {
                        height: 183,
                        value: 0.89
                    },
                    {
                        height: 191,
                        value: 0.89
                    },
                    {
                        height: 198,
                        value: 0.89
                    },
                    {
                        height: 206,
                        value: 0.88
                    }
                ]
            },
            {
                age: 20,
                values: [
                    {
                        height: 114,
                        value: 0.93
                    },
                    {
                        height: 122,
                        value: 0.92
                    },
                    {
                        height: 130,
                        value: 0.92
                    },
                    {
                        height: 137,
                        value: 0.91
                    },
                    {
                        height: 145,
                        value: 0.91
                    },
                    {
                        height: 152,
                        value: 0.9
                    },
                    {
                        height: 160,
                        value: 0.9
                    },
                    {
                        height: 168,
                        value: 0.89
                    },
                    {
                        height: 175,
                        value: 0.89
                    },
                    {
                        height: 183,
                        value: 0.88
                    },
                    {
                        height: 191,
                        value: 0.88
                    },
                    {
                        height: 198,
                        value: 0.88
                    },
                    {
                        height: 206,
                        value: 0.87
                    }
                ]
            },
            {
                age: 25,
                values: [
                    {
                        height: 114,
                        value: 0.91
                    },
                    {
                        height: 122,
                        value: 0.9
                    },
                    {
                        height: 130,
                        value: 0.9
                    },
                    {
                        height: 137,
                        value: 0.89
                    },
                    {
                        height: 145,
                        value: 0.89
                    },
                    {
                        height: 152,
                        value: 0.88
                    },
                    {
                        height: 160,
                        value: 0.88
                    },
                    {
                        height: 168,
                        value: 0.87
                    },
                    {
                        height: 175,
                        value: 0.87
                    },
                    {
                        height: 183,
                        value: 0.86
                    },
                    {
                        height: 191,
                        value: 0.86
                    },
                    {
                        height: 198,
                        value: 0.86
                    },
                    {
                        height: 206,
                        value: 0.85
                    }
                ]
            },
            {
                age: 30,
                values: [
                    {
                        height: 114,
                        value: 0.89
                    },
                    {
                        height: 122,
                        value: 0.89
                    },
                    {
                        height: 130,
                        value: 0.88
                    },
                    {
                        height: 137,
                        value: 0.88
                    },
                    {
                        height: 145,
                        value: 0.87
                    },
                    {
                        height: 152,
                        value: 0.87
                    },
                    {
                        height: 160,
                        value: 0.86
                    },
                    {
                        height: 168,
                        value: 0.86
                    },
                    {
                        height: 175,
                        value: 0.85
                    },
                    {
                        height: 183,
                        value: 0.85
                    },
                    {
                        height: 191,
                        value: 0.84
                    },
                    {
                        height: 198,
                        value: 0.84
                    },
                    {
                        height: 206,
                        value: 0.84
                    }
                ]
            },
            {
                age: 35,
                values: [
                    {
                        height: 114,
                        value: 0.88
                    },
                    {
                        height: 122,
                        value: 0.87
                    },
                    {
                        height: 130,
                        value: 0.87
                    },
                    {
                        height: 137,
                        value: 0.86
                    },
                    {
                        height: 145,
                        value: 0.86
                    },
                    {
                        height: 152,
                        value: 0.85
                    },
                    {
                        height: 160,
                        value: 0.85
                    },
                    {
                        height: 168,
                        value: 0.84
                    },
                    {
                        height: 175,
                        value: 0.84
                    },
                    {
                        height: 183,
                        value: 0.83
                    },
                    {
                        height: 191,
                        value: 0.83
                    },
                    {
                        height: 198,
                        value: 0.83
                    },
                    {
                        height: 206,
                        value: 0.82
                    }
                ]
            },
            {
                age: 40,
                values: [
                    {
                        height: 114,
                        value: 0.86
                    },
                    {
                        height: 122,
                        value: 0.86
                    },
                    {
                        height: 130,
                        value: 0.85
                    },
                    {
                        height: 137,
                        value: 0.85
                    },
                    {
                        height: 145,
                        value: 0.84
                    },
                    {
                        height: 152,
                        value: 0.84
                    },
                    {
                        height: 160,
                        value: 0.83
                    },
                    {
                        height: 168,
                        value: 0.83
                    },
                    {
                        height: 175,
                        value: 0.83
                    },
                    {
                        height: 183,
                        value: 0.82
                    },
                    {
                        height: 191,
                        value: 0.82
                    },
                    {
                        height: 198,
                        value: 0.81
                    },
                    {
                        height: 206,
                        value: 0.81
                    }
                ]
            },
            {
                age: 45,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.85
                    },
                    {
                        height: 130,
                        value: 0.84
                    },
                    {
                        height: 137,
                        value: 0.84
                    },
                    {
                        height: 145,
                        value: 0.83
                    },
                    {
                        height: 152,
                        value: 0.83
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.82
                    },
                    {
                        height: 175,
                        value: 0.82
                    },
                    {
                        height: 183,
                        value: 0.81
                    },
                    {
                        height: 191,
                        value: 0.81
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.8
                    }
                ]
            },
            {
                age: 50,
                values: [
                    {
                        height: 114,
                        value: 0.85
                    },
                    {
                        height: 122,
                        value: 0.84
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.83
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.82
                    },
                    {
                        height: 160,
                        value: 0.82
                    },
                    {
                        height: 168,
                        value: 0.81
                    },
                    {
                        height: 175,
                        value: 0.81
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.8
                    },
                    {
                        height: 198,
                        value: 0.8
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 55,
                values: [
                    {
                        height: 114,
                        value: 0.84
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.83
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.82
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.81
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.8
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.79
                    }
                ]
            },
            {
                age: 60,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.83
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.82
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.81
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.8
                    },
                    {
                        height: 175,
                        value: 0.8
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.79
                    },
                    {
                        height: 198,
                        value: 0.79
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 65,
                values: [
                    {
                        height: 114,
                        value: 0.83
                    },
                    {
                        height: 122,
                        value: 0.82
                    },
                    {
                        height: 130,
                        value: 0.82
                    },
                    {
                        height: 137,
                        value: 0.81
                    },
                    {
                        height: 145,
                        value: 0.81
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.8
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.79
                    },
                    {
                        height: 183,
                        value: 0.79
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.78
                    },
                    {
                        height: 206,
                        value: 0.78
                    }
                ]
            },
            {
                age: 70,
                values: [
                    {
                        height: 114,
                        value: 0.82
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.81
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.8
                    },
                    {
                        height: 152,
                        value: 0.8
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.79
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.78
                    },
                    {
                        height: 191,
                        value: 0.78
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.77
                    }
                ]
            },
            {
                age: 75,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.81
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.8
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.79
                    },
                    {
                        height: 160,
                        value: 0.79
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.78
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.77
                    },
                    {
                        height: 198,
                        value: 0.77
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 80,
                values: [
                    {
                        height: 114,
                        value: 0.81
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.8
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.79
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.78
                    },
                    {
                        height: 168,
                        value: 0.78
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.77
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.76
                    }
                ]
            },
            {
                age: 85,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.8
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.79
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.78
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.77
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.76
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 90,
                values: [
                    {
                        height: 114,
                        value: 0.8
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.79
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.78
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.77
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.76
                    },
                    {
                        height: 191,
                        value: 0.76
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.75
                    }
                ]
            },
            {
                age: 95,
                values: [
                    {
                        height: 114,
                        value: 0.79
                    },
                    {
                        height: 122,
                        value: 0.79
                    },
                    {
                        height: 130,
                        value: 0.78
                    },
                    {
                        height: 137,
                        value: 0.78
                    },
                    {
                        height: 145,
                        value: 0.77
                    },
                    {
                        height: 152,
                        value: 0.77
                    },
                    {
                        height: 160,
                        value: 0.77
                    },
                    {
                        height: 168,
                        value: 0.76
                    },
                    {
                        height: 175,
                        value: 0.76
                    },
                    {
                        height: 183,
                        value: 0.75
                    },
                    {
                        height: 191,
                        value: 0.75
                    },
                    {
                        height: 198,
                        value: 0.75
                    },
                    {
                        height: 206,
                        value: 0.74
                    }
                ]
            }
        ]
    }
];
